/* tslint:disable */

// ====================================================
// START: Typescript template
// ====================================================

// ====================================================
// Scalars
// ====================================================

/** A type representing a formatted java.util.UUID */
export type Uuid = any;

/** A type representing a Locale such as en_US or fr_FR */
export type Locale = any;

/** A type representing a full protocol, host and path */
export type Url = any;

/** Built-in java.math.BigDecimal */
export type BigDecimal = any;

/** Federation scalar type used to represent any external entities passed to _entities query. */
export type _Any = any;

/** Federation type representing set of fields */
export type _FieldSet = any;

// ====================================================
// InputTypes
// ====================================================

/** The input BEX context used for identifying users, sites and other platform functions */
export interface ContextInput {
  /** Information regarding the application which triggered the query */
  clientInfo?: ClientInfoInput | null;
  /** Currency as Alphabetic ISO 4217 code e.g. 'USD'. Use if default currency for Locale needs to be overwritten. */
  currency?: string | null;
  /** Debugging context, such as Abacus overrides */
  debugContext?: DebugContextInput | null;
  /** Client/user Device information */
  device: DeviceInput;
  /** The Expedia Affiliate Partner ID */
  eapid?: number | null;
  /** Client/user information */
  identity: IdentityInput;
  /** The context locale, e.g. en_US */
  locale: Locale;
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: PrivacyTrackingState | null;
  /** The context Site ID, e.g. (70201 for Orbitz) */
  siteId: number;
}
/** Describe which application is invoking bex api */
export interface ClientInfoInput {
  /** Name of the application */
  name: string;
  /** Version of the application eg:18.10 or 5fbc9958 */
  version?: string | null;
}
/** Context used for debugging purposes, such as overriding Abacus experiments */
export interface DebugContextInput {
  /** Abacus exposure overrides to be applied */
  abacusOverrides: ExposureInput[];
  /** ALTER mode */
  alterMode?: AlterMode | null;
}
/** An exposure to an abacus experiment */
export interface ExposureInput {
  /** The experiment bucket of the exposure */
  bucket: number;
  /** The numeric Abacus ID for an experiment */
  id: string;
}
/** Device information */
export interface DeviceInput {
  type: DeviceType;
}
/** Identity information for a specific user or device */
export interface IdentityInput {
  /** The Expedia user authenticated state */
  authState?: AuthenticationState | null;
  /** The device ID (DUAID) */
  duaid: Uuid;
  /** The Expedia User ID */
  expUserId?: string | null;
  /** The user TUID */
  tuid?: string | null;
}

export interface CoordinatesInput {
  /** The latitude of the point in degrees */
  latitude: number;
  /** The longitude of the point in degrees */
  longitude: number;
}
/** Input argument for Request Context */
export interface ClientRequestInput {
  /** Headers of HTTP Request */
  headers: HttpHeaderInput[];
  /** Remote address of HTTP Request */
  remoteAddress: string;
  /** URL of HTTP Request */
  url: string;
}

export interface HttpHeaderInput {
  name: string;

  values: string[];
}
/** All criteria needed for a multi-item search */
export interface MultiItemSearchContextInput {
  cars?: CarSearchCriteriaInput[] | null;

  flights?: FlightSearchCriteriaInput[] | null;

  properties?: PropertySearchCriteriaInput[] | null;
}
/** Car criteria needed to perform a car search */
export interface CarSearchCriteriaInput {
  primary: PrimaryCarCriteriaInput;

  secondary?: ShoppingSearchCriteriaInput | null;
}
/** The core criteria needed for a car search */
export interface PrimaryCarCriteriaInput {
  dropOffDateTime: DateTimeInput;

  dropOffLocation?: CarRentalLocationInput | null;

  pickUpDateTime: DateTimeInput;

  pickUpLocation: CarRentalLocationInput;
}
/** A common date time, if you need to include timezone information, please use ZonedDateTime */
export interface DateTimeInput {
  /** The day of the month of the date */
  day: number;
  /** The hour of the datetime */
  hour: number;
  /** The minute of the hour */
  minute: number;
  /** The numeric month of the date */
  month: number;
  /** The second of the minute */
  second: number;
  /** The four-digit year of the date */
  year: number;
}
/** Provides the car rental location information */
export interface CarRentalLocationInput {
  airportCode?: string | null;

  coordinates?: CoordinatesInput | null;

  regionId?: string | null;

  searchTerm?: string | null;
}
/** Key/Value elements that describes the search criteria often displayed to the customer as filters */
export interface ShoppingSearchCriteriaInput {
  booleans?: BooleanValueInput[] | null;

  counts?: NumberValueInput[] | null;

  dates?: DateValueInput[] | null;

  ranges?: RangeValueInput[] | null;

  selections?: SelectedValueInput[] | null;
}
/** Type used during a product search to specify a given boolean value like the factcustomer would prefer to search for direct flights only. */
export interface BooleanValueInput {
  id: string;

  value: boolean;
}
/** Type used during a product search to specify a given numeric value like the number of stars for a hotel. */
export interface NumberValueInput {
  id: string;

  value: number;
}
/** Type used during a product search to specify a given date. Usually this datewould not be a core search criteria like a departure day for a flight. */
export interface DateValueInput {
  id: string;

  value: DateInput;
}
/** A common date object */
export interface DateInput {
  /** The day of the month, e.g. `1` for the 1st */
  day: number;
  /** The numeric month, e.g. `1` for January */
  month: number;
  /** The four-digit year e.g. `1999` */
  year: number;
}
/** Type used during a product search to specify a given numeric range like theprice of a hotel should be between 100 and 200 (USD). */
export interface RangeValueInput {
  id: string;

  max: number;

  min: number;
}
/** Type used during a product search to specify a given selection like the airline the customer would like to fly with. */
export interface SelectedValueInput {
  id: string;

  value: string;
}
/** All criteria needed to perform a flight search */
export interface FlightSearchCriteriaInput {
  primary: PrimaryFlightCriteriaInput;

  secondary?: ShoppingSearchCriteriaInput | null;
}
/** Represents the core criteria needed for a flight search */
export interface PrimaryFlightCriteriaInput {
  journeyCriterias: FlightsJourneyCriteriaInput[];

  searchPreferences?: FlightsSearchPreferencesInput | null;

  travelers: TravelerDetailsInput[];

  tripType: FlightsTripType;
}
/** The input object for flights search */
export interface FlightsJourneyCriteriaInput {
  /** Departure date of the flight */
  departureDate: DateInput;
  /** Three letter code of the destination airport */
  destination: string;
  /** # Deprecated: Please use cabinClass in FlightsSearchPreferences */
  flightsCabinClass?: FlightsCabinClass | null;
  /** Three letter code of the origin airport */
  origin: string;
}
/** Primary flights criteria part of the search wizard that have an impact on thefirst results set.It's different from the side filter part of the secondarysearch criteria that are filtering on top of it. The side filter should be usinga server driven approach. */
export interface FlightsSearchPreferencesInput {
  /** Advanced filters like non-stop, refundable */
  advancedFilters?: FlightsAdvancedFilterType[] | null;

  airline?: string | null;

  cabinClass: FlightsCabinClass;
}
/** Represents the traveler details */
export interface TravelerDetailsInput {
  age?: number | null;

  type: TravelerDetailsType;
}
/** Property criteria needed to perform a property search */
export interface PropertySearchCriteriaInput {
  primary: PrimaryPropertyCriteriaInput;

  secondary?: ShoppingSearchCriteriaInput | null;
}
/** The core criteria needed for a property search */
export interface PrimaryPropertyCriteriaInput {
  dateRange?: PropertyDateRangeInput | null;

  destination: DestinationInput;

  rooms: RoomInput[];
}

export interface PropertyDateRangeInput {
  checkInDate: DateInput;

  checkOutDate: DateInput;
}
/** Contains detailed geographic information like the Gaia region id as well as theproperty ids in the region for the property destination */
export interface DestinationInput {
  /** The Geo location of the region to search */
  coordinates?: CoordinatesInput | null;
  /** The property ID to use for region resolution (pinned search). */
  pinnedPropertyId?: string | null;
  /** List of property IDs to return search information for. */
  propertyIds?: string[] | null;
  /** The Gaia region ID of the search */
  regionId?: string | null;
  /** The name of the region ID, used for fuzzy resolution */
  regionName?: string | null;
}
/** A single hotel room configuration */
export interface RoomInput {
  /** The number of adult in the room */
  adults: number;
  /** The number of children in the room */
  children?: ChildInput[] | null;
}
/** A guest over the age of 2 */
export interface ChildInput {
  /** The child's age in years */
  age: number;
}
/** All natural keys for the products that the customer has already selected on the shopping path */
export interface MultiItemProductsInput {
  activities: ActivityNaturalKeyInput[];

  cars: CarNaturalKeyInput[];

  flights: FlightNaturalKeyInput[];

  properties: PropertyNaturalKeyInput[];
}
/** Minimum set of data used to retrieve details about an activity product */
export interface ActivityNaturalKeyInput {
  offerToken: string;

  productToken: string;
}
/** Minimum set of data used to retrieve details about a car product */
export interface CarNaturalKeyInput {
  offerToken: string;

  specialEquipments?: SpecialEquipment[] | null;
}
/** Minimum set of data used to retrieve details about a flight product */
export interface FlightNaturalKeyInput {
  offerToken: string;

  productTokens: string[];

  travelers: TravelerDetailsInput[];
}
/** Minimum set of data used to retrieve details about a property product */
export interface PropertyNaturalKeyInput {
  checkIn: DateInput;

  checkOut: DateInput;

  id: string;

  inventoryType: InventoryType;

  noCreditCard?: boolean | null;

  ratePlanId: string;

  ratePlanType?: string | null;

  roomTypeId: string;

  rooms: PropertyRoomInput[];

  shoppingPath?: ShoppingPathType | null;
}
/** Indicates how many rooms will be occupied and by whom */
export interface PropertyRoomInput {
  childAges: number[];

  numberOfAdults: number;
}
/** Dimensions for a presention object i.e. image or icon */
export interface DimensionsInput {
  density: number;

  height: number;

  width: number;
}
/** Represent the current location of the User so we can propose an origin for the flights */
export interface CrossSellUserLocationInput {
  /** The city of User's current location. ex: SANJOSE */
  city: string;
  /** The continent code of User's current location. ex: NA */
  continent: string;
  /** The country code of User's current location. ex: US */
  country: string;
  /** The region or state code of User's current location. ex: CA */
  region: string;
}

export interface MultiItemPropertyPrimerInput {
  naturalKey: PropertyNaturalKeyInput;
}
/** Pricing information */
export interface MoneyInput {
  /** Numeric portion of the price */
  amount: number;
  /** The ISO 4217 3-letter code for this currency eg: USD EUR GBP ... */
  currency?: string | null;
}
/** The `TripItemInput` contains a tripViewId and tripItemId known by the Trip Domain. */
export interface TripItemInput {
  tripItemId: string;

  tripViewId: string;
}
/** The `TripOverviewInput` complex type contains a `tripViewId` known by the Trip Domain.This identifier is opaque to the client, it may be an EG Trip Identifier or an identifier used for Trip Sharing.The server will determine how much of the trip and which actions to return basedon the sharing rules associated with the TripViewId. */
export interface TripOverviewInput {
  tripViewId: string;
}
/** The `TripsFilterInput` contains a filter identifier.The set of supported filter identifiers is defined by the Trips Graph Serviceand may represent a simple filter like Upcoming or Past or an arbitrarilycomplex filter defined by an ML algorithm.See the Trips Graph team for a list of reserved values. */
export interface TripsFilterInput {
  filter: string;
}

export interface GroundTransfersSearchCriteriaInput {
  primary: PrimaryGroundTransfersCriteriaInput;

  secondary?: ShoppingSearchCriteriaInput | null;
}
/** The core criteria needed for a ground transfers or air transportation search */
export interface PrimaryGroundTransfersCriteriaInput {
  dateRange: OptionalDateTimeRangeInput;

  direction: GroundTransfersDirection;

  locations: GroundTransfersLocationInput[];

  travelerDetails: GroundTransfersTravelerDetailsInput[];
}
/** A range of dates & times, without timezone support, from a starting date & time to an ending date & time */
export interface OptionalDateTimeRangeInput {
  /** Optional terminal date & time in this range */
  end?: DateTimeInput | null;
  /** Optional starting date & time in this range */
  start?: DateTimeInput | null;
}
/** Provides the ground transfers location information for destination, airport and hotel */
export interface GroundTransfersLocationInput {
  coordinates?: CoordinatesInput | null;

  id?: string | null;

  name?: string | null;

  type: GeoType;
}
/** Represents the traveler details */
export interface GroundTransfersTravelerDetailsInput {
  count: number;

  type: GroundTransfersTravelerDetailsType;
}

export interface ActivityDateRangeInput {
  endDate: DateInput;

  startDate: DateInput;
}
/** Activity search region information */
export interface ActivityDestinationInput {
  /** Coordinates of the region, used for region (city or multicity) resolution */
  coordinates?: CoordinatesInput | null;
  /** activity id proposed for pinning on LX-SRP */
  pinnedActivityId?: string | null;
  /** activity id passed as a reference for activity recommendations on LX-IS */
  referencedActivityId?: string | null;
  /** Gaia region ID of the search */
  regionId?: string | null;
  /** Name of the region, used for fuzzy resolution */
  regionName?: string | null;
  /** Gaia Region Type denoted by regionId, example HOTEL OR CITY */
  regionType?: string | null;
}
/** Activity marketing information to identify sem/seo traffic */
export interface ActivityMarketingInfoInput {
  /** Marketing channel type code. */
  mctc?: number | null;
  /** field which identifies sem channel */
  sem?: string | null;
  /** field which identifies semdtl value */
  semdtl?: string | null;
}

export interface ActivityOfferFilterInput {
  selections?: ActivitySelectedValueInput[] | null;

  tickets?: ActivityTicketInput[] | null;
}

export interface ActivitySelectedValueInput {
  id: string;

  value: string;
}

export interface ActivityTicketInput {
  code: string;

  count: number;
}
/** Separate a large list of results into multiple sublists */
export interface PaginationInput {
  /** Number of results to get past the starting index */
  size?: number | null;
  /** The inclusive 0-based starting index of the results. Defaults to 0 */
  startingIndex?: number | null;
}
/** Activity search filtering options */
export interface ActivitySearchFiltersInput {
  /** Filter results by user selected activity id from ESS activity Typeahead Suggestions. */
  activityId?: string | null;
  /** Filter results by activity category, supported with legacy categories */
  categories?: ActivityCategory[] | null;
  /** Filter results by activity category keys, supported with nested categories */
  categoryKeys?: string[] | null;
  /** Filter results by user provided free text search keyword */
  keyword?: string | null;
  /** Filter results by user regionId to support neighborhood filters */
  regionId?: string | null;

  selections?: ActivitySelectedValueInput[] | null;
}
/** Activity search region information */
export interface ActivityRegionInput {
  /** Full name of the region, used for exact resolution */
  fullRegionName?: string | null;
  /** Gaia region ID of the search */
  regionId: string;
  /** Name of the region, used for fuzzy resolution */
  regionName?: string | null;
}
/** Optional information to get a better contextual customer notification */
export interface CustomerNotificationOptionalContextInput {
  /** itinerary number */
  itineraryNumber?: string | null;
  /** list of journey criteria items */
  journeyCriterias?: CustomerNotificationOptionalContextJourneyCriteriaInput[] | null;
  /** regionId number */
  regionId?: string | null;
  /** list of GAIA regionIds */
  regionIds?: string[] | null;
  /** trip folder id */
  tripFolderId?: string | null;
}
/** Journey criteria such as location gaia id and travel date ranges */
export interface CustomerNotificationOptionalContextJourneyCriteriaInput {
  /** start date and end date of the trip */
  dateRange?: DateRangeInput | null;
  /** destination information */
  destination?: CustomerNotificationOptionalContextJourneyCriteriaLocationInput | null;
  /** origin information */
  origin?: CustomerNotificationOptionalContextJourneyCriteriaLocationInput | null;
}
/** A range of dates, from a starting date to an ending date */
export interface DateRangeInput {
  /** The terminal date in this range */
  end: DateInput;
  /** The starting date in this range */
  start: DateInput;
}
/** Journey criteria such as location gaia id and travel date ranges */
export interface CustomerNotificationOptionalContextJourneyCriteriaLocationInput {
  /** property id */
  propertyId?: string | null;
  /** regionId number */
  regionId?: string | null;
}
/** Filter criteria details for the searchHistory query. */
export interface SearchHistoryFilterCriteriaInput {
  /** Search item end date in yyyy-MM-dd format. */
  endDate: string;
  /** Search item regionId. */
  regionId: string;
  /** Search item region type. */
  regionType?: string | null;
  /** Search item start date in yyyy-MM-dd format. */
  startDate: string;
}
/** Criteria based on search history groups are created. */
export interface SearchHistoryGroupingCriteriaInput {
  /** Search history grouping based on specified day range. */
  dayRange?: SearchHistoryDayRange | null;
  /** Search history grouping based on specified destination type. */
  destinationType?: SearchHistoryDestinationType | null;
}
/** Represents criteria for flights information page. */
export interface FlightsDetailCriteriaInput {
  /** Represent the continuation identifier for spinner to deduce all journeys selected by the user. */
  journeyContinuationId: string;
}
/** Context for flights search */
export interface FlightsSearchContextInput {
  /** Represent the continuation identifier for spinner to deduce which all journeyshave been selected. Null value represents the request is for first journey. */
  journeysContinuationId?: string | null;
  /** Represents the flights user selected for each segment when the user proceededto FIS.This node will be populated on the search response only if customer isreturning to FSR from FIS. */
  previousFlightSelections?: JourneyFlightSelectionInput[] | null;
  /** Trip type in search */
  tripType: FlightsTripType;
}
/** Represents a pair of segment order as index and the flight identifier as value */
export interface JourneyFlightSelectionInput {
  /** Represents the segment index. */
  journeyIndex: number;
  /** Represents the flight combination the customer previously selected for theindexed segment. This will be used to highlight the previously selected offerfor pinned listing. */
  offerIdentifier: string;
}
/** Represents an element of the list which the client needs to send back to theserver as part of the request. This will be part of each FilterItem so clientneed not apply any logic on filter selection but simply add this to the next request */
export interface FlightsSearchFilterValuesInput {
  /** Represents the value associated with arrival airport filter. */
  arrivalAirportCodeFilterValue?: FlightsAirportCodeFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Arrival Time filter. */
  arrivalTimeFilterValue?: FlightsTimeBasedFilterValueInput | null;
  /** Represents the value associated with departure airport filter. */
  departureAirportCodeFilterValue?: FlightsAirportCodeFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Departure Time filter. */
  departureTimeFilterValue?: FlightsTimeBasedFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Duration filter. */
  durationFilterValue?: FlightsDurationBasedFilterValueInput | null;
  /** Represents the value associated with flexible change policies filter. */
  flexibleChangePolicyBasedFilterValue?: FlightsFlexibleChangePolicyBasedFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Number of stops filter. */
  numOfStopFilterValue?: FlightsStopBasedFilterValueInput | null;
  /** Represents the FilterValue object corresponding to the Preferred Airline filter. */
  preferredAirlineFilterValue?: FlightsPreferredAirlineFilterValueInput | null;
}
/** Represents the value associated with airport filter */
export interface FlightsAirportCodeFilterValueInput {
  airportCode: string;
}
/** Represents the value associated with any time based filter, like DepartureTime or ArrivalTime based filter */
export interface FlightsTimeBasedFilterValueInput {
  timeOfDay: FlightsTimeOfDay;
}
/** Represents the value associated with duration based filter */
export interface FlightsDurationBasedFilterValueInput {
  maxDuration: number;
}
/** Represents the value associated with flexible change policies filter */
export interface FlightsFlexibleChangePolicyBasedFilterValueInput {
  policyName: FilterPolicyType;
}
/** Represents the value associated with number of stops based filter */
export interface FlightsStopBasedFilterValueInput {
  stopInfo: FlightsStopInfoInput;
}
/** Represents the stop related info for each number of stops based filter value.Combination of the number of stops and an operation.Ex. 2+ would be representedby {2,MORE_THAN} , 2 by {2,EQUAL} and <2 by {2,LESS_THAN} */
export interface FlightsStopInfoInput {
  numberOfStops: number;

  stopFilterOperation: FlightsStopFilterOperation;
}
/** Represents the value associated with preferred airline filter */
export interface FlightsPreferredAirlineFilterValueInput {
  carrierCode: string;
}
/** Represents the combination of SortType and SortOrder ex. Price Increasing */
export interface FlightsSortOptionTypeInput {
  sortOrder: FlightsSortOrder;

  sortType: FlightsSortType;
}
/** Traveler details for flights search */
export interface FlightsTravelerDetailsInput {
  /** Age for each traveler */
  ages?: number[] | null;
  /** Traveler count */
  count: number;
  /** Traveler type */
  travelerType: FlightsTravelerType;
}

export interface CarDetailContextInput {
  carOfferToken: string;
  /** Encoded string having certain offer information shown on search page. Eg. priceShown, avg category price */
  continuationContextualId?: string | null;

  rewardPointsSelection?: RewardsPointSelectionEnum | null;

  selectedAccessories?: string[] | null;
}

export interface InsuranceShoppingRequestInput {
  /** Country code of user's residency - to be passed if akamai headers not present */
  countryCode?: string | null;
  /** Region code of user's residency - to be passed if akamai headers not present */
  regionCode?: string | null;
  /** TripId */
  tripId: Uuid;
}

export interface PoiMapCoordinateInput {
  /** If present pins will be filtered out based on these categories */
  categories?: PoiMapItemCategory[] | null;
  /** Center coordinates to generate the map around it */
  centerCoordinates: CoordinatesInput;
  /** If present we will try to search POI based on end date */
  endDate?: DateInput | null;
  /** If present we will try to search POI based on start date */
  startDate?: DateInput | null;
  /** User pins with correct styling will be given back. Also the distance will be based on the first coordinate in the list */
  userCoordinates?: UserCoordinatesInput[] | null;
  /** If present this radius will be used to filter out pins */
  zoomRadius?: DistanceInput | null;
}

export interface UserCoordinatesInput {
  coordinates: CoordinatesInput;

  type: UserCoordinateType;
}
/** Measurable distance with units */
export interface DistanceInput {
  unit: DistanceUnit;

  value: number;
}
/** A location can be represented by a region id or an airport code. */
export interface InsightsLocationInput {
  /** Three letter IATA code associated with am airport near the location */
  airportCode?: string | null;
  /** Gaia region id of the location */
  regionId?: string | null;
}

export interface ShortlistDestinationFilterInput {
  /** Region type that will ultimately determined filtered results. Default is MULTI_CITY_VICINITY */
  destinationType: RegionType;
  /** Gaia region ID for which we want to filter shortlisted results. Does not haveto match region type, but will be used to find the relevant destination typebased on region type provided */
  regionId: string;
}
/** Property search filtering options */
export interface PropertySearchFiltersInput {
  /** Filter results by available accessibility amenities. Example: [ROLL_IN_SHOWER]will return properties with a roll in shower */
  accessibility?: PropertyFilterAccessibility[] | null;
  /** Filter results by TAAP Agency business model. */
  agencyBusinessModels?: AgencyBusinessModel[] | null;
  /** Filter results by available amenities. Example: [POOL,WIFI] will return properties with a pool and wifi */
  amenities?: PropertyFilterAmenity[] | null;
  /** Filter results by the bedroom count. Only includes Vacation Rentals */
  bedroomFilter?: number[] | null;
  /** Filter results by chain id. Input supports a valid chain id */
  chain?: string | null;
  /** Filter results by property cleanliness attribute */
  cleaningAndSafetyPractices?: CleaningAndSafetyPractice[] | null;
  /** Filter results by TAAP commission tier. */
  commissionTiers?: CommissionTier[] | null;
  /** Filter results by Deals */
  deals?: DealType[] | null;
  /** Filter results by available meal plan. Example: FULL_BOARD will return properties with a full board */
  mealPlan?: MealPlanFilterAmenity[] | null;
  /** Filter results by neighborhood. Input supports a valid GAIA ID */
  neighborhood?: string | null;
  /** Filter results by the payment type. */
  paymentType?: PaymentType[] | null;
  /** Filter results by popular location. Input supports a valid coordinates combination string */
  poi?: string | null;
  /** Filter results by price. Can provide a min only, a max only, or a range. */
  price?: PriceRangeInput | null;
  /** PWA ONLY: Support for legacy PWA price buckets in the url. Use 'price' instead */
  priceBuckets?: number[] | null;
  /** Filter results by user provided string */
  propertyName?: string | null;
  /** Property syle filters */
  propertyStyles?: PropertyStyle[] | null;
  /** Filter results by average guest rating. Can provide a min only, a max only, or a range. */
  reviewScore?: ReviewScoreRangeInput | null;
  /** Rewards Type filters */
  rewards?: string[] | null;
  /** Filter results by availability */
  showAvailableOnly?: boolean | null;
  /** Filter results by property star rating. Example: 30, 50 returns properties rated 3 to 3.9 and 5 to 5.9 */
  starList?: number[] | null;
  /** Filter results by property star rating. Example: THREE returns properties rated 3.0+ */
  stars?: StarRangeInput | null;
  /** Filter results by structure type. Example: HOTEL returns properties of structure type 'HOTEL' */
  structureTypes?: StructureType[] | null;
  /** An SEM theme that needs to be passed through to other services */
  theme?: string | null;
  /** Filter results by the type of traveler. */
  travelerType?: TravelerType[] | null;
  /** Filter results by VIP only properties */
  vipOnly?: boolean | null;
}
/** Represents a range of prices for filtering properties. Follows currency rules of the user's point of sale */
export interface PriceRangeInput {
  /** The maximum price, e.g. 500.00 */
  max?: number | null;
  /** The minimum price, e.g. 50.00 */
  min?: number | null;
}
/** Represents a range of review scores for filtering properties */
export interface ReviewScoreRangeInput {
  /** The maximum review score, e.g. 5.0 */
  max?: number | null;
  /** The minimum review score, e.g. 1.0 */
  min?: number | null;
}

export interface StarRangeInput {
  max?: number | null;

  min?: number | null;
}
/** Container of all the marketing data */
export interface PropertyMarketingInfoInput {
  /** Meta affcid channel code */
  affcid?: string | null;
  /** Meta afflid channel code */
  afflid?: string | null;
  /** Meta afmcid channel code */
  afmcid?: string | null;
  /** Meta brandcid channel code */
  brandcid?: string | null;
  /** Meta emlcid channel code */
  emlcid?: string | null;
  /** Meta emldtl channel code */
  emldtl?: string | null;
  /** Meta gclid channel code */
  gclid?: string | null;
  /** Meta icmcid channel code */
  icmcid?: string | null;
  /** Meta icmdtl channel code */
  icmdtl?: string | null;
  /** Meta k_user_id channel code */
  k_user_id?: string | null;
  /** Meta kword channel code */
  kword?: string | null;
  /** Meta lnkloc channel code */
  lnkloc?: string | null;
  /** A consolidated list of marketing channels in key/value pairs.Example: [{"key": "mctc", "value": "2"}, {"key": "icmdtl", "value": "some values"}] */
  marketingChannels?: PropertyMarketingTagInput[] | null;
  /** A consolidated list of marketing prices in key/value pairs.Example: [{"key": "exp_dp", "value": "100"}, {"key": "exp_tx", "value": "10"}] */
  marketingPrices?: PropertyMarketingTagInput[] | null;
  /** Marketing Channel Type Code: Indicates traffic type, i.e. 5 for Trivago */
  mctc?: number | null;
  /** Meta mdpcid channel code */
  mdpcid?: string | null;
  /** Meta mdpdtl channel code */
  mdpdtl?: string | null;
  /** Meta olacid channel code */
  olacid?: string | null;
  /** Meta oladtl channel code */
  oladtl?: string | null;
  /** Meta semcid channel code */
  semcid?: string | null;
  /** Meta semdtl channel code */
  semdtl?: string | null;
  /** Meta seocid channel code */
  seocid?: string | null;
}
/** An object with simple key/value combination for a marketing channel or price.Example: {"key": "mctc", "value": "3"} */
export interface PropertyMarketingTagInput {
  key: string;

  value: string;
}
/** The shopping context used for all search paths, contains the search contexts for the different shopping paths */
export interface ShoppingContextInput {
  multiItem?: MultiItemContextInput | null;
}
/** The multi-item context used for package searches, contains information neededfor package searches and retrieving package sessions */
export interface MultiItemContextInput {
  /** The multi-item session id used to retrieve the customers package search criteria and selected products */
  id: string;
  /** The package type for this search */
  packageType: PackageType;
}
/** The offer details from the search results page */
export interface SearchOfferInput {
  /** The price of the search results offer */
  offerPrice?: SearchOfferPriceInput | null;

  ratePlanId?: string | null;

  roomTypeId?: string | null;
}
/** The offer price from the search results page */
export interface SearchOfferPriceInput {
  /** The encoded multi-item price token */
  multiItemPriceToken?: string | null;
  /** The total price of the search offer */
  price?: MoneyInput | null;
}
/** Data used for travelAd click tracking */
export interface PropertyTravelAdTrackingInfoInput {
  beaconIssued?: string | null;

  candidateHmGuid?: string | null;

  position?: string | null;

  rank?: string | null;

  slots?: string | null;

  testVersionOverride?: string | null;

  trackingData: string;
}
/** [Optional] Review results filters */
export interface PropertyReviewFiltersInput {
  /** Filter review results by category */
  category?: PropertyReviewCategory | null;
  /** Include or disclude reviews that only have ratings */
  includeRatingsOnlyReviews?: boolean | null;
  /** Get reviews immediately when true (without 90 days syndication) */
  includeRecentReviews?: boolean | null;
  /** Filter reviews by specified languages by receiving lang code e.g. 'en' */
  language?: string | null;
  /** Filter review results by reviewers' locale. Example: ko_KR returns reviews made by users on Korea POSa */
  locale?: Locale | null;
  /** Filter review results by a list of review ratings */
  ratings?: number[] | null;
  /** Filter review results by review type: POSITIVE or CRITICAL */
  reviewType?: PropertyReviewType | null;
  /** Filter review results by room type */
  roomTypeId?: number | null;
  /** Filter review results by user provided keyword */
  searchTerm?: string | null;
  /** Sort reviews by Recency, high-to-low rating and low-to-high rating */
  sortRating?: string[] | null;
  /** Filter review results by travel companions */
  travelCompanion?: string[] | null;
  /** Filter reviews by tripReason and travelerCompanion depending on this list */
  travelerType?: string[] | null;
  /** Filter review results by trip reasons */
  tripReason?: string[] | null;
}
/** PWA ONLY: Input that is sent directly from the URL value. These inputs can notbe parsed on a server render of the PWA and must be converted in the spinner */
export interface LegacyPropertySearchCriteriaInput {
  /** Maps to PropertyFilterAmenity */
  amenities?: string[] | null;
  /** Maps to ReviewScoreRange */
  guestRating?: string | null;
  /** Maps to PaymentType enum to account for legacy URL values */
  paymentType?: string[] | null;
  /** List of the price buckets to use. Starts from 0 index e.g. `[0,1,2]` */
  priceBuckets?: number[] | null;
  /** User preference for tracking which is only required in POSs that require tracking opt in */
  privacyTrackingState?: PrivacyTrackingState | null;
  /** Maps to PropertySort */
  sort?: string | null;
  /** Maps to starList */
  stars?: string | null;
  /** Maps to StructureType */
  structureTypes?: string[] | null;
}
/** Property shop options; If this field is not supplied, a server default will be chosen */
export interface PropertyShopOptionsInput {
  /** Ads related property search option */
  listings?: Listings | null;
  /** Paandi redirection to white label */
  paandiRedirection?: string | null;
  /** Points related property search option */
  points?: Points | null;
}
/** User Intent corresponding to this Search */
export interface SearchIntentInput {
  /** list of interests coming from Customer Spinner */
  interests?: InterestInput[] | null;
  /** SEM param, fetch from URL */
  semDtl?: string | null;
  /** SEM param, fetch from URL */
  semdtl?: string | null;
  /** TEMP Theme param, fetch from URL. Remove after SEM migration is complete */
  theme?: string | null;
  /** TEMP intent param, fetch from URL. Support BFF while migration to BEX API */
  userIntent?: string | null;
}
/** Provides the interest of a Customer for a particular search */
export interface InterestInput {
  /** SEM id of interest */
  desmetId?: string | null;
  /** Name of interest */
  name?: string | null;
}

export interface CampaignParametersInput {
  campaignId: string;

  contentPagination?: ContentPaginationInput | null;
}

export interface ContentPaginationInput {
  pageNumber: number;

  pageSize?: number | null;
}

export interface DestinationImageDimensionsInput {
  height: number;

  width: number;
}

export interface UserLocationInput {
  userCountryCode?: string | null;

  userLatitude: BigDecimal;

  userLongitude: BigDecimal;
}
/** Question And Answer Search filters */
export interface ProductQuestionFiltersInput {
  /** Filter Questions and Answers on the basis of this keyword */
  searchTerm?: string | null;
}

export interface CartFlightSearchContextInput {
  /** The age of every children at the time of the flight */
  childAges: number[];
  /** Flight filters */
  filter?: CartFlightFilterInput | null;
  /** The list of infant(s) sitting on laps */
  infantsInLap: boolean[];
  /** The number of adults */
  numberOfAdults: number;
  /** List of origins and destinations flight components */
  originDestinations: CartOriginDestinationSearchInput[];
  /** The type of ticket searched */
  searchType: CartFlightSearchType;
}

export interface CartFlightFilterInput {
  /** non-stop flights only filter */
  nonStopOnly?: boolean | null;
  /** Preferred airline filter */
  preferredAirline?: string | null;
  /** Preferred class filter */
  preferredClass?: string | null;
  /** refundable flights only filter */
  refundableOnly?: boolean | null;
}

export interface CartOriginDestinationSearchInput {
  /** The departure date of the flight */
  departure: DateInput;
  /** The code (TLA) of the arrival airport */
  destinationAirportCode: string;
  /** The code (TLA) of the departure airport */
  originAirportCode: string;
}
/** Minimum set of data used to retrieve details about a property product */
export interface PropertyOfferInput {
  naturalKeys: PropertyNaturalKeyInput[];

  offerIndex: number;
}

export interface CartPropertySearchContextInput {
  /** The checking date for the property rental */
  checkIn: DateInput;
  /** The checkOut date for the property rental */
  checkOut: DateInput;
  /** The id of the region where the hotel is located - from lodging domain */
  regionId: string;
  /** The list of rooms that user searched for */
  rooms: PropertyRoomInput[];
}
/** Options for the session cart being created */
export interface CartOptionsInput {
  ttl: CartTtl;
}
/** Checkout option and its value to apply on the checkoutUrl */
export interface CheckoutOptionInput {
  type: CheckoutOptionType;

  value: string;
}

export interface AbandonBookingInput {
  /** Order number of the booking for abandoning */
  orderNumber: string;
  /** Unique identifier of the collection of products / trip */
  tripId: Uuid;
}

export interface BookingInput {
  cars?: BookingCarInput[] | null;
  /** Email required for booking information to be sent to */
  email: string;
  /** List of ways to pay for the booking. */
  paymentMethods: PaymentMethodInput[];

  properties?: BookingPropertyInput[] | null;
  /** Total price of the booking */
  totalPrice?: MoneyInput | null;
  /** Unique identifier of the collection of products / trip */
  tripId: Uuid;
}
/** Booking information regarding a car rental product */
export interface BookingCarInput {
  contactName: PersonNameInput;

  phoneNumber: PhoneNumberInput;
  /** The unique identifier of the product sometimes referred to as componentId /entityId. Used to identify a product in the TripService. */
  reference: string;
}
/** Name of the main traveler */
export interface PersonNameInput {
  firstName: string;

  lastName: string;
}
/** Phone number with prefix number */
export interface PhoneNumberInput {
  number: string;
  /** The ISO country code (e.g. 'USA', 'GBR', etc) */
  phoneCountryId: string;
}
/** Requires at least 1 payment method to be provided. Currently only supports Credit Card and single payment. */
export interface PaymentMethodInput {
  /** Amount of money to charge for this payment method, not providing this assumes full amount */
  amountToCharge: MoneyInput;
  /** Payment token information which will be used to pay for the booking */
  paymentToken?: PaymentTokenInput | null;
}

export interface PaymentTokenInput {
  /** Payment session id for only 3DS booking */
  paymentSessionId?: string | null;
  /** When provided, will store the payment method for future use */
  saveAs?: string | null;
  /** Edge Token used for the payment */
  token: string;
  /** Type of payment being processed by the edge token */
  type: PaymentTokenType;
}
/** Booking information regarding a property product */
export interface BookingPropertyInput {
  contactName: PersonNameInput;

  phoneNumber: PhoneNumberInput;

  preferences?: PropertyPreferencesInput | null;
  /** The unique identifier of the product sometimes referred to as componentId /entityId. Used to identify a product in the TripService. */
  reference: string;
  /** Indicates whether the user wants to receive a confirmation sms or not. Default type is false. */
  sendConfirmationText?: boolean | null;
}
/** Outlines the user's requests and preferences to the property */
export interface PropertyPreferencesInput {
  /** List of user's accessibility requests */
  accessibilityRequests?: string[] | null;
  /** The user's requested bed type */
  bedType?: string | null;
  /** Indicates whether the user would prefer a smoking or non smoking room */
  smoking?: boolean | null;
  /** Free text special request to be conveyed to the property */
  specialRequests?: string | null;
}

export interface PaymentSessionCriteriaInput {
  /** Booking info which controls what kind of payment sessions may be required for payment */
  bookingProductInfoDetails: BookingProductDetailsInput[];
  /** Currency of the payment session */
  currency?: CurrencyInput | null;
  /** Payment token that represents the payment details */
  edgeToken: string;
  /** Browser metadata to set up 3DS */
  encodedBrowserMetadata: string;
  /** Trip ID to associate with the payment session */
  tripId: Uuid;
  /** Version of the library to use for challenge */
  version: string;
}

export interface BookingProductDetailsInput {
  businessModel: InventoryType;

  lineOfBusiness: LineOfBusiness;
}
/** Information about a specific currency */
export interface CurrencyInput {
  /** The ISO 4217 3-letter code for this currency */
  code: string;
  /** The display name of the currency */
  name: string;
  /** The currency symbol, e.g. '$' */
  symbol: string;
}

export interface ResumeBookingInput {
  /** Order number of the booking for resuming */
  orderNumber: string;
  /** List of payment options used for the booking */
  paymentOptionsUsed: PaymentOptionType[];
  /** Unique identifier of the collection of products / trip */
  tripId: Uuid;
}
/** Represents the the user input for customer notification mutation */
export interface CustomerNotificationUserInput {
  /** Represents list of customer notification user input */
  inputs: CustomerNotificationUserInputElementInput[];
}
/** Represents customer notification user input */
export interface CustomerNotificationUserInputElementInput {
  /** Represents the type of customer notification user input */
  type: string;
  /** Represents the value of customer notification user input */
  value: string;
}

export interface AddInsuranceRequestInput {
  /** CountryCode from residency selection of user */
  countryCode?: string | null;
  /** The user selection for the Insurance product(s) */
  insuranceProductIds: string[];
  /** RegionCode from residency selection of user */
  regionCode?: string | null;
  /** The insurance ids that needs to be removed when selecting another Insurance product(s) */
  removeInsuranceProductIds?: string[] | null;
  /** The shopping identifier for the cache */
  shoppingResponseId: string;
  /** The source id of the persistence store.For example Trip for BEX or Record locator for other systems */
  sourceId: string;
  /** The source Number of the persistence store.For example Trip number for BEX or Record locator for other systems */
  sourceNumber: string;
}

export interface AddInsuranceRequestOldInput {
  insuranceSearchId: string;

  offerTypeId: number;
}

export interface InsuranceTripMutationRequestInput {
  action: InsuranceMutationType;

  insuranceSearchId?: string | null;

  offerTypeId?: number | null;
}

export interface RemoveInsuranceRequestInput {
  /** The user selection for the Insurance product(s) */
  insuranceProductIds: string[];
  /** The source id of the persistence store.For example Trip for BEX or Record locator for other systems */
  sourceId: string;
  /** The source Number of the persistence store.For example Trip number for BEX or Record locator for other systems */
  sourceNumber: string;
}

export interface RemoveInsuranceRequestOldInput {
  insuranceSearchId: string;

  offerTypeId?: number | null;
}
/** Key/Value pairs of data required by the client for playback. (Optional) */
export interface ShortlistMetadataInput {
  key: string;

  value: string;
}
/** Describes a Property related Conversation */
export interface LodgingConversationMetadataInput {
  checkIn: DateInput;

  checkOut: DateInput;

  createdAt: Url;

  from: MessageFromInput;

  propertyId: string;

  rooms: PropertyRoomInput[];
}

export interface MessageFromInput {
  emailAddress: string;

  name: string;
}

// ====================================================
// Enums
// ====================================================

/** Specifies the behavior of ALTER, which is used to run Abacus experiments on localization messages. */
export enum AlterMode {
  DEBUG = 'DEBUG',
  NONE = 'NONE',
  PREVIEW = 'PREVIEW',
  RELEASED = 'RELEASED'
}
/** Valid device types */
export enum DeviceType {
  APP_PHONE = 'APP_PHONE',
  APP_TABLET = 'APP_TABLET',
  CHAT_APP = 'CHAT_APP',
  DESKTOP = 'DESKTOP',
  MOBILE_PHONE = 'MOBILE_PHONE',
  MOBILE_TABLET = 'MOBILE_TABLET',
  VOICE_APP = 'VOICE_APP'
}

export enum AuthenticationState {
  ANONYMOUS = 'ANONYMOUS',
  AUTHENTICATED = 'AUTHENTICATED',
  IDENTIFIED = 'IDENTIFIED'
}
/** Privacy tracking user preference. We can retrieve info on if the site allowstracking from Site Info and null can also be used to represent a selection or not */
export enum PrivacyTrackingState {
  CAN_NOT_TRACK = 'CAN_NOT_TRACK',
  CAN_TRACK = 'CAN_TRACK'
}
/** Enumerated Gaia geographic region types */
export enum RegionType {
  ADDRESS = 'ADDRESS',
  AIRPORT = 'AIRPORT',
  CITY = 'CITY',
  CONTINENT = 'CONTINENT',
  COUNTRY = 'COUNTRY',
  HIGH_LEVEL_REGION = 'HIGH_LEVEL_REGION',
  METRO_STATION = 'METRO_STATION',
  MULTI_CITY_VICINITY = 'MULTI_CITY_VICINITY',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  POINT_OF_INTEREST = 'POINT_OF_INTEREST',
  PROVINCE_STATE = 'PROVINCE_STATE',
  TRAIN_STATION = 'TRAIN_STATION',
  UNKNOWN = 'UNKNOWN'
}
/** The text direction of the locale e.g. ltr or rtl */
export enum TextDirection {
  LTR = 'LTR',
  RTL = 'RTL'
}
/** Cabin class chosen in flight */
export enum FlightsCabinClass {
  BUSINESS = 'BUSINESS',
  COACH = 'COACH',
  FIRST = 'FIRST',
  PREMIUM_ECONOMY = 'PREMIUM_ECONOMY'
}
/** Possible advanced filter types */
export enum FlightsAdvancedFilterType {
  NONSTOP = 'NONSTOP',
  REFUNDABLE = 'REFUNDABLE'
}
/** Possible traveler details types */
export enum TravelerDetailsType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT_IN_LAP = 'INFANT_IN_LAP',
  INFANT_IN_SEAT = 'INFANT_IN_SEAT'
}
/** Trip type chosen in flight search */
export enum FlightsTripType {
  MULTI_DESTINATION = 'MULTI_DESTINATION',
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP'
}
/** Possible equipment requested by the customer */
export enum SpecialEquipment {
  ADDITIONAL_DRIVER = 'ADDITIONAL_DRIVER',
  BICYCLE_RACK = 'BICYCLE_RACK',
  BOOSTER_SEAT = 'BOOSTER_SEAT',
  INFANT_SEAT = 'INFANT_SEAT',
  LEFT_HAND_CONTROL = 'LEFT_HAND_CONTROL',
  LUGGAGE_RACK = 'LUGGAGE_RACK',
  NAV_SYSTEM = 'NAV_SYSTEM',
  RIGHT_HAND_CONTROL = 'RIGHT_HAND_CONTROL',
  ROAD_CONGESTION_PAYMENT_SCHEME = 'ROAD_CONGESTION_PAYMENT_SCHEME',
  SATELLITE_RADIO = 'SATELLITE_RADIO',
  SKI_RACK = 'SKI_RACK',
  SNOW_CHAINS = 'SNOW_CHAINS',
  SNOW_TIRES = 'SNOW_TIRES',
  TODDLER_SEAT = 'TODDLER_SEAT',
  TOLL_PAYMENT_TAG_PASS = 'TOLL_PAYMENT_TAG_PASS',
  TRAILER_HITCH = 'TRAILER_HITCH',
  WIFI_ACCESS = 'WIFI_ACCESS',
  WINTER_PACKAGE = 'WINTER_PACKAGE'
}
/** Indicate the inventory type of a given offer */
export enum InventoryType {
  AICTRAVELGROUP = 'AICTRAVELGROUP',
  AMOMA = 'AMOMA',
  ANA = 'ANA',
  BESTBUYHOTEL = 'BESTBUYHOTEL',
  BONOTEL = 'BONOTEL',
  CNTRAVEL = 'CNTRAVEL',
  CTRIP = 'CTRIP',
  DESPEGAR = 'DESPEGAR',
  DIDATRAVEL = 'DIDATRAVEL',
  DIRECT_AGENCY = 'DIRECT_AGENCY',
  EUROPLAYAS = 'EUROPLAYAS',
  EXCITEHOLIDAYS = 'EXCITEHOLIDAYS',
  EZZEGO_1 = 'EZZEGO_1',
  GETAROOM = 'GETAROOM',
  HOME_AWAY = 'HOME_AWAY',
  HOTELDOBESTDAYTRAVEL = 'HOTELDOBESTDAYTRAVEL',
  HOTEL_BEDS = 'HOTEL_BEDS',
  HRS = 'HRS',
  JAC_TRAVEL = 'JAC_TRAVEL',
  JAL = 'JAL',
  JALAN = 'JALAN',
  JTB = 'JTB',
  JUMBOTOURS = 'JUMBOTOURS',
  MAGICROOMS = 'MAGICROOMS',
  MERCHANT = 'MERCHANT',
  MGBEDBANK = 'MGBEDBANK',
  MIKI = 'MIKI',
  MTS = 'MTS',
  NTA = 'NTA',
  NUITEE = 'NUITEE',
  OPAQUE = 'OPAQUE',
  OSTROVOK = 'OSTROVOK',
  PEGASUS = 'PEGASUS',
  RAKUTEN = 'RAKUTEN',
  RESTEL = 'RESTEL',
  ROOMER = 'ROOMER',
  SMYROOMS = 'SMYROOMS',
  SUNHOTELS = 'SUNHOTELS',
  TOURICO = 'TOURICO',
  TRAVELLANDA = 'TRAVELLANDA',
  TRAVELREPUBLIC = 'TRAVELREPUBLIC',
  VENERE = 'VENERE',
  VRBO = 'VRBO',
  WELCOME_BEDS = 'WELCOME_BEDS',
  WOORI = 'WOORI',
  WORLDHOTELLINK = 'WORLDHOTELLINK',
  WORLDSPAN = 'WORLDSPAN',
  WOTIF = 'WOTIF',
  YOUTRAVEL = 'YOUTRAVEL',
  ZUMATA = 'ZUMATA'
}
/** Indicate the shopping path of a given offer */
export enum ShoppingPathType {
  ATTACH = 'ATTACH',
  PACKAGE = 'PACKAGE',
  STANDALONE = 'STANDALONE'
}

export enum CrossSellProductType {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL'
}
/** supported sizes of icons */
export enum IconSize {
  EXTRA_SMALL = 'EXTRA_SMALL',
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  MEDIUM_LARGE = 'MEDIUM_LARGE',
  SMALL = 'SMALL'
}
/** Used to highlight or convey information. For example, positive messaging like free cancellation may be green. */
export enum TextTheme {
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE',
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}
/** The weight to be applied to a text element */
export enum MishopDetailsUiTextWeight {
  BOLD = 'BOLD',
  MEDIUM = 'MEDIUM',
  REGULAR = 'REGULAR'
}

export enum BookingStatus {
  ABANDONED = 'ABANDONED',
  ANY = 'ANY',
  BOOKED = 'BOOKED',
  CANCELLED = 'CANCELLED',
  DELETED = 'DELETED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  INVALID = 'INVALID',
  NO_LONGER_AVAILABLE = 'NO_LONGER_AVAILABLE',
  PARTIALLY_FAILED = 'PARTIALLY_FAILED',
  PENDING = 'PENDING',
  PLANNING = 'PLANNING',
  SAVED = 'SAVED',
  UNKNOWN = 'UNKNOWN'
}
/** Possible direction types for ground transfers */
export enum GroundTransfersDirection {
  FROM_AIRPORT = 'FROM_AIRPORT',
  ROUNDTRIP = 'ROUNDTRIP',
  TO_AIRPORT = 'TO_AIRPORT'
}
/** Possible direction types for ground transfers */
export enum GeoType {
  AIRPORT = 'AIRPORT',
  DESTINATION = 'DESTINATION',
  PROPERTY = 'PROPERTY'
}
/** Possible traveler details types */
export enum GroundTransfersTravelerDetailsType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT = 'INFANT'
}
/** Text style to apply to text */
export enum GroundTransfersStyle {
  EMPHASISED = 'EMPHASISED',
  POSITIVE = 'POSITIVE',
  STANDARD = 'STANDARD'
}

export enum GroundTransfersBadgeTheme {
  DEAL_BUNDLED = 'DEAL_BUNDLED',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER'
}

export enum GroundTransfersGroupViewType {
  CARDS_LIST = 'CARDS_LIST'
}
/** Details view options that are not filters */
export enum ActivityDetailViewOptions {
  NON_CONSOLIDATED_OFFERS = 'NON_CONSOLIDATED_OFFERS',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}
/** Search options that are not filters */
export enum ActivitySearchOptions {
  CATEGORY = 'CATEGORY',
  FILTER_NESTED_CATEGORIES = 'FILTER_NESTED_CATEGORIES',
  GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER = 'GAIA_RETURN_ADDITIONAL_DISTANCE_PARAMETER',
  GIFTING_ACTIVITIES = 'GIFTING_ACTIVITIES',
  GUEST_PROMO = 'GUEST_PROMO',
  NON_CONSOLIDATED_OFFERS = 'NON_CONSOLIDATED_OFFERS',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
  SHOW_GT_BANNER = 'SHOW_GT_BANNER'
}

export enum ActivityBadgeType {
  CAMPAIGN_DEAL = 'CAMPAIGN_DEAL',
  DEAL_ADD_ON = 'DEAL_ADD_ON',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER'
}

export enum ActivityCategory {
  ADULTS_ONLY_SHOWS = 'ADULTS_ONLY_SHOWS',
  ADVENTURES = 'ADVENTURES',
  ADVENTURE_OUTDOOR = 'ADVENTURE_OUTDOOR',
  AIRBOAT_TOURS = 'AIRBOAT_TOURS',
  AIRPLANE_RIDES = 'AIRPLANE_RIDES',
  AIRPLANE_TOURS = 'AIRPLANE_TOURS',
  AIRPORT_GROUND_TRANSPORTATION = 'AIRPORT_GROUND_TRANSPORTATION',
  AIRPORT_LOUNGES = 'AIRPORT_LOUNGES',
  AIRPORT_TO_AIRPORT_TRANSFERS = 'AIRPORT_TO_AIRPORT_TRANSFERS',
  AIR_BALLOON_HELICOPTER_TOURS = 'AIR_BALLOON_HELICOPTER_TOURS',
  AIR_HELICOPTER_BALLOON_TOURS = 'AIR_HELICOPTER_BALLOON_TOURS',
  AMUSEMENT_THEME_PARKS = 'AMUSEMENT_THEME_PARKS',
  ARCHITECTURE_TOURS = 'ARCHITECTURE_TOURS',
  ART_CLASSES = 'ART_CLASSES',
  ART_CULTURE_HISTORY_TOURS = 'ART_CULTURE_HISTORY_TOURS',
  ART_MUSIC_LITERARYTOURS = 'ART_MUSIC_LITERARYTOURS',
  ATTRACTIONS = 'ATTRACTIONS',
  ATTRACTION_TICKETS = 'ATTRACTION_TICKETS',
  BALLOON_RIDES = 'BALLOON_RIDES',
  BALLOON_TOURS = 'BALLOON_TOURS',
  BAR_PUB_TOURS = 'BAR_PUB_TOURS',
  BEER_BREWERY_TOURS = 'BEER_BREWERY_TOURS',
  BEYOND_THE_CITY = 'BEYOND_THE_CITY',
  BIKE_MOUNTAIN_BIKE_TOURS = 'BIKE_MOUNTAIN_BIKE_TOURS',
  BIKE_RENTALS = 'BIKE_RENTALS',
  BOAT_RENTAL = 'BOAT_RENTAL',
  BOAT_TOURS = 'BOAT_TOURS',
  BOAT_TOURS_CRUISES = 'BOAT_TOURS_CRUISES',
  BRUNCHC_RUISES = 'BRUNCHC_RUISES',
  BUNGEE_JUMPING_SKYDIVING = 'BUNGEE_JUMPING_SKYDIVING',
  BUS_MINIVAN_TOURS = 'BUS_MINIVAN_TOURS',
  CABARET = 'CABARET',
  CAMPAIGN_DEALS = 'CAMPAIGN_DEALS',
  CASTLE_PALACE_TOURS = 'CASTLE_PALACE_TOURS',
  CHAUFFER_SERVICES = 'CHAUFFER_SERVICES',
  CHRISTMAS = 'CHRISTMAS',
  CIRQUE = 'CIRQUE',
  CIRQUE_DU_SOLEIL = 'CIRQUE_DU_SOLEIL',
  CIRQUE_DU_SOLEILSHOWS = 'CIRQUE_DU_SOLEILSHOWS',
  CITY_AND_ATTRACTION_TRANSFERS = 'CITY_AND_ATTRACTION_TRANSFERS',
  CITY_ATTRACTION_TRANSFERS = 'CITY_ATTRACTION_TRANSFERS',
  CITY_TOURS = 'CITY_TOURS',
  CITY_TOURS_PACKAGES = 'CITY_TOURS_PACKAGES',
  CLASSES_WORKSHOPS = 'CLASSES_WORKSHOPS',
  CLUB_AND_PARTY_BUS_TOURS = 'CLUB_AND_PARTY_BUS_TOURS',
  CLUB_PARTY_BUS_TOURS = 'CLUB_PARTY_BUS_TOURS',
  COFFEE_TEA_TOURS = 'COFFEE_TEA_TOURS',
  COMEDY_SHOWS = 'COMEDY_SHOWS',
  CONCERTS_SPECIAL_EVENTS = 'CONCERTS_SPECIAL_EVENTS',
  COOKING_CLASSES = 'COOKING_CLASSES',
  CRUISES_BOAT_TOURS = 'CRUISES_BOAT_TOURS',
  CRUISES_WATER_TOURS = 'CRUISES_WATER_TOURS',
  CULTURAL_HERITAGE_EXPERIENCES = 'CULTURAL_HERITAGE_EXPERIENCES',
  CUSTOM_PRIVATE_TOURS = 'CUSTOM_PRIVATE_TOURS',
  DANCE_CLASSES = 'DANCE_CLASSES',
  DAY_OF_THE_DEAD = 'DAY_OF_THE_DEAD',
  DAY_SPAS = 'DAY_SPAS',
  DAY_TRIPS = 'DAY_TRIPS',
  DAY_TRIPS_EXCURSIONS = 'DAY_TRIPS_EXCURSIONS',
  DINING_EXPERIENCES = 'DINING_EXPERIENCES',
  DINNER_CRUISES = 'DINNER_CRUISES',
  DINNER_THEATER = 'DINNER_THEATER',
  DISNEY = 'DISNEY',
  DISNEY_PARKS = 'DISNEY_PARKS',
  DOLPHIN_WHALE_WATCHING = 'DOLPHIN_WHALE_WATCHING',
  DOSE_OF_CULTURE = 'DOSE_OF_CULTURE',
  DUCK_TOURS = 'DUCK_TOURS',
  EASTER = 'EASTER',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  FASHION_SHOWS_TOURS = 'FASHION_SHOWS_TOURS',
  FISHING_CHARTERS_TOURS = 'FISHING_CHARTERS_TOURS',
  FISHING_TOURS_AND_CHARTERS = 'FISHING_TOURS_AND_CHARTERS',
  FOOD_DRINK = 'FOOD_DRINK',
  FOOD_DRINK_NIGHTLIFE = 'FOOD_DRINK_NIGHTLIFE',
  FOOD_TOURS = 'FOOD_TOURS',
  FUN_FOR_FOODIES = 'FUN_FOR_FOODIES',
  FUN_ON_THE_WATER = 'FUN_ON_THE_WATER',
  GALLERIES_MUSEUMS = 'GALLERIES_MUSEUMS',
  GAMES_SHOWS_SPECIAL_EVENTS = 'GAMES_SHOWS_SPECIAL_EVENTS',
  GETTING_AROUND = 'GETTING_AROUND',
  GOLF_TEE_TIMES = 'GOLF_TEE_TIMES',
  GOLF_TOURS_TEE_TIMES = 'GOLF_TOURS_TEE_TIMES',
  HALLOWEEN = 'HALLOWEEN',
  HAMMAMS_TURKISH_BATHS = 'HAMMAMS_TURKISH_BATHS',
  HELICOPTER_RIDES = 'HELICOPTER_RIDES',
  HELICOPTER_TOURS = 'HELICOPTER_TOURS',
  HIGH_SPEED_DRIVING = 'HIGH_SPEED_DRIVING',
  HIGH_SPEED_RIDES = 'HIGH_SPEED_RIDES',
  HIKING_CAMPING = 'HIKING_CAMPING',
  HISTORICAL_TOURS = 'HISTORICAL_TOURS',
  HISTORY_CULTURE = 'HISTORY_CULTURE',
  HOLIDAY_SEASONAL_TOURS = 'HOLIDAY_SEASONAL_TOURS',
  HONEYMOON_PACKAGE = 'HONEYMOON_PACKAGE',
  HONEYMOON_PACKAGES = 'HONEYMOON_PACKAGES',
  HOP_ON_HOP_OFF = 'HOP_ON_HOP_OFF',
  HOP_ON_HOP_OFF_TOURS = 'HOP_ON_HOP_OFF_TOURS',
  HORSE_CARRIAGE_RIDES = 'HORSE_CARRIAGE_RIDES',
  HOT_SPRINGS_THERMAL_SPAS = 'HOT_SPRINGS_THERMAL_SPAS',
  INTERESTS = 'INTERESTS',
  KAYAKING_CANOEING = 'KAYAKING_CANOEING',
  LATEST_GREATEST = 'LATEST_GREATEST',
  LIFT_TICKETS = 'LIFT_TICKETS',
  LIKELY_TO_SELL_OUT = 'LIKELY_TO_SELL_OUT',
  LITERARY_ART_MUSIC_TOURS = 'LITERARY_ART_MUSIC_TOURS',
  LOCAL_EXPERT_PICKS = 'LOCAL_EXPERT_PICKS',
  LUNCH_CRUISES = 'LUNCH_CRUISES',
  MOTORCYCLE_SCOOTER_TOURS = 'MOTORCYCLE_SCOOTER_TOURS',
  MOVIE_TV_TOURS = 'MOVIE_TV_TOURS',
  MULTIDAY_CRUISES = 'MULTIDAY_CRUISES',
  MULTI_DAY_EXTENDED_TOURS = 'MULTI_DAY_EXTENDED_TOURS',
  MUSEUM_TICKETS = 'MUSEUM_TICKETS',
  MUSEUM_TICKETS_PASSES = 'MUSEUM_TICKETS_PASSES',
  MUST_SEE_SIGHTS = 'MUST_SEE_SIGHTS',
  NA = 'NA',
  NATIONAL_HOLIDAYS = 'NATIONAL_HOLIDAYS',
  NEW = 'NEW',
  NEWY_EARS = 'NEWY_EARS',
  NIGHTLIFE = 'NIGHTLIFE',
  NIGHTLIFE_PASSES = 'NIGHTLIFE_PASSES',
  NIGHT_CRUISES = 'NIGHT_CRUISES',
  NIGHT_TOURS = 'NIGHT_TOURS',
  ONSENS = 'ONSENS',
  OTHER_ANIMALS_ACTIVITIES = 'OTHER_ANIMALS_ACTIVITIES',
  OTHER_ANIMAL_ACTIVITIES = 'OTHER_ANIMAL_ACTIVITIES',
  OTHER_CLASSES = 'OTHER_CLASSES',
  OTHER_OUTDOOR_ACTIVITIES = 'OTHER_OUTDOOR_ACTIVITIES',
  OTHER_SEASONAL_EVENTS = 'OTHER_SEASONAL_EVENTS',
  OTHER_TOURS = 'OTHER_TOURS',
  OTHER_TRANSFERS = 'OTHER_TRANSFERS',
  OTHER_TRANSPORTATION = 'OTHER_TRANSPORTATION',
  OTHER_WATER_ACTIVITIES = 'OTHER_WATER_ACTIVITIES',
  PHOTOGRAPHY_TOURS = 'PHOTOGRAPHY_TOURS',
  PORT_TRANSFERS = 'PORT_TRANSFERS',
  PRIVATE_CUSTOM_TOURS = 'PRIVATE_CUSTOM_TOURS',
  PRIVATE_DAY_TRIPS = 'PRIVATE_DAY_TRIPS',
  PRIVATE_TOURS = 'PRIVATE_TOURS',
  PRIVATE_TRANSFERS = 'PRIVATE_TRANSFERS',
  PURE_ROMANCE = 'PURE_ROMANCE',
  RELIGIOUS_SPIRITUAL_TOURS = 'RELIGIOUS_SPIRITUAL_TOURS',
  RIVER_HARBOUR_CRUISES = 'RIVER_HARBOUR_CRUISES',
  ROMAN_STAYCATION = 'ROMAN_STAYCATION',
  SAFARIS = 'SAFARIS',
  SAILING_TRIPS = 'SAILING_TRIPS',
  SCOOTER_RENTALS = 'SCOOTER_RENTALS',
  SEGWAY_TOURS = 'SEGWAY_TOURS',
  SHARED_TRANSFERS = 'SHARED_TRANSFERS',
  SHARK_DIVING = 'SHARK_DIVING',
  SHOPPING_FASHION = 'SHOPPING_FASHION',
  SHOPPING_PASSES_OFFERS = 'SHOPPING_PASSES_OFFERS',
  SHOPPING_TOURS = 'SHOPPING_TOURS',
  SHORE_EXCURIONS = 'SHORE_EXCURIONS',
  SHOWS_CONCERTS = 'SHOWS_CONCERTS',
  SHOW_SPORT_TICKETS = 'SHOW_SPORT_TICKETS',
  SIGHTSEEING_ATTRACTION_PASSES = 'SIGHTSEEING_ATTRACTION_PASSES',
  SIGHTSEEING_CITY_PASSES = 'SIGHTSEEING_CITY_PASSES',
  SIGHTSEEING_PASSES = 'SIGHTSEEING_PASSES',
  SKIING_RENTALS = 'SKIING_RENTALS',
  SKIP_THE_LINE_TOURS = 'SKIP_THE_LINE_TOURS',
  SNORKELING_SCUBA_DIVING = 'SNORKELING_SCUBA_DIVING',
  SNOWBOARDING_RENTALS = 'SNOWBOARDING_RENTALS',
  SNOWMOBILE_TOURS = 'SNOWMOBILE_TOURS',
  SNOWSHOEING = 'SNOWSHOEING',
  SPA = 'SPA',
  SPA_WELLNESS = 'SPA_WELLNESS',
  SPEED_BOATS_JET_SKIS = 'SPEED_BOATS_JET_SKIS',
  SPORTING_EVENTS_PACKAGES = 'SPORTING_EVENTS_PACKAGES',
  SPORTS_PACKAGES = 'SPORTS_PACKAGES',
  STAY_ACTIVE = 'STAY_ACTIVE',
  SUBMARINE_TOURS = 'SUBMARINE_TOURS',
  SUNSET_CRUISES = 'SUNSET_CRUISES',
  SUPERNATURAL_TOURS = 'SUPERNATURAL_TOURS',
  SUSTAINABLE_TOURS = 'SUSTAINABLE_TOURS',
  SWIM_WITH_DOLPHINS = 'SWIM_WITH_DOLPHINS',
  THEATER_SHOWS_MUSICALS = 'THEATER_SHOWS_MUSICALS',
  THEME_PARKS = 'THEME_PARKS',
  THEME_PARK_TICKETS_TOURS = 'THEME_PARK_TICKETS_TOURS',
  THE_GREAT_OUTDOORS = 'THE_GREAT_OUTDOORS',
  THRILL_SEEKER = 'THRILL_SEEKER',
  TICKETS = 'TICKETS',
  TOURS_ACTIVITIES = 'TOURS_ACTIVITIES',
  TOURS_SIGHTSEEING = 'TOURS_SIGHTSEEING',
  TRANSPORTATION_SERVICES = 'TRANSPORTATION_SERVICES',
  TREAT_YOURSELF = 'TREAT_YOURSELF',
  TUBING = 'TUBING',
  UNIVERSAL_THEME_PARKS = 'UNIVERSAL_THEME_PARKS',
  VALENTINES_DAY = 'VALENTINES_DAY',
  WALKING_BIKE_TOURS = 'WALKING_BIKE_TOURS',
  WALKING_TOURS = 'WALKING_TOURS',
  WATERSKIING_WAKEBOARDING = 'WATERSKIING_WAKEBOARDING',
  WATER_ACTIVITIES = 'WATER_ACTIVITIES',
  WATER_PARKS = 'WATER_PARKS',
  WEDDING_CEREMONIES = 'WEDDING_CEREMONIES',
  WEDDING_HONEYMOON = 'WEDDING_HONEYMOON',
  WEDDING_PACKAGES = 'WEDDING_PACKAGES',
  WEDDING_SHONEYMOONS = 'WEDDING_SHONEYMOONS',
  WHAT_TO_DO_WITH_GROUPS = 'WHAT_TO_DO_WITH_GROUPS',
  WHAT_TO_DO_WITH_KIDS = 'WHAT_TO_DO_WITH_KIDS',
  WHITE_WATER_RAFTING = 'WHITE_WATER_RAFTING',
  WILDLIFE_NATURE = 'WILDLIFE_NATURE',
  WINE_TASTING_WINERY_TOURS = 'WINE_TASTING_WINERY_TOURS',
  WINTER_ACTIVITIES = 'WINTER_ACTIVITIES',
  YOGA_CLASS = 'YOGA_CLASS',
  YOGA_CLASSES = 'YOGA_CLASSES',
  ZOO_TICKETS = 'ZOO_TICKETS',
  ZOO_TICKETS_PASSES = 'ZOO_TICKETS_PASSES'
}

export enum ChronoUnit {
  CENTURIES = 'CENTURIES',
  DAYS = 'DAYS',
  DECADES = 'DECADES',
  ERAS = 'ERAS',
  FOREVER = 'FOREVER',
  HALFDAYS = 'HALFDAYS',
  HOURS = 'HOURS',
  MICROS = 'MICROS',
  MILLENNIA = 'MILLENNIA',
  MILLIS = 'MILLIS',
  MINUTES = 'MINUTES',
  MONTHS = 'MONTHS',
  NANOS = 'NANOS',
  SECONDS = 'SECONDS',
  WEEKS = 'WEEKS',
  YEARS = 'YEARS'
}

export enum ActivityCancellationType {
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  NO_CANCELLATION = 'NO_CANCELLATION'
}

export enum ActivityDiscountType {
  AIR_ATTACH_MIP = 'AIR_ATTACH_MIP',
  AIR_HOTEL_ATTACH_MIP = 'AIR_HOTEL_ATTACH_MIP',
  CAMPAIGN_DEAL = 'CAMPAIGN_DEAL',
  FREE_ACTIVITY = 'FREE_ACTIVITY',
  GUEST = 'GUEST',
  HOTEL_ATTACH_MIP = 'HOTEL_ATTACH_MIP',
  MOD = 'MOD',
  STRIKE_OUT = 'STRIKE_OUT'
}

export enum ActivityRedemptionType {
  PRINT = 'PRINT',
  VOUCHER_LESS = 'VOUCHER_LESS'
}

export enum ActivityTextSize {
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}
/** Activity Price types */
export enum ActivityPriceType {
  GROUP = 'GROUP',
  NORMAL = 'NORMAL',
  VOLUME_BASED = 'VOLUME_BASED'
}

export enum ActivityOfferUdsToken {
  SELECTED = 'SELECTED',
  UNSELECTED = 'UNSELECTED'
}
/** Activity banner type */
export enum ActivityBannerType {
  ALERT = 'ALERT',
  INFO = 'INFO',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}
/** Unique identifier for a message if one needs to identify the reason for the message creation */
export enum ActivityMessageType {
  ADDON = 'ADDON',
  EARN_2X_REWARD_POINTS = 'EARN_2X_REWARD_POINTS',
  GIFTING_LX_BANNER = 'GIFTING_LX_BANNER',
  LOGIN = 'LOGIN',
  SOURCED_CAMPAIGN = 'SOURCED_CAMPAIGN',
  SUMMER_CAMPAIGN_PRIMARY = 'SUMMER_CAMPAIGN_PRIMARY',
  SUMMER_CAMPAIGN_SECONDARY = 'SUMMER_CAMPAIGN_SECONDARY'
}

export enum ActivityReviewSort {
  HIGHEST_TO_LOWEST_RATED = 'HIGHEST_TO_LOWEST_RATED',
  LOWEST_TO_HIGHEST_RATED = 'LOWEST_TO_HIGHEST_RATED',
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST'
}

export enum ActivityGroupType {
  ACTIVITY_LIST = 'ACTIVITY_LIST',
  ACTIVITY_MESSAGE = 'ACTIVITY_MESSAGE',
  AVAILABLE_TODAY = 'AVAILABLE_TODAY',
  CATEGORY = 'CATEGORY',
  FILTERED_ACTIVITIES = 'FILTERED_ACTIVITIES',
  INTERESTS = 'INTERESTS',
  KEYWORD_SEARCH = 'KEYWORD_SEARCH',
  MORE_ACTIVITIES = 'MORE_ACTIVITIES',
  NEIGHBOURHOOD = 'NEIGHBOURHOOD',
  PINNED_ACTIVITY = 'PINNED_ACTIVITY',
  POI = 'POI',
  RECOMMENDATIONS = 'RECOMMENDATIONS',
  SLIM_CATEGORY = 'SLIM_CATEGORY',
  SUB_CATEGORIES = 'SUB_CATEGORIES',
  SUB_CATEGORY = 'SUB_CATEGORY',
  TOP_ACTIVITIES = 'TOP_ACTIVITIES',
  XSELL_RECOMMENDATIONS = 'XSELL_RECOMMENDATIONS'
}
/** Search view options that are not filters */
export enum ActivitySearchViewOptions {
  DISTANCE_FROM_HOTEL_TO_ACTIVITY = 'DISTANCE_FROM_HOTEL_TO_ACTIVITY',
  FILTER_NESTED_CATEGORIES = 'FILTER_NESTED_CATEGORIES',
  NEARBY_ACTIVITIES = 'NEARBY_ACTIVITIES',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS',
  SHOW_GT_BANNER = 'SHOW_GT_BANNER',
  TRAVEL_DISTANCE_FROM_HOTEL = 'TRAVEL_DISTANCE_FROM_HOTEL'
}
/** Activity sort types */
export enum ActivitySort {
  CAMPAIGN_DEALS = 'CAMPAIGN_DEALS',
  DISTANCE_FROM_HOTEL = 'DISTANCE_FROM_HOTEL',
  PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW',
  PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH',
  RECOMMENDED = 'RECOMMENDED'
}

export enum ActivityGroupViewType {
  ACTIVITY_LIST = 'ACTIVITY_LIST',
  ACTIVITY_SPANNED_TILE_LIST = 'ACTIVITY_SPANNED_TILE_LIST',
  ACTIVITY_TILES_CAROUSEL = 'ACTIVITY_TILES_CAROUSEL',
  CATEGORY_TILES_CAROUSEL = 'CATEGORY_TILES_CAROUSEL',
  KEYWORD_SEARCH = 'KEYWORD_SEARCH',
  MESSAGE = 'MESSAGE',
  SLIM_CATEGORY_TILES_CAROUSEL = 'SLIM_CATEGORY_TILES_CAROUSEL',
  TEXT = 'TEXT'
}

export enum ActivityMapGroupType {
  POI = 'POI'
}

export enum ActivityCategoryType {
  ACTIVITIES = 'ACTIVITIES',
  CATEGORIES = 'CATEGORIES',
  DEALS_PROMOTIONS = 'DEALS_PROMOTIONS',
  NA = 'NA',
  RECOMMENDATIONS = 'RECOMMENDATIONS',
  TOURS = 'TOURS',
  TRANSPORTATION = 'TRANSPORTATION'
}

export enum ActivityUdsToken {
  MULTI_SELECT_LIST = 'MULTI_SELECT_LIST',
  MULTI_SELECT_RANGE = 'MULTI_SELECT_RANGE',
  SINGLE_SELECT = 'SINGLE_SELECT',
  TEXT = 'TEXT'
}
/** Activity Page Type - infosite or TTDFH */
export enum ActivityPageType {
  ACTIVITY_INFO = 'ACTIVITY_INFO',
  ACTIVITY_THINGS_TO_DO_FROM_HOME = 'ACTIVITY_THINGS_TO_DO_FROM_HOME'
}
/** Activity page Meta Tag types - NamedMetaTag, PropertyMetaTag and so on */
export enum ActivityPageMetaTagType {
  HTTP_EQUIV = 'HTTP_EQUIV',
  NAME = 'NAME',
  PROPERTY = 'PROPERTY'
}
/** Supported versions of chatbot. */
export enum ChatbotVersionId {
  V1 = 'V1',
  V2 = 'V2'
}
/** Indicates the coupon's active state */
export enum ActiveState {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  UNKNOWN = 'UNKNOWN',
  USED = 'USED'
}

export enum TripIntentPersonType {
  ADULT = 'ADULT',
  CHILD = 'CHILD'
}

export enum HistoryType {
  ACTIVITY_DETAIL = 'ACTIVITY_DETAIL',
  ACTIVITY_SEARCH = 'ACTIVITY_SEARCH',
  CAR_DETAIL = 'CAR_DETAIL',
  CAR_SEARCH = 'CAR_SEARCH',
  CRUISE_SEARCH = 'CRUISE_SEARCH',
  FLIGHT_DETAIL = 'FLIGHT_DETAIL',
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  PACKAGE_SEARCH = 'PACKAGE_SEARCH',
  PROPERTY_DETAIL = 'PROPERTY_DETAIL',
  PROPERTY_SEARCH = 'PROPERTY_SEARCH'
}

export enum FunnelLocation {
  CHECKOUT = 'CHECKOUT',
  CHECKOUT_ERROR = 'CHECKOUT_ERROR',
  CONFIRMATION = 'CONFIRMATION',
  DETAILS = 'DETAILS',
  ENTRY = 'ENTRY',
  FEATURES = 'FEATURES',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  POST_BOOKING = 'POST_BOOKING',
  SEARCH_RESULTS = 'SEARCH_RESULTS',
  SYSTEM = 'SYSTEM',
  USER = 'USER'
}

export enum ExpLineOfBusiness {
  ACTIVITIES = 'ACTIVITIES',
  CAR = 'CAR',
  CRUISES = 'CRUISES',
  FLIGHT = 'FLIGHT',
  GROUNDTRANSFERS = 'GROUNDTRANSFERS',
  HOTEL = 'HOTEL',
  PACKAGES = 'PACKAGES',
  RAILS = 'RAILS',
  UNCLASSIFIED = 'UNCLASSIFIED'
}

export enum NotificationLocation {
  AFTER_HEADER = 'AFTER_HEADER',
  FOOTER = 'FOOTER',
  IN_PAGE = 'IN_PAGE',
  IN_PAGE_AD = 'IN_PAGE_AD',
  POPUP = 'POPUP',
  PRE_HEADER = 'PRE_HEADER'
}
/** The text style to apply to strings */
export enum CustomerNotificationPhrasePartStyle {
  EMPHASIS = 'EMPHASIS',
  IMPORTANT = 'IMPORTANT',
  STANDARD = 'STANDARD'
}
/** Represents the target of the link */
export enum CustomerNotificationLinkTarget {
  NEW_TAB = 'NEW_TAB',
  SAME_TAB = 'SAME_TAB'
}
/** The display type of the Customer notification message */
export enum CustomerNotificationMessageDisplayType {
  FORM = 'FORM',
  PAGE = 'PAGE'
}
/** The level type of the Customer notification message */
export enum CustomerNotificationMessageLevel {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING'
}
/** Represents the link type */
export enum CustomerNotificationLinkType {
  ANCHOR = 'ANCHOR',
  BUTTON = 'BUTTON',
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}

export enum CustomerNotificationType {
  APP_DOWNLOAD = 'APP_DOWNLOAD',
  APP_HERO = 'APP_HERO',
  CITI_COBRAND = 'CITI_COBRAND',
  GDPR = 'GDPR',
  MAD_MARQUEE = 'MAD_MARQUEE',
  NONE = 'NONE',
  TRAVEL_ADVISORY = 'TRAVEL_ADVISORY'
}
/** Search history grouping day range. */
export enum SearchHistoryDayRange {
  SEVEN_DAYS = 'SEVEN_DAYS',
  THREE_DAYS = 'THREE_DAYS'
}
/** Search history grouping destination type. */
export enum SearchHistoryDestinationType {
  METRO_CITY = 'METRO_CITY'
}
/** Gender of the customer */
export enum CustomerGender {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  UNKNOWN = 'UNKNOWN'
}
/** Represents the state the client wants to query */
export enum FlightsQueryState {
  LOADED = 'LOADED',
  LOADING = 'LOADING'
}
/** Describes the type of actionable button. Types reference UDS tokens for buttons. */
export enum FlightsActionDisplayType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY'
}
/** Represent all the possible traveler types */
export enum FlightsTravelerType {
  ADULT = 'ADULT',
  CHILD = 'CHILD',
  INFANT_IN_LAP = 'INFANT_IN_LAP',
  INFANT_IN_SEAT = 'INFANT_IN_SEAT'
}
/** Available action types an actionable element */
export enum FlightsActionType {
  APPLY_FARE = 'APPLY_FARE',
  CHOOSE_FARE = 'CHOOSE_FARE',
  DISMISS = 'DISMISS',
  ENABLE_SUGGESTED_FILTER = 'ENABLE_SUGGESTED_FILTER',
  FETCH_SEARCH_LISTINGS = 'FETCH_SEARCH_LISTINGS',
  GO_TO_CHECKOUT = 'GO_TO_CHECKOUT',
  GO_TO_DETAILS = 'GO_TO_DETAILS',
  GO_TO_NEXT_JOURNEY = 'GO_TO_NEXT_JOURNEY',
  GO_TO_PACKAGES = 'GO_TO_PACKAGES',
  GO_TO_SEARCH = 'GO_TO_SEARCH',
  GO_TO_STOREFRONT = 'GO_TO_STOREFRONT',
  LOAD_CROSS_SELL_DIALOG = 'LOAD_CROSS_SELL_DIALOG',
  LOAD_STANDARD_OFFER_FARE_RULE_MODULE = 'LOAD_STANDARD_OFFER_FARE_RULE_MODULE',
  OPEN_PRICE_SUMMARY = 'OPEN_PRICE_SUMMARY',
  REFRESH = 'REFRESH',
  SEARCH_FORM_ADD_JOURNEY = 'SEARCH_FORM_ADD_JOURNEY',
  SEARCH_FORM_CLOSE_BUTTON = 'SEARCH_FORM_CLOSE_BUTTON',
  SEARCH_FORM_REMOVE_JOURNEY = 'SEARCH_FORM_REMOVE_JOURNEY',
  SHARE_FEEDBACK = 'SHARE_FEEDBACK'
}
/** The text style to apply to strings */
export enum FlightsPhrasePartStyle {
  EMPHASIS = 'EMPHASIS',
  IMPORTANT = 'IMPORTANT',
  STANDARD = 'STANDARD'
}
/** Tags Associated with the response */
export enum ResponseTagType {
  LISTINGS_PAGINATED = 'LISTINGS_PAGINATED',
  LISTING_CACHE_SOURCE = 'LISTING_CACHE_SOURCE',
  LISTING_DOWNLEVEL_SOURCE = 'LISTING_DOWNLEVEL_SOURCE',
  UNRECOGNIZED = 'UNRECOGNIZED'
}
/** Css class names for datepicker cell content. */
export enum FlightsFareCalendarPriceTheme {
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE',
  UNDEFINED = 'UNDEFINED'
}
/** Enum representing the various time slots in a day */
export enum FlightsTimeOfDay {
  AFTERNOON = 'AFTERNOON',
  EARLY_MORNING = 'EARLY_MORNING',
  EVENING = 'EVENING',
  MORNING = 'MORNING'
}
/** Enum class to represent the type of flexible change policies */
export enum FilterPolicyType {
  NO_CHANGE_FEE = 'NO_CHANGE_FEE'
}
/** Enum class to represent the operation associated with num of stops */
export enum FlightsStopFilterOperation {
  EQUAL = 'EQUAL',
  GREATER_THAN_EQUAL = 'GREATER_THAN_EQUAL',
  LESS_THAN_EQUAL = 'LESS_THAN_EQUAL'
}
/** Enum which lists the sort orders */
export enum FlightsSortOrder {
  DECREASING = 'DECREASING',
  INCREASING = 'INCREASING'
}
/** Enum class which lists all the supported sorting criteria */
export enum FlightsSortType {
  ARRIVAL = 'ARRIVAL',
  DEPARTURE = 'DEPARTURE',
  DURATION = 'DURATION',
  PRICE = 'PRICE',
  RECOMMENDED = 'RECOMMENDED'
}
/** Represents the type of animation the dialog will use when displayed */
export enum FlightsDialogAnimation {
  FADE = 'FADE',
  NONE = 'NONE'
}
/** Represents the theme values for a Badge */
export enum FlightsBadgeTheme {
  DEAL_BUNDLED = 'DEAL_BUNDLED',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  NOTIFICATION = 'NOTIFICATION',
  SAVED = 'SAVED',
  SPONSORED = 'SPONSORED',
  SUPPLIER_PROMO = 'SUPPLIER_PROMO',
  VIEWED = 'VIEWED',
  VIP = 'VIP'
}
/** Represents cross sell product types that will be displayed */
export enum FlightCrossSellProductType {
  CAR = 'CAR',
  HOTEL = 'HOTEL'
}

export enum FlightsFilterType {
  ARRIVAL_AIRPORT = 'ARRIVAL_AIRPORT',
  ARRIVAL_TIME = 'ARRIVAL_TIME',
  DEPARTURE_AIRPORT = 'DEPARTURE_AIRPORT',
  DEPARTURE_TIME = 'DEPARTURE_TIME',
  DURATION = 'DURATION',
  FLEXIBLE_CHANGE_POLICIES = 'FLEXIBLE_CHANGE_POLICIES',
  NUM_OF_STOPS = 'NUM_OF_STOPS',
  PREFERRED_AIRLINE = 'PREFERRED_AIRLINE'
}
/** Represents the display of progress bar when the results are loading */
export enum FlightsProgressBarDisplay {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED'
}

export enum FlightsSearchFormErrorType {
  CHILD_AGE_MISSING = 'CHILD_AGE_MISSING',
  DATE_BEFORE_PREVIOUS_DATE = 'DATE_BEFORE_PREVIOUS_DATE',
  DATE_NOT_IN_VALID_RANGE = 'DATE_NOT_IN_VALID_RANGE',
  DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE = 'DATE_NOT_IN_VALID_RANGE_TO_DEFAULT_DATE',
  INFANT_AGE_MISSING = 'INFANT_AGE_MISSING',
  INVALID_DATE_FORMAT = 'INVALID_DATE_FORMAT',
  INVALID_TRAVELER_COUNT = 'INVALID_TRAVELER_COUNT',
  LESS_THAN_MINIMUM_ADULT = 'LESS_THAN_MINIMUM_ADULT',
  LOCATION_EMPTY = 'LOCATION_EMPTY',
  LOCATION_SAME = 'LOCATION_SAME',
  MAX_STAY_DURATION_ERROR = 'MAX_STAY_DURATION_ERROR',
  SAME_CITY = 'SAME_CITY',
  SPECIAL_CHARACTER_NOT_ALLOWED = 'SPECIAL_CHARACTER_NOT_ALLOWED',
  TOO_SHORT_AIRPORT_STRING = 'TOO_SHORT_AIRPORT_STRING',
  UNATTENDED_INFANT_IN_LAP = 'UNATTENDED_INFANT_IN_LAP',
  UNATTENDED_INFANT_IN_SEAT = 'UNATTENDED_INFANT_IN_SEAT'
}

export enum RewardsPointSelectionEnum {
  APPLY_REWARD_POINTS = 'APPLY_REWARD_POINTS',
  DO_NOT_APPLY_REWARD_POINTS = 'DO_NOT_APPLY_REWARD_POINTS'
}

export enum CarAccessorySelectionState {
  NOT_SELECTED = 'NOT_SELECTED',
  SELECTED = 'SELECTED'
}

export enum CarActionType {
  APPLY_LOYALTY_POINTS = 'APPLY_LOYALTY_POINTS',
  CAR_MAP_MARKER = 'CAR_MAP_MARKER',
  DISMISS = 'DISMISS',
  GO_BACK_TO_SEARCH = 'GO_BACK_TO_SEARCH',
  GO_TO_CHECKOUT = 'GO_TO_CHECKOUT',
  GO_TO_CLEANLINESS_DIALOG = 'GO_TO_CLEANLINESS_DIALOG',
  GO_TO_DETAILS = 'GO_TO_DETAILS',
  GO_TO_PACKAGES = 'GO_TO_PACKAGES',
  GO_TO_RECOMMENDED_SORT_FAQ = 'GO_TO_RECOMMENDED_SORT_FAQ',
  GO_TO_SIGNIN = 'GO_TO_SIGNIN',
  GO_TO_SIGNUP = 'GO_TO_SIGNUP',
  LOAD_MORE = 'LOAD_MORE',
  OPEN_DIALOG = 'OPEN_DIALOG',
  OPEN_NEW_TAB = 'OPEN_NEW_TAB',
  OPEN_ON_CURRENT_TAB = 'OPEN_ON_CURRENT_TAB',
  REFRESH = 'REFRESH',
  REMOVE_LOYALTY_POINTS = 'REMOVE_LOYALTY_POINTS',
  SEE_CARS_AT_MAP_MARKER = 'SEE_CARS_AT_MAP_MARKER',
  SHARE_FEEDBACK = 'SHARE_FEEDBACK',
  SHOW_FREE_CANCELLATION_OFFERS = 'SHOW_FREE_CANCELLATION_OFFERS',
  UNLOCK_CAR_SALES = 'UNLOCK_CAR_SALES'
}

export enum CarMapMarkerType {
  CarMarker = 'CarMarker',
  PlaceMarker = 'PlaceMarker'
}

export enum CarLabelTheme {
  CLICKABLE = 'CLICKABLE'
}

export enum InsuranceListLayout {
  MULTI_COLUMNS = 'MULTI_COLUMNS',
  SINGLE_COLUMN = 'SINGLE_COLUMN'
}

export enum InsuranceListType {
  ORDERED = 'ORDERED',
  UNORDERED = 'UNORDERED'
}

export enum InsuranceMessageType {
  ERROR = 'ERROR',
  INFO = 'INFO',
  WARNING = 'WARNING'
}

export enum InsurancePhrasePartStyle {
  COLOR_GREEN = 'COLOR_GREEN',
  COLOR_RED = 'COLOR_RED',
  EMPHASIS = 'EMPHASIS',
  IMPORTANT = 'IMPORTANT',
  STANDARD = 'STANDARD'
}

export enum InsuranceListTypeOld {
  ICON = 'ICON',
  NUMBERED = 'NUMBERED'
}

export enum PoiMapItemCategory {
  ACTIVITY = 'ACTIVITY',
  RESTAURANT = 'RESTAURANT'
}

export enum UserCoordinateType {
  AIRPORT = 'AIRPORT',
  PROPERTY = 'PROPERTY'
}
/** Enum of the units of measure and their abbreviations */
export enum DistanceUnit {
  KILOMETER = 'KILOMETER',
  MILE = 'MILE'
}

export enum PoiMapItemCardType {
  POI_MAP_ITEM_SUMMARY_CARD = 'POI_MAP_ITEM_SUMMARY_CARD'
}

export enum PoiMapPinType {
  AIRPORT = 'AIRPORT',
  POI = 'POI',
  PROPERTY = 'PROPERTY'
}
/** ID used to identify a month for queries that bucket data by month */
export enum MonthId {
  APRIL = 'APRIL',
  AUGUST = 'AUGUST',
  DECEMBER = 'DECEMBER',
  FEBRUARY = 'FEBRUARY',
  JANUARY = 'JANUARY',
  JULY = 'JULY',
  JUNE = 'JUNE',
  MARCH = 'MARCH',
  MAY = 'MAY',
  NOVEMBER = 'NOVEMBER',
  OCTOBER = 'OCTOBER',
  SEPTEMBER = 'SEPTEMBER'
}

export enum ProductType {
  ARTICLE = 'ARTICLE',
  CAR_DETAILS = 'CAR_DETAILS',
  DESTINATION = 'DESTINATION',
  DESTINATION_EXPERIENCE = 'DESTINATION_EXPERIENCE',
  EXPERIENCE = 'EXPERIENCE',
  EXPERT_TIP = 'EXPERT_TIP',
  FLIGHT_SEARCH = 'FLIGHT_SEARCH',
  LX_DETAILS = 'LX_DETAILS',
  NEIGHBORHOOD = 'NEIGHBORHOOD',
  POI_GAIA = 'POI_GAIA',
  PROPERTY_DETAILS = 'PROPERTY_DETAILS'
}

export enum FooterButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY',
  TERTIARY = 'TERTIARY'
}

export enum FooterSeparatorType {
  HORIZONTAL_RULE = 'HORIZONTAL_RULE'
}

export enum PageId {
  ACTIVITY = 'ACTIVITY',
  CAR = 'CAR',
  CRUISE = 'CRUISE',
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL',
  PACKAGE = 'PACKAGE',
  UNKNOWN = 'UNKNOWN'
}

export enum HeaderViewSize {
  EXTRA_LARGE = 'EXTRA_LARGE',
  LARGE = 'LARGE',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL'
}

export enum HeaderButtonType {
  PRIMARY = 'PRIMARY',
  TERTIARY = 'TERTIARY'
}

export enum HeaderItemPosition {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}

export enum HeaderTextType {
  HEADING = 'HEADING',
  SUBHEADING = 'SUBHEADING'
}

export enum HeaderSeparatorType {
  HORIZONTAL_RULE = 'HORIZONTAL_RULE'
}

export enum PickerTriggerPlacementType {
  MENU_ITEM = 'MENU_ITEM',
  NAV_LINK = 'NAV_LINK'
}

export enum PickerTriggerDisplayType {
  GLOBAL_NAV_BUTTON = 'GLOBAL_NAV_BUTTON',
  GLOBAL_NAV_LINK = 'GLOBAL_NAV_LINK'
}

export enum MemberWalletBadgeTheme {
  LOYALTY_HIGH_TIER = 'LOYALTY_HIGH_TIER',
  LOYALTY_LOW_TIER = 'LOYALTY_LOW_TIER',
  LOYALTY_MIDDLE_TIER = 'LOYALTY_MIDDLE_TIER'
}

export enum PropertyFilterAccessibility {
  ACCESSIBLE_BATHROOM = 'ACCESSIBLE_BATHROOM',
  IN_ROOM_ACCESSIBLE = 'IN_ROOM_ACCESSIBLE',
  ROLL_IN_SHOWER = 'ROLL_IN_SHOWER'
}

export enum AgencyBusinessModel {
  EXPEDIA_COLLECT = 'EXPEDIA_COLLECT',
  HOTEL_COLLECT = 'HOTEL_COLLECT'
}

export enum PropertyFilterAmenity {
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  BEACH = 'BEACH',
  CASINO = 'CASINO',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_PARKING = 'FREE_PARKING',
  GOLF = 'GOLF',
  HOT_SPRING = 'HOT_SPRING',
  HOT_TUB = 'HOT_TUB',
  KITCHEN_KITCHEN = 'KITCHEN_KITCHEN',
  KITCHEN_KITCHENETTE = 'KITCHEN_KITCHENETTE',
  OCEAN_VIEW = 'OCEAN_VIEW',
  PETS = 'PETS',
  POOL = 'POOL',
  SPA_ON_SITE = 'SPA_ON_SITE',
  WASHER_DRYER = 'WASHER_DRYER',
  WATER_PARK = 'WATER_PARK',
  WIFI = 'WIFI'
}

export enum CleaningAndSafetyPractice {
  ENHANCED_CLEANING = 'ENHANCED_CLEANING'
}

export enum CommissionTier {
  BASIC = 'BASIC',
  BASIC_PLUS = 'BASIC_PLUS',
  PREMIUM = 'PREMIUM',
  PREMIUM_PLUS = 'PREMIUM_PLUS'
}

export enum DealType {
  AARP = 'AARP'
}

export enum MealPlanFilterAmenity {
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FULL_BOARD = 'FULL_BOARD',
  HALF_BOARD = 'HALF_BOARD'
}

export enum PaymentType {
  COUPON_ELIGIBLE = 'COUPON_ELIGIBLE',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  PAY_LATER = 'PAY_LATER',
  PAY_LATER_WITH_DEPOSIT = 'PAY_LATER_WITH_DEPOSIT',
  PAY_WITHOUT_CREDITCARD = 'PAY_WITHOUT_CREDITCARD'
}

export enum PropertyStyle {
  BOUTIQUE = 'BOUTIQUE',
  HOMES = 'HOMES',
  HOTELS = 'HOTELS',
  LGBT = 'LGBT',
  LUXURY = 'LUXURY',
  OUTDOOR = 'OUTDOOR',
  UNIQUE = 'UNIQUE'
}

export enum StructureType {
  AGRITOURISM = 'AGRITOURISM',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  APARTMENT = 'APARTMENT',
  APART_HOTEL = 'APART_HOTEL',
  BED_AND_BREAKFAST = 'BED_AND_BREAKFAST',
  CABIN = 'CABIN',
  CAPSULE_HOTEL = 'CAPSULE_HOTEL',
  CARAVAN_PARK = 'CARAVAN_PARK',
  CASTLE = 'CASTLE',
  CHALET = 'CHALET',
  CONDO = 'CONDO',
  CONDO_RESORT = 'CONDO_RESORT',
  COTTAGE = 'COTTAGE',
  COUNTRY_HOUSE = 'COUNTRY_HOUSE',
  CRUISE = 'CRUISE',
  ECO_HOTEL = 'ECO_HOTEL',
  GUEST_HOUSE = 'GUEST_HOUSE',
  HOLIDAY_PARK = 'HOLIDAY_PARK',
  HOSTAL = 'HOSTAL',
  HOSTEL = 'HOSTEL',
  HOTEL = 'HOTEL',
  HOTEL_RESORT = 'HOTEL_RESORT',
  HOUSE_BOAT = 'HOUSE_BOAT',
  INN = 'INN',
  LODGE = 'LODGE',
  LONGHOUSE = 'LONGHOUSE',
  MOTEL = 'MOTEL',
  OVERWATER = 'OVERWATER',
  PALACE = 'PALACE',
  PENSION = 'PENSION',
  POUSADA_BRAZIL = 'POUSADA_BRAZIL',
  POUSADA_PORTUGAL = 'POUSADA_PORTUGAL',
  RANCH = 'RANCH',
  RESIDENCE = 'RESIDENCE',
  RIAD = 'RIAD',
  RYOKAN = 'RYOKAN',
  SAFARI = 'SAFARI',
  SERVICED_APARTMENT = 'SERVICED_APARTMENT',
  TOWNHOUSE = 'TOWNHOUSE',
  TRADITIONAL_BUILDING = 'TRADITIONAL_BUILDING',
  TREE_HOUSE = 'TREE_HOUSE',
  UNKNOWN = 'UNKNOWN',
  VACATION_HOME = 'VACATION_HOME',
  VILLA = 'VILLA',
  VIP = 'VIP'
}

export enum TravelerType {
  BUSINESS = 'BUSINESS',
  FAMILY = 'FAMILY',
  ROMANTIC = 'ROMANTIC'
}
/** Search options that are not filters. Previously these were a large set of boolean flags in ExpWeb called `searchOptions` */
export enum PropertySearchOptions {
  ADS_ONLY = 'ADS_ONLY',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}
/** Hotel sort types */
export enum PropertySort {
  AARP_MEMBER_DISCOUNT = 'AARP_MEMBER_DISCOUNT',
  BEST_DEAL = 'BEST_DEAL',
  DISTANCE = 'DISTANCE',
  MEMBER_PRICING = 'MEMBER_PRICING',
  PRICE_HIGH_TO_LOW = 'PRICE_HIGH_TO_LOW',
  PRICE_LOW_TO_HIGH = 'PRICE_LOW_TO_HIGH',
  PRICE_RELEVANT = 'PRICE_RELEVANT',
  PROPERTY_CLASS = 'PROPERTY_CLASS',
  PROPERTY_NAME = 'PROPERTY_NAME',
  RECOMMENDED = 'RECOMMENDED',
  REVIEW = 'REVIEW',
  VACATION_RENTAL = 'VACATION_RENTAL'
}
/** Options that are not filters. Refer @code { SearchOptions } */
export enum PropertyInfoOptions {
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}

export enum PackageType {
  FLIGHT_CAR = 'FLIGHT_CAR',
  FLIGHT_HOTEL = 'FLIGHT_HOTEL',
  FLIGHT_HOTEL_CAR = 'FLIGHT_HOTEL_CAR',
  HOTEL_CAR = 'HOTEL_CAR'
}

export enum LodgingType {
  CONVENTIONAL = 'CONVENTIONAL',
  UNKNOWN = 'UNKNOWN',
  UNRECOGNIZED = 'UNRECOGNIZED',
  VACATION_RENTAL_MULTI_UNIT = 'VACATION_RENTAL_MULTI_UNIT',
  VACATION_RENTAL_SINGLE_UNIT = 'VACATION_RENTAL_SINGLE_UNIT'
}
/** Used to indicate what type of markup a field contains */
export enum MarkupTextType {
  HTML = 'HTML'
}

export enum BadgeIcon {
  ACCESS_TIME = 'ACCESS_TIME',
  ADD = 'ADD',
  BUNDLED_SAVINGS_PLUS = 'BUNDLED_SAVINGS_PLUS',
  EXP29639_ORB = 'EXP29639_ORB',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  INFO_OUTLINE = 'INFO_OUTLINE',
  LOB_DEALS = 'LOB_DEALS',
  MOD = 'MOD',
  SMARTPHONE = 'SMARTPHONE'
}

export enum Theme {
  BRAND = 'BRAND',
  BRANDED_DEAL = 'BRANDED_DEAL',
  DEAL_ADD_ON = 'DEAL_ADD_ON',
  DEAL_BUNDLED = 'DEAL_BUNDLED',
  DEAL_GENERIC = 'DEAL_GENERIC',
  DEAL_MEMBER = 'DEAL_MEMBER',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  INFO = 'INFO',
  LINK = 'LINK',
  LOYALTY = 'LOYALTY',
  LOYALTY_HIGH_TIER = 'LOYALTY_HIGH_TIER',
  LOYALTY_LOW_TIER = 'LOYALTY_LOW_TIER',
  LOYALTY_MIDDLE_TIER = 'LOYALTY_MIDDLE_TIER',
  NOTIFICATION = 'NOTIFICATION',
  SAVED = 'SAVED',
  SPONSORED = 'SPONSORED',
  SUCCESS = 'SUCCESS',
  SUCCESS_MEDIUM = 'SUCCESS_MEDIUM',
  SUPPLIER_PROMO = 'SUPPLIER_PROMO',
  URGENT = 'URGENT',
  VIEWED = 'VIEWED',
  VIP = 'VIP',
  VIP_ACCESS = 'VIP_ACCESS'
}
/** Theme information for a message. */
export enum LodgingMessageTheme {
  AGGRESSIVE = 'AGGRESSIVE',
  HIGHLIGHT = 'HIGHLIGHT',
  STRONG = 'STRONG'
}
/** Describes what kind of action being described. Copy for example describes thecoupon code copy behavior. Authwindow shows the login/signup dialog. */
export enum ActionDetailsType {
  AUTHWINDOW = 'AUTHWINDOW',
  COPY = 'COPY',
  DATEPICKER = 'DATEPICKER',
  EXTERNAL_LINK = 'EXTERNAL_LINK',
  FREE_LX = 'FREE_LX',
  OPEN = 'OPEN',
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS'
}
/** Unique identifier for a message if one needs to identify the reason for the message creation */
export enum MessageType {
  ADDON = 'ADDON',
  COMPRESSION = 'COMPRESSION',
  COUPON = 'COUPON',
  DOUBLE_POINTS = 'DOUBLE_POINTS',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  FREE_LX = 'FREE_LX',
  HOTRATE = 'HOTRATE',
  LEGAL = 'LEGAL',
  LOGIN = 'LOGIN',
  LOYALTY = 'LOYALTY',
  NO_CC = 'NO_CC',
  OVERFILTERED = 'OVERFILTERED',
  PARTNER_LINKOFF = 'PARTNER_LINKOFF',
  VACATION_RENTALS = 'VACATION_RENTALS'
}

export enum AmenityCategory {
  ACCESSIBLE_ROLL_IN_SHOWER = 'ACCESSIBLE_ROLL_IN_SHOWER',
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  ARCADE = 'ARCADE',
  BABYSITTING = 'BABYSITTING',
  BAR = 'BAR',
  BOWLING = 'BOWLING',
  BREAKFAST_AVAILABLE = 'BREAKFAST_AVAILABLE',
  BREAKFAST_NOT_AVAILABLE = 'BREAKFAST_NOT_AVAILABLE',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CHILDREN_CLUB = 'CHILDREN_CLUB',
  DAILY_HOUSEKEEPING = 'DAILY_HOUSEKEEPING',
  EXTRA_BED = 'EXTRA_BED',
  FITNESS_EQUIPMENT = 'FITNESS_EQUIPMENT',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_CANCEL = 'FREE_CANCEL',
  FREE_PARKING = 'FREE_PARKING',
  FREE_WELCOME_DRINK = 'FREE_WELCOME_DRINK',
  FREE_WIRED_INTERNET = 'FREE_WIRED_INTERNET',
  FRONT_DESK_24_HOURS = 'FRONT_DESK_24_HOURS',
  GROCERY = 'GROCERY',
  HIGH_SPEED_INTERNET = 'HIGH_SPEED_INTERNET',
  HOT_TUB = 'HOT_TUB',
  INTERNET_NOT_AVAILABLE = 'INTERNET_NOT_AVAILABLE',
  IN_ROOM_INTERNET = 'IN_ROOM_INTERNET',
  KIDS_POOL = 'KIDS_POOL',
  KITCHEN = 'KITCHEN',
  LAUNDRY = 'LAUNDRY',
  LIVING_AREA = 'LIVING_AREA',
  MICROWAVE = 'MICROWAVE',
  MINI_GOLF = 'MINI_GOLF',
  NON_REFUNDABLE = 'NON_REFUNDABLE',
  ON_PRIVATE_BEACH = 'ON_PRIVATE_BEACH',
  ON_THE_BEACH = 'ON_THE_BEACH',
  PARKING = 'PARKING',
  PETS_ALLOWED = 'PETS_ALLOWED',
  PLAYGROUND = 'PLAYGROUND',
  POOL = 'POOL',
  RESERVE_NOW_PAY_DEPOSIT = 'RESERVE_NOW_PAY_DEPOSIT',
  RESERVE_NOW_PAY_LATER = 'RESERVE_NOW_PAY_LATER',
  RESTAURANT_IN_HOTEL = 'RESTAURANT_IN_HOTEL',
  ROOM_SERVICE = 'ROOM_SERVICE',
  SMOKE_FREE = 'SMOKE_FREE',
  SOUNDPROOF_ROOM = 'SOUNDPROOF_ROOM',
  SPA_SERVICES_ON_SITE = 'SPA_SERVICES_ON_SITE',
  SPECIAL_DEAL = 'SPECIAL_DEAL',
  TENNIS_COURT = 'TENNIS_COURT',
  TOYS = 'TOYS',
  WATERSLIDE = 'WATERSLIDE',
  WIFI_SURCHARGE = 'WIFI_SURCHARGE',
  WIRED_INTERNET_SURCHARGE = 'WIRED_INTERNET_SURCHARGE'
}

export enum PropertyPaymentType {
  PAY_LATER = 'PAY_LATER',
  PAY_LATER_WITH_DEPOSIT = 'PAY_LATER_WITH_DEPOSIT',
  PAY_NOW = 'PAY_NOW'
}

export enum LodgingInputType {
  EMAIL = 'EMAIL',
  HIDDEN = 'HIDDEN',
  PASSWORD = 'PASSWORD',
  TEL = 'TEL',
  TEXT = 'TEXT',
  URL = 'URL'
}

export enum LodgingFormMethod {
  GET = 'GET',
  POST = 'POST'
}

export enum PropertyCancellationPolicyType {
  NON_REFUNDABLE = 'NON_REFUNDABLE',
  REFUNDABLE_WITH_NO_PENALTY = 'REFUNDABLE_WITH_NO_PENALTY',
  REFUNDABLE_WITH_PENALTY = 'REFUNDABLE_WITH_PENALTY'
}

export enum RateDiscountType {
  MEMBER_DEAL = 'MEMBER_DEAL',
  MOBILE_EXCLUSIVE = 'MOBILE_EXCLUSIVE',
  REGULAR = 'REGULAR',
  TONIGHT_ONLY = 'TONIGHT_ONLY'
}

export enum FeeType {
  DEFAULT = 'DEFAULT',
  DEFAULT_SUPPLIER_COLLECTED = 'DEFAULT_SUPPLIER_COLLECTED',
  GROUPED_MANDATORY_FEES = 'GROUPED_MANDATORY_FEES',
  L26_TAX_BREAKOUT = 'L26_TAX_BREAKOUT',
  NORMAL = 'NORMAL',
  OTHER = 'OTHER',
  PER_PERSON_PER_NIGHT = 'PER_PERSON_PER_NIGHT',
  PROPERTY = 'PROPERTY',
  REFUNDABLE_DAMAGE_DEPOSIT = 'REFUNDABLE_DAMAGE_DEPOSIT',
  RESORT = 'RESORT'
}

export enum PropertyPaymentModel {
  PAY_LATER = 'PAY_LATER',
  PAY_LATER_WITH_DEPOSIT = 'PAY_LATER_WITH_DEPOSIT',
  PAY_NOW = 'PAY_NOW'
}

export enum StrikeOutType {
  ATTACH = 'ATTACH',
  INVALID = 'INVALID',
  LOYALTY = 'LOYALTY',
  PACKAGE = 'PACKAGE',
  PRICE_SURVEY = 'PRICE_SURVEY',
  STANDALONE = 'STANDALONE'
}

export enum PricingSchemeType {
  DAILY_RATE = 'DAILY_RATE',
  TOTAL_RATE = 'TOTAL_RATE'
}

export enum SourceType {
  ESR = 'ESR',
  GDS = 'GDS'
}

export enum PropertySectionRef {
  RECOMMENDED_OFFER = 'RECOMMENDED_OFFER',
  ROOMS_AND_RATES = 'ROOMS_AND_RATES'
}
/** Filters review results by category type */
export enum PropertyReviewCategory {
  BUSINESS_TRAVELERS = 'BUSINESS_TRAVELERS',
  COUPLES = 'COUPLES',
  EVERYONE = 'EVERYONE',
  FAMILIES = 'FAMILIES',
  GETAWAY_WITH_FRIENDS = 'GETAWAY_WITH_FRIENDS',
  GOLF = 'GOLF',
  OTHER = 'OTHER',
  OVERNIGHT_STAY = 'OVERNIGHT_STAY',
  PERSONAL_EVENT = 'PERSONAL_EVENT',
  SHOPPING = 'SHOPPING',
  SPA = 'SPA',
  STUDENTS = 'STUDENTS'
}
/** [Optional] Review filter type */
export enum PropertyReviewType {
  CRITICAL = 'CRITICAL',
  POSITIVE = 'POSITIVE',
  RECENT = 'RECENT'
}
/** [Optional] Hotel reviews sort types. Defaults to NEWEST_TO_OLDEST_BY_LANGUAGE */
export enum PropertyReviewSort {
  HIGHEST_TO_LOWEST_RATED = 'HIGHEST_TO_LOWEST_RATED',
  LOWEST_TO_HIGHEST_RATED = 'LOWEST_TO_HIGHEST_RATED',
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST',
  NEWEST_TO_OLDEST_BY_LANGUAGE = 'NEWEST_TO_OLDEST_BY_LANGUAGE',
  OLDEST_TO_NEWEST = 'OLDEST_TO_NEWEST',
  OLDEST_TO_NEWEST_BY_LANGUAGE = 'OLDEST_TO_NEWEST_BY_LANGUAGE'
}
/** Type that represents the amenity category icons for the property */
export enum PropertyAmenityCategoryType {
  ACCESSIBLE_ROLL_IN_SHOWER = 'ACCESSIBLE_ROLL_IN_SHOWER',
  AIR_CONDITIONING = 'AIR_CONDITIONING',
  ALL_INCLUSIVE = 'ALL_INCLUSIVE',
  ARCADE = 'ARCADE',
  BABYSITTING = 'BABYSITTING',
  BAR = 'BAR',
  BOWLING = 'BOWLING',
  BREAKFAST_AVAILABLE = 'BREAKFAST_AVAILABLE',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CHILDREN_CLUB = 'CHILDREN_CLUB',
  DAILY_HOUSEKEEPING = 'DAILY_HOUSEKEEPING',
  EXTRA_BED = 'EXTRA_BED',
  FITNESS_EQUIPMENT = 'FITNESS_EQUIPMENT',
  FREE_AIRPORT_TRANSPORTATION = 'FREE_AIRPORT_TRANSPORTATION',
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_PARKING = 'FREE_PARKING',
  FREE_WELCOME_DRINK = 'FREE_WELCOME_DRINK',
  FRONT_DESK_24_HOURS = 'FRONT_DESK_24_HOURS',
  GROCERY = 'GROCERY',
  HIGH_SPEED_INTERNET = 'HIGH_SPEED_INTERNET',
  HOT_TUB = 'HOT_TUB',
  IN_ROOM_INTERNET = 'IN_ROOM_INTERNET',
  KIDS_POOL = 'KIDS_POOL',
  KITCHEN = 'KITCHEN',
  LAUNDRY = 'LAUNDRY',
  LIVING_AREA = 'LIVING_AREA',
  MICROWAVE = 'MICROWAVE',
  MINI_GOLF = 'MINI_GOLF',
  PARKING = 'PARKING',
  PETS_ALLOWED = 'PETS_ALLOWED',
  PLAYGROUND = 'PLAYGROUND',
  POOL = 'POOL',
  RESTAURANT_IN_HOTEL = 'RESTAURANT_IN_HOTEL',
  ROOM_SERVICE = 'ROOM_SERVICE',
  SMOKE_FREE = 'SMOKE_FREE',
  SOUNDPROOF_ROOM = 'SOUNDPROOF_ROOM',
  SPA_SERVICES_ON_SITE = 'SPA_SERVICES_ON_SITE',
  SPECIAL_DEAL = 'SPECIAL_DEAL',
  TENNIS_COURT = 'TENNIS_COURT',
  TOYS = 'TOYS',
  WATERSLIDE = 'WATERSLIDE'
}

export enum PropertyAmenityType {
  ACCESSIBILITY = 'ACCESSIBILITY',
  BATHROOM = 'BATHROOM',
  BEDROOM = 'BEDROOM',
  BUSINESS_SERVICES = 'BUSINESS_SERVICES',
  CONVENIENCES = 'CONVENIENCES',
  ENTERTAINMENT = 'ENTERTAINMENT',
  FAMILY_FRIENDLY = 'FAMILY_FRIENDLY',
  FOOD_DRINK = 'FOOD_DRINK',
  GUEST_SERVICES = 'GUEST_SERVICES',
  INTERNET = 'INTERNET',
  MORE = 'MORE',
  OUTDOOR = 'OUTDOOR',
  OUTDOOR_SPACE = 'OUTDOOR_SPACE',
  PARKING = 'PARKING',
  PROPERTY = 'PROPERTY',
  ROOM = 'ROOM',
  SPA = 'SPA',
  THINGS_TO_DO = 'THINGS_TO_DO'
}
/** The UDS icon used for the map marker */
export enum MapIconType {
  AIRPORT = 'AIRPORT',
  CIRCLE = 'CIRCLE',
  HOTEL = 'HOTEL',
  LANDMARK = 'LANDMARK',
  METRO = 'METRO',
  RESTAURANT = 'RESTAURANT',
  SOLD_OUT = 'SOLD_OUT',
  TRAIN = 'TRAIN'
}
/** The type of map marker */
export enum MarkerType {
  HOTEL = 'HOTEL',
  POI = 'POI'
}
/** ADs related property search options */
export enum Listings {
  ADS_ONLY = 'ADS_ONLY'
}
/** Points related property search options */
export enum Points {
  SHOP_WITHOUT_POINTS = 'SHOP_WITHOUT_POINTS',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}

export enum OfferAttributeType {
  FREE_BREAKFAST = 'FREE_BREAKFAST',
  FREE_CANCELLATION = 'FREE_CANCELLATION',
  NO_CC_REQUIRED = 'NO_CC_REQUIRED',
  PAYMENT_CHOICE = 'PAYMENT_CHOICE',
  VIP = 'VIP'
}

export enum PropertyPaymentFlags {
  ARTIFICIALLY_FENCED_RATE = 'ARTIFICIALLY_FENCED_RATE',
  MIXED_RATE_PLAN = 'MIXED_RATE_PLAN',
  NO_CREDIT_CARD = 'NO_CREDIT_CARD'
}
/** Describes the type of product (line of business) that is being sold */
export enum LodgingCrossSellProductType {
  CAR = 'CAR'
}
/** A rough measure of the percentage of properties that are sold out in thedestination region as calculated by the Urgency Service. */
export enum CompressionLevel {
  CAP = 'CAP',
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  NA = 'NA'
}

export enum CampaignProductType {
  FLIGHT = 'FLIGHT',
  HOTEL = 'HOTEL',
  PACKAGE = 'PACKAGE'
}

export enum RecommendedType {
  BESPOKE = 'BESPOKE',
  DESTINATIONS = 'DESTINATIONS',
  OFFERS = 'OFFERS'
}

export enum CampaignOfferBadgeType {
  DEFAULT = 'DEFAULT',
  DISCOUNT = 'DISCOUNT'
}

export enum ProductQuestionTopic {
  HOTEL = 'HOTEL'
}

export enum QuestionSortType {
  NEWEST_TO_OLDEST = 'NEWEST_TO_OLDEST',
  OLDEST_TO_NEWEST = 'OLDEST_TO_NEWEST'
}

export enum KeyPhrasesClientType {
  DEFAULT = 'DEFAULT',
  FILTER = 'FILTER',
  SNIPPET = 'SNIPPET'
}

export enum CartFlightSearchType {
  MULTI_CITY = 'MULTI_CITY',
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP'
}

export enum CartTtl {
  FIVE_MINUTES = 'FIVE_MINUTES',
  SEVEN_DAYS = 'SEVEN_DAYS',
  TWELVE_HOURS = 'TWELVE_HOURS'
}
/** Supported Features on prepareCheckout */
export enum CheckoutOptionType {
  FENCING_ATTRIBUTES = 'FENCING_ATTRIBUTES',
  SHOP_WITH_POINTS = 'SHOP_WITH_POINTS'
}

export enum CheckoutServiceResult {
  FAILURE = 'FAILURE',
  SUCCESS = 'SUCCESS'
}

export enum PaymentTokenType {
  CREDIT_CARD = 'CREDIT_CARD',
  STORED_CARD = 'STORED_CARD'
}

export enum LineOfBusiness {
  HOTEL = 'HOTEL'
}

export enum PaymentOptionType {
  CREDIT_CARD = 'CREDIT_CARD',
  STORED_CARD = 'STORED_CARD'
}

export enum CustomerNotificationMessageType {
  INVALID_INPUT = 'INVALID_INPUT',
  SERVICE_ERROR = 'SERVICE_ERROR',
  SUCCESS = 'SUCCESS'
}

export enum InsuranceMutationStatus {
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS'
}

export enum InsuranceMutationType {
  ADD_INSURANCE = 'ADD_INSURANCE',
  REMOVE_INSURANCE = 'REMOVE_INSURANCE'
}

export enum Result {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}

export enum ConversationsOperationResult {
  ERROR = 'ERROR',
  SUCCESS = 'SUCCESS'
}

export enum Severity {
  ERROR = 'ERROR',
  WARNING = 'WARNING'
}

export enum FeedbackPlacement {
  FIELD = 'FIELD',
  MODULE = 'MODULE',
  PAGE = 'PAGE'
}

export enum ButtonType {
  PRIMARY = 'PRIMARY',
  SECONDARY = 'SECONDARY'
}

export enum CheckoutModule {
  INSURANCE = 'INSURANCE',
  NONE = 'NONE',
  PAYMENTS = 'PAYMENTS'
}

export enum BadgeTheme {
  DEAL_GENERIC = 'DEAL_GENERIC'
}
/** Ids of inputs that can currently exist as input in special requests */
export enum CheckoutSpecialRequestInputIds {
  ACCESSIBILITY_INPUT = 'ACCESSIBILITY_INPUT',
  BEDDING_INPUT = 'BEDDING_INPUT',
  SMOKING_INPUT = 'SMOKING_INPUT',
  SPECIAL_REQUEST_TEXT = 'SPECIAL_REQUEST_TEXT'
}
/** Types of html element inputs for special requests elements */
export enum CheckoutSpecialRequestInputElementType {
  CHECKBOX = 'CHECKBOX',
  SELECT = 'SELECT',
  TEXTAREA = 'TEXTAREA'
}
/** Types of html elements for special requests */
export enum CheckoutSpecialRequestElementType {
  EXPANDO_LINK = 'EXPANDO_LINK',
  HEADING = 'HEADING'
}
/** Indicates the type of intent. */
export enum ChatBotIntentType {
  CANCEL = 'CANCEL',
  CHANGE = 'CHANGE',
  VIEW_BOOKING = 'VIEW_BOOKING'
}
/** Indicates the type of product. */
export enum ChatBotProductType {
  FLIGHT = 'FLIGHT'
}
/** Indicates the waiver redemption state. */
export enum ChatBotWaiverRedemptionState {
  CREDIT_REDEMPTION = 'CREDIT_REDEMPTION'
}
/** The button type of the Customer notification submit button */
export enum CustomerNotificationFormButtonType {
  FLOATING_ACTION_BUTTON = 'FLOATING_ACTION_BUTTON',
  PRIMARY_BUTTON = 'PRIMARY_BUTTON',
  SECONDARY_BUTTON = 'SECONDARY_BUTTON',
  TERTIARY_BUTTON = 'TERTIARY_BUTTON'
}

export enum FlightCabinClassInfo {
  BUSINESS = 'BUSINESS',
  COACH = 'COACH',
  FIRST = 'FIRST',
  PREMIUM_ECONOMY = 'PREMIUM_ECONOMY'
}

export enum FlightsFlexibleSearchHeaderCellTheme {
  DEFAULT = 'DEFAULT',
  SEARCHED_DATE_HEADER = 'SEARCHED_DATE_HEADER'
}

export enum FlightsFlexibleSearchLegendCellTheme {
  DEFAULT = 'DEFAULT'
}

export enum FlightsFlexibleSearchResultCellTheme {
  DEFAULT_PRICE = 'DEFAULT_PRICE',
  HIGHEST_PRICE = 'HIGHEST_PRICE',
  LOWEST_PRICE = 'LOWEST_PRICE',
  NO_PRICE = 'NO_PRICE',
  SEARCHED_DATE = 'SEARCHED_DATE',
  SEARCHED_DATE_LOWEST_PRICE = 'SEARCHED_DATE_LOWEST_PRICE',
  SEARCHED_DATE_NO_PRICE = 'SEARCHED_DATE_NO_PRICE',
  SEARCHED_DATE_UNAVAILABLE_FLIGHTS = 'SEARCHED_DATE_UNAVAILABLE_FLIGHTS',
  UNAVAILABLE_FLIGHTS = 'UNAVAILABLE_FLIGHTS'
}

export enum RouteType {
  MULTI_DESTINATION = 'MULTI_DESTINATION',
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP'
}

// ====================================================
// END: Typescript template
// ====================================================

// ====================================================
// Documents
// ====================================================

export namespace FlightsFlexibleSearch {
  export type Variables = {
    context: ContextInput;
    flightsSearchContext?: FlightsSearchContextInput | null;
    journeyCriteria: FlightsJourneyCriteriaInput[];
    queryState?: FlightsQueryState | null;
    searchPreferences?: FlightsSearchPreferencesInput | null;
    travelerDetails?: FlightsTravelerDetailsInput[] | null;
  };

  export type Query = {
    __typename?: 'Query';

    flightsSearch: FlightsSearch;
  };

  export type FlightsSearch = {
    __typename?: 'FlightsSearchResponse';

    flexibleSearchResponse?: FlexibleSearchResponse | null;
  };

  export type FlexibleSearchResponse = {
    __typename?: 'FlightsFlexibleSearchResponse';

    title: string;

    subTitle: string;

    titleAccessibility: string;

    searchTriggerAction?: string | null;

    analytics: Analytics;

    departureLegend?: DepartureLegend | null;

    resultsGrid: ResultsGrid;

    coverageAnalytics: CoverageAnalytics;

    gridTrigger?: GridTrigger | null;
  };

  export type Analytics = {
    __typename?: 'FlightsFlexibleSearchResponseAnalytics';

    priceFillRate: string;
  };

  export type DepartureLegend = {
    __typename?: 'FlightsFlexibleSearchGridLegendBadge';

    icon?: Icon | null;

    labelText?: string | null;

    accessibility: string;
  };

  export type Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;
  };

  export type ResultsGrid = {
    __typename?: 'FlightsFlexibleSearchResultsGrid';

    results: Results[][];
  };

  export type Results =
    | FlightsFlexSearchHeaderCell.Fragment
    | FlightsFlexSearchLegendCell.Fragment
    | FlightsFlexSearchResults.Fragment;

  export type CoverageAnalytics = FlightsAnalyticsFlexSearch.Fragment;

  export type GridTrigger = {
    __typename?: 'FlightsFlexibleSearchGridTrigger';

    collapseAnalytics: CollapseAnalytics;

    expandAnalytics: ExpandAnalytics;
  };

  export type CollapseAnalytics = FlightsAnalyticsFlexSearch.Fragment;

  export type ExpandAnalytics = FlightsAnalyticsFlexSearch.Fragment;
}

export namespace FlightsShoppingPwaFlightInformationResults {
  export type Variables = {
    context: ContextInput;
    flightsDetailCriteria: FlightsDetailCriteriaInput;
    queryState?: FlightsQueryState | null;
  };

  export type Query = {
    __typename?: 'Query';

    flightsDetail: FlightsDetail;
  };

  export type FlightsDetail = {
    __typename?: 'FlightsInformationResponse';

    analytics?: Analytics | null;

    clientMetadata?: ClientMetadata | null;

    flightsOpinionLab?: FlightsOpinionLab | null;

    pageTitle?: PageTitle | null;

    messagingCards?: MessagingCards[] | null;

    banners?: Banners[] | null;

    freeCancellation?: FreeCancellation | null;

    flightsSelectedJourneyReview?: FlightsSelectedJourneyReview[] | null;

    priceSummary?: PriceSummary | null;

    separateTicketBanner?: SeparateTicketBanner | null;

    brandPolicies?: BrandPolicies | null;

    serverErrorMessaging?: ServerErrorMessaging | null;

    dynamicElementsGroups?: DynamicElementsGroups[] | null;
  };

  export type Analytics = {
    __typename?: 'FlightsInformationAnalytics';

    footerOnViewedAnalytics?: FooterOnViewedAnalytics | null;
  };

  export type FooterOnViewedAnalytics = FlightsAnalyticsInformationLoaded.Fragment;

  export type ClientMetadata = FlightsPwaMetadataInlineFragment;

  export type FlightsPwaMetadataInlineFragment = {
    __typename?: 'FlightsPWAMetadata';

    pageName: string;

    pageNameAnalytics: PageNameAnalytics;
  };

  export type PageNameAnalytics = FlightsAnalyticsInformationLoaded.Fragment;

  export type FlightsOpinionLab = FlightsActionAndLabelInlineFragment;

  export type FlightsActionAndLabelInlineFragment = {
    __typename?: 'FlightsActionAndLabel';

    label: string;

    selectAction: SelectAction;
  };

  export type SelectAction = FlightsActionInformationLoaded.Fragment;

  export type PageTitle = FlightsPageTitleInlineFragment;

  export type FlightsPageTitleInlineFragment = {
    __typename?: 'FlightsPageTitle';

    title: Title;

    pageAccessibility?: string | null;
  };

  export type Title = {
    __typename?: 'FlightsResponsiveMessage';

    longMessage: string;

    shortMessage?: string | null;
  };

  export type MessagingCards =
    | FlightsIconPlacardInformationLoaded.Fragment
    | FlightsImagePlacardInformationLoaded.Fragment;

  export type Banners = FlightsIconPlacardInformationLoaded.Fragment;

  export type FreeCancellation = FlightsImagePlacardInformationLoaded.Fragment;

  export type FlightsSelectedJourneyReview = LoadedFlightsSelectedJourneyReviewInlineFragment;

  export type LoadedFlightsSelectedJourneyReviewInlineFragment = {
    __typename?: 'LoadedFlightsSelectedJourneyReview';

    flightsJourneyInformation?: FlightsJourneyInformation | null;

    flightsJourneyHeaders: FlightsJourneyHeaders;

    flightsJourneySummary: FlightsJourneySummary;

    onViewedAnalytics?: OnViewedAnalytics | null;

    changeFlight: ChangeFlight;

    fareDetails: FareDetails;

    flightsJourneyPolicies?: FlightsJourneyPolicies | null;

    journeyInformation?: JourneyInformation | null;

    hygieneAmenitiesPresentation?: HygieneAmenitiesPresentation | null;
  };

  export type FlightsJourneyInformation = {
    __typename?: 'FlightsDetailedJourneyInformation';

    details: Details;

    flightJourneyDetails: FlightJourneyDetails;
  };

  export type Details = FlightsToggleInformationLoaded.Fragment;

  export type FlightJourneyDetails = {
    __typename?: 'FlightsJourneyDetails';

    journeyParts: JourneyParts[];
  };

  export type JourneyParts = {
    __typename?: 'JourneyPart';

    connectionAdditionalInformation?: ConnectionAdditionalInformation | null;

    flightsConnectionInformation: FlightsConnectionInformation;
  };

  export type ConnectionAdditionalInformation = {
    __typename?: 'AdditionalInformation';

    durationAndStop: string;

    nextFlightOriginAirport?: string | null;
  };

  export type FlightsConnectionInformation = {
    __typename?: 'FlightsConnectionInformation';

    flightsConnection: FlightsConnection;

    governmentApprovalMessage?: string | null;
  };

  export type FlightsConnection = {
    __typename?: 'FlightsConnection';

    aircraftModel?: string | null;

    airlineInfo: string;

    cabinClassAndBookingCode: string;

    connectionArrival: ConnectionArrival;

    connectionDeparture: ConnectionDeparture;

    duration: string;

    journeyAmenities?: JourneyAmenities | null;
  };

  export type ConnectionArrival = CoordinateInformationInformationLoaded.Fragment;

  export type ConnectionDeparture = CoordinateInformationInformationLoaded.Fragment;

  export type JourneyAmenities = {
    __typename?: 'FlightsJourneyAmenities';

    accessibilityMessage: string;

    amenities: Amenities[];

    analytics?: _Analytics | null;
  };

  export type Amenities = {
    __typename?: 'FlightsIconAndLabel';

    accessibility?: string | null;

    icon: Icon;

    label: string;
  };

  export type Icon = IconInformationLoaded.Fragment;

  export type _Analytics = FlightsAnalyticsInformationLoaded.Fragment;

  export type FlightsJourneyHeaders = {
    __typename?: 'FlightsJourneyHeaders';

    flightsJourneySubheading: string;

    flightsJourneySubheadingImage?: FlightsJourneySubheadingImage | null;

    heading: string;
  };

  export type FlightsJourneySubheadingImage = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type FlightsJourneySummary = {
    __typename?: FlightsBargainJourneySummaryInlineFragment['__typename'];

    heading: Heading;

    differentDayArrival?: DifferentDayArrival | null;

    basicFlightDetails: BasicFlightDetails[];
  } & FlightsBargainJourneySummaryInlineFragment;

  export type Heading = FlightsMessageAndAccessibilityInformationLoaded.Fragment;

  export type DifferentDayArrival = FlightsMessageAndAccessibilityInformationLoaded.Fragment;

  export type BasicFlightDetails = FlightsMessageAndAccessibilityInformationLoaded.Fragment;

  export type FlightsBargainJourneySummaryInlineFragment = {
    __typename?: 'FlightsBargainJourneySummary';

    arrivalDayInformation: string;
  };

  export type OnViewedAnalytics = FlightsAnalyticsInformationLoaded.Fragment;

  export type ChangeFlight = FlightsActionInformationLoaded.Fragment;

  export type FareDetails = {
    __typename?: 'FareDetails';

    changePolicies?: ChangePolicies | null;

    fareSummary?: FareSummary | null;

    defaultBaggageInformation?: _DefaultBaggageInformation | null;
  };

  export type ChangePolicies = FlightsInformationTextSectionLoaded.Fragment;

  export type FareSummary = {
    __typename?: 'FareSummary';

    message: string;

    title: string;

    flightsSelectedJourneyAvailableFaresInformation?: FlightsSelectedJourneyAvailableFaresInformation | null;

    details: _Details;
  };

  export type FlightsSelectedJourneyAvailableFaresInformation = {
    __typename?: 'FlightsSelectedJourneyAvailableFares';

    fareChoiceInformation: FareChoiceInformation;

    dismissDetailedJourneyInformation: DismissDetailedJourneyInformation;

    openAccessibility: string;
  };

  export type FareChoiceInformation = {
    __typename?: 'FlightsFareChoiceInformation';

    accessibleHeading: string;

    heading: _Heading;

    message: string;

    tripTypePerTraveler: string;

    displayAnalytics: DisplayAnalytics;

    scrollAnalytics: ScrollAnalytics;

    fareTypes: FareTypes[];

    defaultBaggageInformation: DefaultBaggageInformation;
  };

  export type _Heading = {
    __typename?: 'FlightsResponsiveMessage';

    longMessage: string;

    shortMessage?: string | null;
  };

  export type DisplayAnalytics = FlightsAnalyticsInformationLoaded.Fragment;

  export type ScrollAnalytics = FlightsAnalyticsInformationLoaded.Fragment;

  export type FareTypes = {
    __typename?: 'FlightsJourneyFare';

    name: string;

    cabinClass: string;

    accessibilityMessage: string;

    formattedPrice: FormattedPrice;

    totalPrice: string;

    identifier: string;

    selected: boolean;

    clickEventAnalytics: ClickEventAnalytics;

    fareScrollAnalytics: FareScrollAnalytics;

    collapsedRules: CollapsedRules;

    expandedRules: ExpandedRules[];

    baggageFeesInformation: BaggageFeesInformation;

    showMoreToggle: ShowMoreToggle;

    showMoreAmenitiesToggle?: ShowMoreAmenitiesToggle | null;

    changeCancellationMessages?: ChangeCancellationMessages | null;

    chooseFareAction: ChooseFareAction;

    recommendation?: Recommendation | null;
  };

  export type FormattedPrice = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: Items[];
  };

  export type Items = {
    __typename?: 'FlightsPhrasePart';

    text: string;

    styles: FlightsPhrasePartStyle[];
  };

  export type ClickEventAnalytics = FlightsAnalyticsInformationLoaded.Fragment;

  export type FareScrollAnalytics = FlightsAnalyticsInformationLoaded.Fragment;

  export type CollapsedRules = {
    __typename?: 'FlightsJourneyAmenities';

    accessibilityMessage: string;

    amenities: _Amenities[];

    analytics?: __Analytics | null;
  };

  export type _Amenities = {
    __typename?: 'FlightsIconAndLabel';

    icon: _Icon;

    label: string;
  };

  export type _Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;

    withBackground?: boolean | null;
  };

  export type __Analytics = FlightsAnalyticsInformationLoaded.Fragment;

  export type ExpandedRules = {
    __typename?: 'FlightsJourneyAmenitiesWithLabel';

    label: string;

    rules: Rules;
  };

  export type Rules = {
    __typename?: 'FlightsJourneyAmenities';

    accessibilityMessage: string;

    amenities: __Amenities[];

    analytics?: ___Analytics | null;
  };

  export type __Amenities = {
    __typename?: 'FlightsIconAndLabel';

    icon: __Icon;

    label: string;
  };

  export type __Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;

    withBackground?: boolean | null;
  };

  export type ___Analytics = FlightsAnalyticsInformationLoaded.Fragment;

  export type BaggageFeesInformation = FlightsBaggageInformation.Fragment;

  export type ShowMoreToggle = FlightsToggleInformationLoaded.Fragment;

  export type ShowMoreAmenitiesToggle = FlightsToggleInformationLoaded.Fragment;

  export type ChangeCancellationMessages = {
    __typename?: 'FlightsTextSection';

    heading?: string | null;

    displayAction?: DisplayAction | null;

    messages: Messages[];

    onViewedAnalytics?: _OnViewedAnalytics | null;

    displayAnalytics?: _DisplayAnalytics | null;
  };

  export type DisplayAction = FlightsToggleInformationLoaded.Fragment;

  export type Messages = FlightsInformationLoadedPhrase.Fragment;

  export type _OnViewedAnalytics = FlightsAnalyticsInformationLoaded.Fragment;

  export type _DisplayAnalytics = FlightsAnalyticsInformationLoaded.Fragment;

  export type ChooseFareAction = FlightsActionInformationLoaded.Fragment;

  export type Recommendation = {
    __typename?: 'FlightsBadge';

    text?: string | null;

    type: FlightsBadgeTheme;
  };

  export type DefaultBaggageInformation = FlightsBaggageInformation.Fragment;

  export type DismissDetailedJourneyInformation = {
    __typename?: 'FlightsActionableIcon';

    analytics: ____Analytics;

    icon: ___Icon;
  };

  export type ____Analytics = FlightsAnalyticsInformationLoaded.Fragment;

  export type ___Icon = IconInformationLoaded.Fragment;

  export type _Details = FlightsActionInformationLoaded.Fragment;

  export type _DefaultBaggageInformation = FlightsBaggageInformation.Fragment;

  export type FlightsJourneyPolicies = FlightsInformationTextSectionLoaded.Fragment;

  export type JourneyInformation = JourneyInformation.Fragment;

  export type HygieneAmenitiesPresentation = {
    __typename?: 'FlightsHygieneAmenitiesPresentation';

    displayAction?: _DisplayAction | null;

    airlineAmenityGroups: AirlineAmenityGroups[];

    disclaimerMessage: string;
  };

  export type _DisplayAction = {
    __typename?: 'FlightsTextSection';

    displayAction?: __DisplayAction | null;
  };

  export type __DisplayAction = {
    __typename?: 'FlightsToggle';

    collapseActionable: CollapseActionable;

    expandActionable: ExpandActionable;

    expanded: boolean;
  };

  export type CollapseActionable = {
    __typename?: 'TogglePhase';

    action: string;

    analytics: _____Analytics;
  };

  export type _____Analytics = FlightsAnalyticsInformationLoaded.Fragment;

  export type ExpandActionable = {
    __typename?: 'TogglePhase';

    action: string;

    analytics: ______Analytics;
  };

  export type ______Analytics = FlightsAnalyticsInformationLoaded.Fragment;

  export type AirlineAmenityGroups = {
    __typename?: 'FlightsAirlineAmenityGroup';

    headerText?: string | null;

    amenities?: ___Amenities[] | null;
  };

  export type ___Amenities = {
    __typename?: 'FlightsIconAndLabel';

    icon: ____Icon;

    label: string;

    subLabel?: string | null;
  };

  export type ____Icon = {
    __typename?: 'Icon';

    id: string;
  };

  export type PriceSummary = FlightsLoadedPriceSummary.Fragment;

  export type SeparateTicketBanner = FlightsIconPlacardInformationLoaded.Fragment;

  export type BrandPolicies = FlightsInformationTextSectionLoaded.Fragment;

  export type ServerErrorMessaging = FlightsInformationServerErrorMessaging.Fragment;

  export type DynamicElementsGroups = {
    __typename?: 'FlightsInformationDynamicElementsGroup';

    identifier: string;

    dynamicElements: DynamicElements;
  };

  export type DynamicElements = {
    __typename?: FlightsInformationDynamicElementsInlineFragment['__typename'];

    flightsJourneyDetailsDynamicElements?: FlightsJourneyDetailsDynamicElements[] | null;
  } & FlightsInformationDynamicElementsInlineFragment;

  export type FlightsJourneyDetailsDynamicElements = {
    __typename?: 'FlightsJourneyDetailsDynamicElements';

    fareName?: string | null;

    journeyPartsDynamicElements: JourneyPartsDynamicElements[];
  };

  export type JourneyPartsDynamicElements = {
    __typename?: 'JourneyPartsDynamicElements';

    cabinClassAndBookingCode: string;
  };

  export type FlightsInformationDynamicElementsInlineFragment = {
    __typename?: 'FlightsInformationDynamicElements';

    priceSummary: _PriceSummary;

    totalPrice: string;

    fareChoiceInformationDynamicElement?: FareChoiceInformationDynamicElement | null;
  };

  export type _PriceSummary = FlightsLoadedPriceSummary.Fragment;

  export type FareChoiceInformationDynamicElement = {
    __typename?: 'FareChoiceInformationDynamicElement';

    farePricePerPerson: string;
  };
}

export namespace FlightsShoppingPwaFlightInformationResultsLoading {
  export type Variables = {
    context: ContextInput;
    flightsDetailCriteria: FlightsDetailCriteriaInput;
    queryState?: FlightsQueryState | null;
  };

  export type Query = {
    __typename?: 'Query';

    flightsDetail: FlightsDetail;
  };

  export type FlightsDetail = {
    __typename?: 'FlightsInformationResponse';

    clientMetadata?: ClientMetadata | null;

    pageTitle?: PageTitle | null;

    freeCancellation?: FreeCancellation | null;

    flightsSelectedJourneyReview?: FlightsSelectedJourneyReview[] | null;

    priceSummary?: PriceSummary | null;

    serverErrorMessaging?: ServerErrorMessaging | null;

    stepIndicator?: StepIndicator | null;
  };

  export type ClientMetadata = FlightsPwaMetadataInlineFragment;

  export type FlightsPwaMetadataInlineFragment = {
    __typename?: 'FlightsPWAMetadata';

    pageName: string;

    pageNameAnalytics: PageNameAnalytics;
  };

  export type PageNameAnalytics = FlightsAnalyticsInformationLoading.Fragment;

  export type PageTitle = FlightsPageTitleInlineFragment;

  export type FlightsPageTitleInlineFragment = {
    __typename?: 'FlightsPageTitle';

    title: Title;

    pageAccessibility?: string | null;
  };

  export type Title = {
    __typename?: 'FlightsResponsiveMessage';

    longMessage: string;

    shortMessage?: string | null;
  };

  export type FreeCancellation = FlightsImagePlacardInformationLoading.Fragment;

  export type FlightsSelectedJourneyReview = LoadingFlightsSelectedJourneyReviewInlineFragment;

  export type LoadingFlightsSelectedJourneyReviewInlineFragment = {
    __typename?: 'LoadingFlightsSelectedJourneyReview';

    flightsJourneyHeaders: FlightsJourneyHeaders;

    flightsJourneySummary: FlightsJourneySummary;

    fareSummarySkeletonCount: number;

    changeFlight: ChangeFlight;
  };

  export type FlightsJourneyHeaders = {
    __typename?: 'FlightsJourneyHeaders';

    heading: string;

    flightsJourneySubheadingImage?: FlightsJourneySubheadingImage | null;

    flightsJourneySubheading: string;
  };

  export type FlightsJourneySubheadingImage = {
    __typename?: 'Image';

    url: Url;

    description: string;
  };

  export type FlightsJourneySummary = {
    __typename?:
      | LoadingFlightsStandardJourneySummaryInlineFragment['__typename']
      | FlightsBargainJourneySummaryInlineFragment['__typename'];

    heading: Heading;

    differentDayArrival?: DifferentDayArrival | null;

    basicFlightDetails: BasicFlightDetails[];
  } & (LoadingFlightsStandardJourneySummaryInlineFragment | FlightsBargainJourneySummaryInlineFragment);

  export type Heading = FlightsMessageAndAccessibilityInformationLoading.Fragment;

  export type DifferentDayArrival = FlightsMessageAndAccessibilityInformationLoading.Fragment;

  export type BasicFlightDetails = FlightsMessageAndAccessibilityInformationLoading.Fragment;

  export type LoadingFlightsStandardJourneySummaryInlineFragment = {
    __typename?: 'LoadingFlightsStandardJourneySummary';

    skeletonCount: number;
  };

  export type FlightsBargainJourneySummaryInlineFragment = {
    __typename?: 'FlightsBargainJourneySummary';

    arrivalDayInformation: string;
  };

  export type ChangeFlight = FlightsActionInformationLoading.Fragment;

  export type PriceSummary = FlightsLoadingPriceSummaryInlineFragment;

  export type FlightsLoadingPriceSummaryInlineFragment = {
    __typename?: 'FlightsLoadingPriceSummary';

    title: string;

    skeletonCount: number;

    tripTotalLabel: string;

    buttonAction: ButtonAction;
  };

  export type ButtonAction = FlightsActionInformationLoading.Fragment;

  export type ServerErrorMessaging = FlightsInformationLoadingServerErrorMessaging.Fragment;

  export type StepIndicator = FlightsInformationStepIndicator.Fragment;
}

export namespace FlightsShoppingPwaFlightSearchResultsFlightsSearch {
  export type Variables = {
    context: ContextInput;
    flightsSearchContext?: FlightsSearchContextInput | null;
    journeyCriteria: FlightsJourneyCriteriaInput[];
    queryState?: FlightsQueryState | null;
    searchFilterValuesList?: FlightsSearchFilterValuesInput[] | null;
    searchPreferences?: FlightsSearchPreferencesInput | null;
    sortOption?: FlightsSortOptionTypeInput | null;
    travelerDetails?: FlightsTravelerDetailsInput[] | null;
    searchPagination?: PaginationInput | null;
  };

  export type Query = {
    __typename?: 'Query';

    flightsSearch: FlightsSearch;
  };

  export type FlightsSearch = {
    __typename?: 'FlightsSearchResponse';

    clientMetadata?: ClientMetadata | null;

    failedRequestMessaging?: FailedRequestMessaging | null;

    noListingMessaging?: NoListingMessaging | null;

    searchForm?: SearchForm | null;

    sortAndFilterResult?: SortAndFilterResult | null;

    listingResult?: ListingResult | null;

    opinionLab?: OpinionLab | null;

    flightsOpinionLab?: FlightsOpinionLab | null;

    pageTitle?: PageTitle | null;

    dialogs?: Dialogs[] | null;

    banners?: Banners[] | null;

    cheapestListingInfo?: CheapestListingInfo | null;

    gaiaId?: string | null;

    stepIndicator?: StepIndicator | null;
  };

  export type ClientMetadata = FlightsPwaMetadataInlineFragment;

  export type FlightsPwaMetadataInlineFragment = {
    __typename?: 'FlightsPWAMetadata';

    pageName: string;

    pageNameAnalytics: PageNameAnalytics;

    responseTags?: ResponseTagType[] | null;
  };

  export type PageNameAnalytics = FlightsAnalytics.Fragment;

  export type FailedRequestMessaging = {
    __typename?: 'FlightsActionableErrorMessaging';

    icon: Icon;

    message: string;

    action: Action;

    title: string;
  };

  export type Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;
  };

  export type Action = FlightAction.Fragment;

  export type NoListingMessaging =
    | FlightsNoFlightsFoundMessagingInlineFragment
    | FlightsNoFlightsFoundWithFilterMessagingInlineFragment
    | FlightsActionableErrorMessagingInlineFragment;

  export type FlightsNoFlightsFoundMessagingInlineFragment = {
    __typename?: 'FlightsNoFlightsFoundMessaging';

    icon: _Icon;

    message: string;

    title: string;
  };

  export type _Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type FlightsNoFlightsFoundWithFilterMessagingInlineFragment = {
    __typename?: 'FlightsNoFlightsFoundWithFilterMessaging';

    icon: __Icon;

    message: string;

    clearFiltersAction?: ClearFiltersAction | null;

    title: string;
  };

  export type __Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type ClearFiltersAction = FlightAction.Fragment;

  export type FlightsActionableErrorMessagingInlineFragment = {
    __typename?: 'FlightsActionableErrorMessaging';

    icon: ___Icon;

    message: string;

    action: _Action;

    title: string;
  };

  export type ___Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;
  };

  export type _Action = FlightAction.Fragment;

  export type SearchForm = FlightsLoadedSearchFormInlineFragment;

  export type FlightsLoadedSearchFormInlineFragment = {
    __typename?: 'FlightsLoadedSearchForm';

    closeActionAccessibility?: string | null;

    accessibilityMessage?: string | null;

    addJourneyAction?: AddJourneyAction | null;

    appliedFilterCount?: number | null;

    collapseFormAnalytics: CollapseFormAnalytics;

    departureAndReturnDates?: DepartureAndReturnDates | null;

    errorSummary: ErrorSummary;

    expandFilterAction: ExpandFilterAction;

    expandFormAnalytics: ExpandFormAnalytics;

    expandSearchFormAction: ExpandSearchFormAction;

    closeFormAction?: CloseFormAction | null;

    journeys: Journeys[];

    newJourneyTemplate: NewJourneyTemplate;

    originAndDestinationLocations?: string | null;

    searchAction?: string | null;

    searchActionAnalytics: SearchActionAnalytics;

    searchOptions: SearchOptions[];
  };

  export type AddJourneyAction = {
    __typename?: 'FlightsAction';

    analytics: Analytics;

    displayAction: string;

    displayType: FlightsActionDisplayType;

    type: FlightsActionType;
  };

  export type Analytics = FlightsAnalytics.Fragment;

  export type CollapseFormAnalytics = FlightsAnalytics.Fragment;

  export type DepartureAndReturnDates = {
    __typename?: 'FlightsResponsiveMessage';

    longMessage: string;

    shortMessage?: string | null;
  };

  export type ErrorSummary = {
    __typename?: 'FlightsErrorSummary';

    header: string;

    linkText: string;

    displayAnalytics: DisplayAnalytics;

    linkAnalytics: LinkAnalytics;
  };

  export type DisplayAnalytics = {
    __typename?: 'FlightsAnalytics';

    linkName: string;

    referrerId: string;
  };

  export type LinkAnalytics = {
    __typename?: 'FlightsAnalytics';

    linkName: string;

    referrerId: string;
  };

  export type ExpandFilterAction = {
    __typename?: 'FlightsIconAndLabel';

    icon: ____Icon;

    label: string;
  };

  export type ____Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type ExpandFormAnalytics = FlightsAnalytics.Fragment;

  export type ExpandSearchFormAction = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type CloseFormAction = {
    __typename?: 'FlightsAction';

    displayAction: string;

    analytics: _Analytics;
  };

  export type _Analytics = FlightsAnalytics.Fragment;

  export type Journeys = {
    __typename?: 'FlightsSearchFormJourneyCriteria';

    departureDate: DepartureDate;

    destinationLocation: DestinationLocation;

    label: Label;

    originLocation: OriginLocation;

    returnDate?: ReturnDate | null;

    removeJourneyAction?: RemoveJourneyAction | null;

    swapLocationsAction: SwapLocationsAction;
  };

  export type DepartureDate = {
    __typename?: 'FlightsSearchFormDateField';

    analytics: __Analytics;

    handleClickAnalytics: HandleClickAnalytics;

    currentError?: string | null;

    date?: Date | null;

    dateFormat: string;

    daysBookableInAdvance: number;

    label: string;

    placeholder: string;

    possibleErrors: PossibleErrors[];

    doneAction: string;
  };

  export type __Analytics = FlightsAnalytics.Fragment;

  export type HandleClickAnalytics = FlightsAnalytics.Fragment;

  export type Date = {
    __typename?: 'Date';

    day: number;

    month: number;

    year: number;

    formatted: string;

    isoFormat: string;
  };

  export type PossibleErrors = {
    __typename?: 'FlightsSearchFormError';

    analytics: ___Analytics;

    message: string;

    type: FlightsSearchFormErrorType;
  };

  export type ___Analytics = FlightsAnalytics.Fragment;

  export type DestinationLocation = {
    __typename?: 'FlightsSearchFormLocationField';

    analytics: ____Analytics;

    onTypeAnalytics: OnTypeAnalytics;

    currentError?: string | null;

    icon: _____Icon;

    label: string;

    placeholder: string;

    possibleErrors: _PossibleErrors[];

    value?: string | null;

    airportCode?: string | null;
  };

  export type ____Analytics = FlightsAnalytics.Fragment;

  export type OnTypeAnalytics = FlightsAnalytics.Fragment;

  export type _____Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type _PossibleErrors = {
    __typename?: 'FlightsSearchFormError';

    analytics: _____Analytics;

    message: string;

    type: FlightsSearchFormErrorType;
  };

  export type _____Analytics = FlightsAnalytics.Fragment;

  export type Label = {
    __typename?: 'FlightsSimpleLocalizationTemplate';

    initialValue?: string | null;

    template: string;

    tokens: string[];
  };

  export type OriginLocation = {
    __typename?: 'FlightsSearchFormLocationField';

    analytics: ______Analytics;

    onTypeAnalytics: _OnTypeAnalytics;

    currentError?: string | null;

    icon: ______Icon;

    label: string;

    placeholder: string;

    possibleErrors: __PossibleErrors[];

    value?: string | null;

    airportCode?: string | null;
  };

  export type ______Analytics = FlightsAnalytics.Fragment;

  export type _OnTypeAnalytics = FlightsAnalytics.Fragment;

  export type ______Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type __PossibleErrors = {
    __typename?: 'FlightsSearchFormError';

    analytics: _______Analytics;

    message: string;

    type: FlightsSearchFormErrorType;
  };

  export type _______Analytics = FlightsAnalytics.Fragment;

  export type ReturnDate = {
    __typename?: 'FlightsSearchFormDateField';

    analytics: ________Analytics;

    handleClickAnalytics: _HandleClickAnalytics;

    currentError?: string | null;

    date?: _Date | null;

    dateFormat: string;

    daysBookableInAdvance: number;

    label: string;

    placeholder: string;

    possibleErrors: ___PossibleErrors[];

    doneAction: string;
  };

  export type ________Analytics = FlightsAnalytics.Fragment;

  export type _HandleClickAnalytics = FlightsAnalytics.Fragment;

  export type _Date = {
    __typename?: 'Date';

    day: number;

    month: number;

    year: number;

    formatted: string;

    isoFormat: string;
  };

  export type ___PossibleErrors = {
    __typename?: 'FlightsSearchFormError';

    analytics: _________Analytics;

    message: string;

    type: FlightsSearchFormErrorType;
  };

  export type _________Analytics = FlightsAnalytics.Fragment;

  export type RemoveJourneyAction = {
    __typename?: 'FlightsAction';

    displayAction: string;

    analytics: __________Analytics;

    accessibilityUsageMessage?: AccessibilityUsageMessage | null;
  };

  export type __________Analytics = FlightsAnalytics.Fragment;

  export type AccessibilityUsageMessage = {
    __typename?: 'FlightsSimpleLocalizationTemplate';

    initialValue?: string | null;

    template: string;

    tokens: string[];
  };

  export type SwapLocationsAction = {
    __typename?: 'FlightsSwapLocationAction';

    icon: _______Icon;

    analytics: ___________Analytics;

    accessibilityMessage?: string | null;

    accessibilityUsageMessage: _AccessibilityUsageMessage;
  };

  export type _______Icon = {
    __typename?: 'FlightsResponsiveIcon';

    smallView: SmallView;

    largeView: LargeView;
  };

  export type SmallView = {
    __typename?: 'Icon';

    id: string;

    size?: IconSize | null;
  };

  export type LargeView = {
    __typename?: 'Icon';

    id: string;

    size?: IconSize | null;
  };

  export type ___________Analytics = FlightsAnalytics.Fragment;

  export type _AccessibilityUsageMessage = {
    __typename?: 'FlightsSimpleLocalizationTemplate';

    initialValue?: string | null;

    template: string;

    tokens: string[];
  };

  export type NewJourneyTemplate = {
    __typename?: 'FlightsSearchFormJourneyCriteria';

    departureDate: _DepartureDate;

    destinationLocation: _DestinationLocation;

    originLocation: _OriginLocation;

    returnDate?: _ReturnDate | null;

    label: _Label;

    removeJourneyAction?: _RemoveJourneyAction | null;

    swapLocationsAction: _SwapLocationsAction;
  };

  export type _DepartureDate = {
    __typename?: 'FlightsSearchFormDateField';

    analytics: ____________Analytics;

    handleClickAnalytics: __HandleClickAnalytics;

    currentError?: string | null;

    date?: __Date | null;

    dateFormat: string;

    daysBookableInAdvance: number;

    label: string;

    placeholder: string;

    possibleErrors: ____PossibleErrors[];

    doneAction: string;
  };

  export type ____________Analytics = FlightsAnalytics.Fragment;

  export type __HandleClickAnalytics = FlightsAnalytics.Fragment;

  export type __Date = {
    __typename?: 'Date';

    day: number;

    month: number;

    year: number;

    formatted: string;

    isoFormat: string;

    shortDateFormat?: string | null;
  };

  export type ____PossibleErrors = {
    __typename?: 'FlightsSearchFormError';

    analytics: _____________Analytics;

    message: string;

    type: FlightsSearchFormErrorType;
  };

  export type _____________Analytics = FlightsAnalytics.Fragment;

  export type _DestinationLocation = {
    __typename?: 'FlightsSearchFormLocationField';

    analytics: ______________Analytics;

    onTypeAnalytics: __OnTypeAnalytics;

    currentError?: string | null;

    icon: ________Icon;

    label: string;

    placeholder: string;

    possibleErrors: _____PossibleErrors[];

    value?: string | null;

    airportCode?: string | null;
  };

  export type ______________Analytics = FlightsAnalytics.Fragment;

  export type __OnTypeAnalytics = FlightsAnalytics.Fragment;

  export type ________Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type _____PossibleErrors = {
    __typename?: 'FlightsSearchFormError';

    analytics: _______________Analytics;

    message: string;

    type: FlightsSearchFormErrorType;
  };

  export type _______________Analytics = FlightsAnalytics.Fragment;

  export type _OriginLocation = {
    __typename?: 'FlightsSearchFormLocationField';

    analytics: ________________Analytics;

    onTypeAnalytics: ___OnTypeAnalytics;

    currentError?: string | null;

    icon: _________Icon;

    label: string;

    placeholder: string;

    possibleErrors: ______PossibleErrors[];

    value?: string | null;

    airportCode?: string | null;
  };

  export type ________________Analytics = FlightsAnalytics.Fragment;

  export type ___OnTypeAnalytics = FlightsAnalytics.Fragment;

  export type _________Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type ______PossibleErrors = {
    __typename?: 'FlightsSearchFormError';

    analytics: _________________Analytics;

    message: string;

    type: FlightsSearchFormErrorType;
  };

  export type _________________Analytics = FlightsAnalytics.Fragment;

  export type _ReturnDate = {
    __typename?: 'FlightsSearchFormDateField';

    analytics: __________________Analytics;

    handleClickAnalytics: ___HandleClickAnalytics;

    currentError?: string | null;

    date?: ___Date | null;

    dateFormat: string;

    daysBookableInAdvance: number;

    label: string;

    placeholder: string;

    possibleErrors: _______PossibleErrors[];

    doneAction: string;
  };

  export type __________________Analytics = FlightsAnalytics.Fragment;

  export type ___HandleClickAnalytics = FlightsAnalytics.Fragment;

  export type ___Date = {
    __typename?: 'Date';

    day: number;

    month: number;

    year: number;

    formatted: string;

    isoFormat: string;

    shortDateFormat?: string | null;
  };

  export type _______PossibleErrors = {
    __typename?: 'FlightsSearchFormError';

    analytics: ___________________Analytics;

    message: string;

    type: FlightsSearchFormErrorType;
  };

  export type ___________________Analytics = FlightsAnalytics.Fragment;

  export type _Label = {
    __typename?: 'FlightsSimpleLocalizationTemplate';

    initialValue?: string | null;

    template: string;

    tokens: string[];
  };

  export type _RemoveJourneyAction = {
    __typename?: 'FlightsAction';

    displayAction: string;

    analytics: ____________________Analytics;

    accessibilityUsageMessage?: __AccessibilityUsageMessage | null;
  };

  export type ____________________Analytics = FlightsAnalytics.Fragment;

  export type __AccessibilityUsageMessage = {
    __typename?: 'FlightsSimpleLocalizationTemplate';

    initialValue?: string | null;

    template: string;

    tokens: string[];
  };

  export type _SwapLocationsAction = {
    __typename?: 'FlightsSwapLocationAction';

    icon: __________Icon;

    analytics: _____________________Analytics;

    accessibilityMessage?: string | null;

    accessibilityUsageMessage: ___AccessibilityUsageMessage;
  };

  export type __________Icon = {
    __typename?: 'FlightsResponsiveIcon';

    smallView: _SmallView;

    largeView: _LargeView;
  };

  export type _SmallView = {
    __typename?: 'Icon';

    id: string;

    size?: IconSize | null;
  };

  export type _LargeView = {
    __typename?: 'Icon';

    id: string;

    size?: IconSize | null;
  };

  export type _____________________Analytics = FlightsAnalytics.Fragment;

  export type ___AccessibilityUsageMessage = {
    __typename?: 'FlightsSimpleLocalizationTemplate';

    initialValue?: string | null;

    template: string;

    tokens: string[];
  };

  export type SearchActionAnalytics = FlightsAnalytics.Fragment;

  export type SearchOptions =
    | FlightsSearchFormAirlineOptionInlineFragment
    | FlightsSearchFormCabinClassOptionInlineFragment
    | FlightsSearchFormMoreFiltersOptionInlineFragment
    | FlightsSearchFormTravelersOptionInlineFragment
    | FlightsSearchFormTripTypeOptionInlineFragment;

  export type FlightsSearchFormAirlineOptionInlineFragment = {
    __typename?: 'FlightsSearchFormAirlineOption';

    label: string;

    icon: ___________Icon;

    fieldIcon: FieldIcon;

    applyAnalytics: ApplyAnalytics;

    cancelAnalytics: CancelAnalytics;

    openAnalytics: OpenAnalytics;

    doneAction: string;

    items: Items[];

    selectedItem: SelectedItem;

    closeIcon?: CloseIcon | null;

    doneActionAccessibility?: string | null;
  };

  export type ___________Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type FieldIcon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type ApplyAnalytics = FlightsAnalytics.Fragment;

  export type CancelAnalytics = FlightsAnalytics.Fragment;

  export type OpenAnalytics = FlightsAnalytics.Fragment;

  export type Items = {
    __typename?: 'FlightsSearchFormAirlineOptionItem';

    airline: string;

    label: string;

    airlineSelectedAnalytics: AirlineSelectedAnalytics;

    selected: boolean;
  };

  export type AirlineSelectedAnalytics = FlightsAnalytics.Fragment;

  export type SelectedItem = {
    __typename?: 'FlightsSearchFormAirlineOptionItem';

    airline: string;

    label: string;
  };

  export type CloseIcon = {
    __typename?: 'FlightsIconAndAccessibility';

    accessibility?: string | null;
  };

  export type FlightsSearchFormCabinClassOptionInlineFragment = {
    __typename?: 'FlightsSearchFormCabinClassOption';

    label: string;

    icon: ____________Icon;

    fieldIcon: _FieldIcon;

    openAnalytics: _OpenAnalytics;

    items: _Items[];

    selectedItem: _SelectedItem;
  };

  export type ____________Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type _FieldIcon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type _OpenAnalytics = FlightsAnalytics.Fragment;

  export type _Items = {
    __typename?: 'FlightsSearchFormCabinClassOptionItem';

    cabinClass: FlightsCabinClass;

    label: string;

    cabinClassSelectedAnalytics: CabinClassSelectedAnalytics;

    selected: boolean;
  };

  export type CabinClassSelectedAnalytics = FlightsAnalytics.Fragment;

  export type _SelectedItem = {
    __typename?: 'FlightsSearchFormCabinClassOptionItem';

    cabinClass: FlightsCabinClass;

    label: string;
  };

  export type FlightsSearchFormMoreFiltersOptionInlineFragment = {
    __typename?: 'FlightsSearchFormMoreFiltersOption';

    label: string;

    icon: _____________Icon;

    openAnalytics: __OpenAnalytics;

    doneAction: string;

    items: __Items[];
  };

  export type _____________Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type __OpenAnalytics = FlightsAnalytics.Fragment;

  export type __Items = {
    __typename?: 'FlightsSearchFormMoreFiltersOptionItem';

    advancedFilterSelectedAnalytics: AdvancedFilterSelectedAnalytics;

    advancedFilterRemoveAnalytics: AdvancedFilterRemoveAnalytics;

    advancedFilterType: FlightsAdvancedFilterType;

    label: string;

    selected: boolean;
  };

  export type AdvancedFilterSelectedAnalytics = FlightsAnalytics.Fragment;

  export type AdvancedFilterRemoveAnalytics = FlightsAnalytics.Fragment;

  export type FlightsSearchFormTravelersOptionInlineFragment = {
    __typename?: 'FlightsSearchFormTravelersOption';

    label: string;

    travelerLimitLabel: string;

    icon: ______________Icon;

    fieldIcon: __FieldIcon;

    ageRulesLink: AgeRulesLink;

    applyAnalytics: _ApplyAnalytics;

    cancelAction: string;

    cancelAnalytics: _CancelAnalytics;

    changeAnalytics: ChangeAnalytics;

    adultSelectedAnalytics: AdultSelectedAnalytics;

    childrenSelectedAnalytics: ChildrenSelectedAnalytics;

    infantSelectedAnalytics: InfantSelectedAnalytics;

    infantLapAnalytics: InfantLapAnalytics;

    infantSeatAnalytics: InfantSeatAnalytics;

    openAnalytics: ___OpenAnalytics;

    doneAction: string;

    currentErrors?: (string | null)[] | null;

    possibleErrors: ________PossibleErrors[];

    valueTemplate: ValueTemplate;

    items: ___Items[];

    doneActionAccessibility?: string | null;

    cancelActionAccessibility?: string | null;
  };

  export type ______________Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type __FieldIcon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type AgeRulesLink = {
    __typename?: 'FlightsLinkAction';

    analytics: ______________________Analytics;

    displayAction: string;

    url: Url;
  };

  export type ______________________Analytics = FlightsAnalytics.Fragment;

  export type _ApplyAnalytics = FlightsAnalytics.Fragment;

  export type _CancelAnalytics = FlightsAnalytics.Fragment;

  export type ChangeAnalytics = FlightsAnalytics.Fragment;

  export type AdultSelectedAnalytics = FlightsAnalytics.Fragment;

  export type ChildrenSelectedAnalytics = FlightsAnalytics.Fragment;

  export type InfantSelectedAnalytics = FlightsAnalytics.Fragment;

  export type InfantLapAnalytics = FlightsAnalytics.Fragment;

  export type InfantSeatAnalytics = FlightsAnalytics.Fragment;

  export type ___OpenAnalytics = FlightsAnalytics.Fragment;

  export type ________PossibleErrors = {
    __typename?: 'FlightsSearchFormError';

    analytics: _______________________Analytics;

    message: string;

    type: FlightsSearchFormErrorType;
  };

  export type _______________________Analytics = FlightsAnalytics.Fragment;

  export type ValueTemplate = {
    __typename?: 'FlightsMultiPluralLocalizationTemplate';

    oneTemplate: string;

    manyTemplate: string;

    tokens: string[];

    fewTemplate: string;

    otherTemplate: string;

    twoTemplate: string;

    zeroTemplate: string;
  };

  export type ___Items = {
    __typename?: FlightsSearchFormTravelerInfantOptionItemInlineFragment['__typename'];

    caption?: string | null;

    currentError?: string | null;

    increaseCountAccessibility?: string | null;

    decreaseCountAccessibility?: string | null;

    decreaseCountAnalytics: DecreaseCountAnalytics;

    increaseCountAnalytics: IncreaseCountAnalytics;

    label: string;

    max: number;

    minCount: number;

    travelerAgeSelectorTemplate?: TravelerAgeSelectorTemplate | null;

    travelerAges?: TravelerAges[] | null;

    travelerCount: number;

    type: FlightsTravelerType;
  } & FlightsSearchFormTravelerInfantOptionItemInlineFragment;

  export type DecreaseCountAnalytics = FlightsAnalytics.Fragment;

  export type IncreaseCountAnalytics = FlightsAnalytics.Fragment;

  export type TravelerAgeSelectorTemplate = {
    __typename?: 'FlightsTravelerAgeSelector';

    analytics: ________________________Analytics;

    items: ____Items[];

    label: __Label;

    placeholder: string;
  };

  export type ________________________Analytics = FlightsAnalytics.Fragment;

  export type ____Items = {
    __typename?: 'FlightsSearchFormTravelerAgeOptionItem';

    label: string;

    selected: boolean;

    value: number;
  };

  export type __Label = {
    __typename?: 'FlightsSimpleLocalizationTemplate';

    initialValue?: string | null;

    template: string;

    tokens: string[];
  };

  export type TravelerAges = {
    __typename?: 'FlightsTravelerAgeSelector';

    analytics: _________________________Analytics;

    items: _____Items[];

    label: ___Label;

    placeholder: string;
  };

  export type _________________________Analytics = FlightsAnalytics.Fragment;

  export type _____Items = {
    __typename?: 'FlightsSearchFormTravelerAgeOptionItem';

    label: string;

    selected: boolean;

    value: number;
  };

  export type ___Label = {
    __typename?: 'FlightsSimpleLocalizationTemplate';

    initialValue?: string | null;

    template: string;

    tokens: string[];
  };

  export type FlightsSearchFormTravelerInfantOptionItemInlineFragment = {
    __typename?: 'FlightsSearchFormTravelerInfantOptionItem';

    infantsOption: InfantsOption;
  };

  export type InfantsOption = {
    __typename?: 'FlightsSearchFormTravelerInfantsOption';

    items: ______Items[];

    label: string;
  };

  export type ______Items = {
    __typename?: 'FlightsSearchFormTravelerInfantsSelection';

    label: string;

    selected: boolean;

    type: FlightsTravelerType;
  };

  export type FlightsSearchFormTripTypeOptionInlineFragment = {
    __typename?: 'FlightsSearchFormTripTypeOption';

    label: string;

    icon: _______________Icon;

    openAnalytics: ____OpenAnalytics;

    items: _______Items[];
  };

  export type _______________Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type ____OpenAnalytics = FlightsAnalytics.Fragment;

  export type _______Items = {
    __typename?: 'FlightsSearchFormTripTypeOptionItem';

    label: string;

    selected: boolean;

    tripType: FlightsTripType;

    tripTypeSelectedAnalytics: TripTypeSelectedAnalytics;
  };

  export type TripTypeSelectedAnalytics = FlightsAnalytics.Fragment;

  export type SortAndFilterResult = FlightsLoadedSortAndFilterResultInlineFragment;

  export type FlightsLoadedSortAndFilterResultInlineFragment = {
    __typename?: 'FlightsLoadedSortAndFilterResult';

    title: string;

    appliedFiltersSummary?: AppliedFiltersSummary | null;

    applyAction: ApplyAction;

    clearSelectionLabel: ClearSelectionLabel;

    clearAllSelectionLabel: ClearAllSelectionLabel;

    dismiss: Dismiss;

    dismissAnalytics: DismissAnalytics;

    revealAction: RevealAction;

    revealActionAnalytics: RevealActionAnalytics;

    sortPresentation: SortPresentation;

    filterPresentation?: FilterPresentation | null;
  };

  export type AppliedFiltersSummary = {
    __typename?: 'FlightsAppliedFiltersSummary';

    appliedFilters?: AppliedFilters[] | null;
  };

  export type AppliedFilters = {
    __typename?: 'FlightsAppliedFilter';

    analytics: __________________________Analytics;

    dismissIcon: DismissIcon;

    label: string;

    nextSearchSortFilterCriteria?: NextSearchSortFilterCriteria | null;

    accessibilityMessage: string;
  };

  export type __________________________Analytics = FlightsAnalytics.Fragment;

  export type DismissIcon = {
    __typename?: 'Icon';

    description: string;

    id: string;
  };

  export type NextSearchSortFilterCriteria = {
    __typename?: 'FlightsSearchSortAndFilterCriteria';

    filterCriteria: FilterCriteria[];
  };

  export type FilterCriteria = {
    __typename?: 'FlightsSearchFilterValues';

    arrivalAirportCodeFilterValue?: ArrivalAirportCodeFilterValue | null;

    arrivalTimeFilterValue?: ArrivalTimeFilterValue | null;

    departureAirportCodeFilterValue?: DepartureAirportCodeFilterValue | null;

    departureTimeFilterValue?: DepartureTimeFilterValue | null;

    durationFilterValue?: DurationFilterValue | null;

    numOfStopFilterValue?: NumOfStopFilterValue | null;

    preferredAirlineFilterValue?: PreferredAirlineFilterValue | null;

    flexibleChangePolicyBasedFilterValue?: FlexibleChangePolicyBasedFilterValue | null;
  };

  export type ArrivalAirportCodeFilterValue = {
    __typename?: 'FlightsAirportCodeFilterValue';

    airportCode: string;
  };

  export type ArrivalTimeFilterValue = {
    __typename?: 'FlightsTimeBasedFilterValue';

    timeOfDay: FlightsTimeOfDay;
  };

  export type DepartureAirportCodeFilterValue = {
    __typename?: 'FlightsAirportCodeFilterValue';

    airportCode: string;
  };

  export type DepartureTimeFilterValue = {
    __typename?: 'FlightsTimeBasedFilterValue';

    timeOfDay: FlightsTimeOfDay;
  };

  export type DurationFilterValue = {
    __typename?: 'FlightsDurationBasedFilterValue';

    maxDuration: number;
  };

  export type NumOfStopFilterValue = {
    __typename?: 'FlightsStopBasedFilterValue';

    stopInfo: StopInfo;
  };

  export type StopInfo = {
    __typename?: 'FlightsStopInfo';

    numberOfStops: number;

    stopFilterOperation: FlightsStopFilterOperation;
  };

  export type PreferredAirlineFilterValue = {
    __typename?: 'FlightsPreferredAirlineFilterValue';

    carrierCode: string;
  };

  export type FlexibleChangePolicyBasedFilterValue = {
    __typename?: 'FlightsFlexibleChangePolicyBasedFilterValue';

    policyName: FilterPolicyType;
  };

  export type ApplyAction = {
    __typename?: 'FlightsSortAndFilterAction';

    accessibility: Accessibility;

    analytics: ___________________________Analytics;

    details?: string | null;

    label: string;
  };

  export type Accessibility = {
    __typename?: 'FlightsAccessibilityMessage';

    onCompletion?: string | null;

    usage?: string | null;
  };

  export type ___________________________Analytics = FlightsAnalytics.Fragment;

  export type ClearSelectionLabel = {
    __typename?: 'FlightsActionableLabel';

    label: string;

    analytics?: ____________________________Analytics | null;

    accessibility?: _Accessibility | null;
  };

  export type ____________________________Analytics = FlightsAnalytics.Fragment;

  export type _Accessibility = {
    __typename?: 'FlightsAccessibilityMessage';

    onCompletion?: string | null;

    usage?: string | null;
  };

  export type ClearAllSelectionLabel = {
    __typename?: 'FlightsActionableLabel';

    label: string;

    analytics?: _____________________________Analytics | null;

    accessibility?: __Accessibility | null;
  };

  export type _____________________________Analytics = FlightsAnalytics.Fragment;

  export type __Accessibility = {
    __typename?: 'FlightsAccessibilityMessage';

    onCompletion?: string | null;

    usage?: string | null;
  };

  export type Dismiss = {
    __typename?: 'Icon';

    description: string;

    id: string;
  };

  export type DismissAnalytics = FlightsAnalytics.Fragment;

  export type RevealAction = {
    __typename?: 'FlightsSortAndFilterRevealAction';

    accessibility?: ___Accessibility | null;

    appliedFilterCount?: number | null;

    iconAndLabel: IconAndLabel;

    enabled: boolean;
  };

  export type ___Accessibility = {
    __typename?: 'FlightsAccessibilityMessage';

    onCompletion?: string | null;

    usage?: string | null;
  };

  export type IconAndLabel = {
    __typename?: 'FlightsIconAndLabel';

    icon: ________________Icon;

    label: string;
  };

  export type ________________Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;
  };

  export type RevealActionAnalytics = FlightsAnalytics.Fragment;

  export type SortPresentation = {
    __typename?: 'FlightsSortLoadedPresentation';

    label: string;

    options: Options[];

    selectedOption: SelectedOption;

    selectionActive: boolean;
  };

  export type Options = {
    __typename?: 'FlightsSortOptionItem';

    accessibility?: ____Accessibility | null;

    analytics: ______________________________Analytics;

    label: string;

    sortType: SortType;
  };

  export type ____Accessibility = {
    __typename?: 'FlightsAccessibilityMessage';

    onCompletion?: string | null;

    usage?: string | null;
  };

  export type ______________________________Analytics = FlightsAnalytics.Fragment;

  export type SortType = {
    __typename?: 'FlightsSortOptionType';

    sortOrder: FlightsSortOrder;

    sortType: FlightsSortType;
  };

  export type SelectedOption = {
    __typename?: 'FlightsSortOptionItem';

    label: string;

    sortType: _SortType;
  };

  export type _SortType = {
    __typename?: 'FlightsSortOptionType';

    sortOrder: FlightsSortOrder;

    sortType: FlightsSortType;
  };

  export type FilterPresentation = {
    __typename?: 'FlightsFilterLoadedPresentation';

    accessibility: _____Accessibility;

    options?: _Options[] | null;

    title?: string | null;

    emptyFiltersMessage?: string | null;
  };

  export type _____Accessibility = {
    __typename?: 'FlightsAccessibilityMessage';

    onCompletion?: string | null;

    usage?: string | null;
  };

  export type _Options = FlightsListDisplayFilterOptionInlineFragment | FlightsCardsDisplayFilterOptionInlineFragment;

  export type FlightsListDisplayFilterOptionInlineFragment = {
    __typename?: 'FlightsListDisplayFilterOption';

    items: ________Items[];

    itemsDefaultDisplayCount: number;

    label: string;

    priceFromLabel?: string | null;

    showMoreToggle?: ShowMoreToggle | null;

    supportsMultipleSelection: boolean;

    type: FlightsFilterType;
  };

  export type ________Items = {
    __typename?: 'FlightsListDisplayFilterItem';

    selectPositionAnalytics?: SelectPositionAnalytics | null;

    accessibility?: ______Accessibility | null;

    deselectAnalytics: DeselectAnalytics;

    flightsSearchFilterValues: FlightsSearchFilterValues;

    label: string;

    selectAnalytics: SelectAnalytics;

    selected: boolean;

    startingPrice?: StartingPrice | null;

    value: Value;
  };

  export type SelectPositionAnalytics = FlightsAnalytics.Fragment;

  export type ______Accessibility = {
    __typename?: 'FlightsAccessibilityMessage';

    onCompletion?: string | null;

    usage?: string | null;
  };

  export type DeselectAnalytics = FlightsAnalytics.Fragment;

  export type FlightsSearchFilterValues = {
    __typename?: 'FlightsSearchFilterValues';

    arrivalAirportCodeFilterValue?: _ArrivalAirportCodeFilterValue | null;

    arrivalTimeFilterValue?: _ArrivalTimeFilterValue | null;

    departureAirportCodeFilterValue?: _DepartureAirportCodeFilterValue | null;

    departureTimeFilterValue?: _DepartureTimeFilterValue | null;

    durationFilterValue?: _DurationFilterValue | null;

    numOfStopFilterValue?: _NumOfStopFilterValue | null;

    preferredAirlineFilterValue?: _PreferredAirlineFilterValue | null;

    flexibleChangePolicyBasedFilterValue?: _FlexibleChangePolicyBasedFilterValue | null;
  };

  export type _ArrivalAirportCodeFilterValue = {
    __typename?: 'FlightsAirportCodeFilterValue';

    airportCode: string;
  };

  export type _ArrivalTimeFilterValue = {
    __typename?: 'FlightsTimeBasedFilterValue';

    timeOfDay: FlightsTimeOfDay;
  };

  export type _DepartureAirportCodeFilterValue = {
    __typename?: 'FlightsAirportCodeFilterValue';

    airportCode: string;
  };

  export type _DepartureTimeFilterValue = {
    __typename?: 'FlightsTimeBasedFilterValue';

    timeOfDay: FlightsTimeOfDay;
  };

  export type _DurationFilterValue = {
    __typename?: 'FlightsDurationBasedFilterValue';

    maxDuration: number;
  };

  export type _NumOfStopFilterValue = {
    __typename?: 'FlightsStopBasedFilterValue';

    stopInfo: _StopInfo;
  };

  export type _StopInfo = {
    __typename?: 'FlightsStopInfo';

    stopFilterOperation: FlightsStopFilterOperation;

    numberOfStops: number;
  };

  export type _PreferredAirlineFilterValue = {
    __typename?: 'FlightsPreferredAirlineFilterValue';

    carrierCode: string;
  };

  export type _FlexibleChangePolicyBasedFilterValue = {
    __typename?: 'FlightsFlexibleChangePolicyBasedFilterValue';

    policyName: FilterPolicyType;
  };

  export type SelectAnalytics = FlightsAnalytics.Fragment;

  export type StartingPrice = {
    __typename?: 'Money';

    formatted: string;
  };

  export type Value =
    | FlightsAirportCodeFilterValueInlineFragment
    | FlightsDurationBasedFilterValueInlineFragment
    | FlightsPreferredAirlineFilterValueInlineFragment
    | FlightsFlexibleChangePolicyBasedFilterValueInlineFragment
    | FlightsStopBasedFilterValueInlineFragment
    | FlightsTimeBasedFilterValueInlineFragment;

  export type FlightsAirportCodeFilterValueInlineFragment = {
    __typename?: 'FlightsAirportCodeFilterValue';

    airportCode: string;
  };

  export type FlightsDurationBasedFilterValueInlineFragment = {
    __typename?: 'FlightsDurationBasedFilterValue';

    maxDuration: number;
  };

  export type FlightsPreferredAirlineFilterValueInlineFragment = {
    __typename?: 'FlightsPreferredAirlineFilterValue';

    carrierCode: string;
  };

  export type FlightsFlexibleChangePolicyBasedFilterValueInlineFragment = {
    __typename?: 'FlightsFlexibleChangePolicyBasedFilterValue';

    policyName: FilterPolicyType;
  };

  export type FlightsStopBasedFilterValueInlineFragment = {
    __typename?: 'FlightsStopBasedFilterValue';

    stopInfo: __StopInfo;
  };

  export type __StopInfo = {
    __typename?: 'FlightsStopInfo';

    stopFilterOperation: FlightsStopFilterOperation;

    numberOfStops: number;
  };

  export type FlightsTimeBasedFilterValueInlineFragment = {
    __typename?: 'FlightsTimeBasedFilterValue';

    timeOfDay: FlightsTimeOfDay;
  };

  export type ShowMoreToggle = FlightsToggleSearch.Fragment;

  export type FlightsCardsDisplayFilterOptionInlineFragment = {
    __typename?: 'FlightsCardsDisplayFilterOption';

    items: _________Items[];

    label: string;

    type: FlightsFilterType;

    supportsMultipleSelection: boolean;
  };

  export type _________Items = {
    __typename?: 'FlightsCardsDisplayFilterItem';

    accessibility?: _______Accessibility | null;

    card: Card;

    deselectAnalytics: _DeselectAnalytics;

    flightsSearchFilterValues: _FlightsSearchFilterValues;

    label: string;

    subLabel: string;

    selectAnalytics: _SelectAnalytics;

    selected: boolean;

    value: _Value;
  };

  export type _______Accessibility = {
    __typename?: 'FlightsAccessibilityMessage';

    onCompletion?: string | null;

    usage?: string | null;
  };

  export type Card = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type _DeselectAnalytics = FlightsAnalytics.Fragment;

  export type _FlightsSearchFilterValues = {
    __typename?: 'FlightsSearchFilterValues';

    arrivalAirportCodeFilterValue?: __ArrivalAirportCodeFilterValue | null;

    arrivalTimeFilterValue?: __ArrivalTimeFilterValue | null;

    departureAirportCodeFilterValue?: __DepartureAirportCodeFilterValue | null;

    departureTimeFilterValue?: __DepartureTimeFilterValue | null;

    durationFilterValue?: __DurationFilterValue | null;

    numOfStopFilterValue?: __NumOfStopFilterValue | null;

    preferredAirlineFilterValue?: __PreferredAirlineFilterValue | null;

    flexibleChangePolicyBasedFilterValue?: __FlexibleChangePolicyBasedFilterValue | null;
  };

  export type __ArrivalAirportCodeFilterValue = {
    __typename?: 'FlightsAirportCodeFilterValue';

    airportCode: string;
  };

  export type __ArrivalTimeFilterValue = {
    __typename?: 'FlightsTimeBasedFilterValue';

    timeOfDay: FlightsTimeOfDay;
  };

  export type __DepartureAirportCodeFilterValue = {
    __typename?: 'FlightsAirportCodeFilterValue';

    airportCode: string;
  };

  export type __DepartureTimeFilterValue = {
    __typename?: 'FlightsTimeBasedFilterValue';

    timeOfDay: FlightsTimeOfDay;
  };

  export type __DurationFilterValue = {
    __typename?: 'FlightsDurationBasedFilterValue';

    maxDuration: number;
  };

  export type __NumOfStopFilterValue = {
    __typename?: 'FlightsStopBasedFilterValue';

    stopInfo: ___StopInfo;
  };

  export type ___StopInfo = {
    __typename?: 'FlightsStopInfo';

    stopFilterOperation: FlightsStopFilterOperation;

    numberOfStops: number;
  };

  export type __PreferredAirlineFilterValue = {
    __typename?: 'FlightsPreferredAirlineFilterValue';

    carrierCode: string;
  };

  export type __FlexibleChangePolicyBasedFilterValue = {
    __typename?: 'FlightsFlexibleChangePolicyBasedFilterValue';

    policyName: FilterPolicyType;
  };

  export type _SelectAnalytics = FlightsAnalytics.Fragment;

  export type _Value =
    | _FlightsAirportCodeFilterValueInlineFragment
    | _FlightsDurationBasedFilterValueInlineFragment
    | _FlightsPreferredAirlineFilterValueInlineFragment
    | _FlightsFlexibleChangePolicyBasedFilterValueInlineFragment
    | _FlightsStopBasedFilterValueInlineFragment
    | _FlightsTimeBasedFilterValueInlineFragment;

  export type _FlightsAirportCodeFilterValueInlineFragment = {
    __typename?: 'FlightsAirportCodeFilterValue';

    airportCode: string;
  };

  export type _FlightsDurationBasedFilterValueInlineFragment = {
    __typename?: 'FlightsDurationBasedFilterValue';

    maxDuration: number;
  };

  export type _FlightsPreferredAirlineFilterValueInlineFragment = {
    __typename?: 'FlightsPreferredAirlineFilterValue';

    carrierCode: string;
  };

  export type _FlightsFlexibleChangePolicyBasedFilterValueInlineFragment = {
    __typename?: 'FlightsFlexibleChangePolicyBasedFilterValue';

    policyName: FilterPolicyType;
  };

  export type _FlightsStopBasedFilterValueInlineFragment = {
    __typename?: 'FlightsStopBasedFilterValue';

    stopInfo: ____StopInfo;
  };

  export type ____StopInfo = {
    __typename?: 'FlightsStopInfo';

    stopFilterOperation: FlightsStopFilterOperation;

    numberOfStops: number;
  };

  export type _FlightsTimeBasedFilterValueInlineFragment = {
    __typename?: 'FlightsTimeBasedFilterValue';

    timeOfDay: FlightsTimeOfDay;
  };

  export type ListingResult = FlightsLoadedListingResultInlineFragment;

  export type FlightsLoadedListingResultInlineFragment = {
    __typename?: 'FlightsLoadedListingResult';

    pinnedListingUnavailableMessage?: string | null;

    accessibilityMessage?: string | null;

    appliedFilterAccessibility?: string | null;

    appliedSortingAccessibility?: string | null;

    listings?: Listings[] | null;

    flightsListingsAnalytics: FlightsListingsAnalytics;

    listingsAction?: ListingsAction | null;
  };

  export type Listings =
    | FlightsSuggestedFilterMessageListing.Fragment
    | FlightsStandardOffer.Fragment
    | FlightsBargainFareOffer.Fragment
    | FlightsFeedback.Fragment
    | FlightsCrossSellMessage.Fragment;

  export type FlightsListingsAnalytics = {
    __typename?: 'FlightsListingsAnalytics';

    onViewedAnalytics: OnViewedAnalytics;

    pinnedListingDisplayedAnalytics?: PinnedListingDisplayedAnalytics | null;
  };

  export type OnViewedAnalytics = FlightsAnalytics.Fragment;

  export type PinnedListingDisplayedAnalytics = FlightsAnalytics.Fragment;

  export type ListingsAction = FlightAction.Fragment;

  export type OpinionLab = {
    __typename?: 'FlightsOpinionLab';

    analytics: _______________________________Analytics;

    iconAndLabel: _IconAndLabel;

    link: Url;
  };

  export type _______________________________Analytics = FlightsAnalytics.Fragment;

  export type _IconAndLabel = {
    __typename?: 'FlightsIconAndLabel';

    icon: _________________Icon;

    label: string;
  };

  export type _________________Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;
  };

  export type FlightsOpinionLab = FlightsActionAndLabelInlineFragment;

  export type FlightsActionAndLabelInlineFragment = {
    __typename?: 'FlightsActionAndLabel';

    label: string;

    selectAction: SelectAction;
  };

  export type SelectAction = FlightAction.Fragment;

  export type PageTitle = {
    __typename?: 'FlightsPageTitle';

    date?: ____Date | null;

    subTitle?: SubTitle | null;

    title: Title;
  };

  export type ____Date = {
    __typename?: 'FlightsResponsiveMessage';

    longMessage: string;

    shortMessage?: string | null;
  };

  export type SubTitle = {
    __typename?: 'FlightsResponsiveMessage';

    longMessage: string;

    shortMessage?: string | null;
  };

  export type Title = {
    __typename?: 'FlightsResponsiveMessage';

    longMessage: string;

    shortMessage?: string | null;
  };

  export type Dialogs =
    | FlightsDialogStaleSessionInlineFragment
    | FlightsDialogForcedChoiceLodgingCrossSellInlineFragment;

  export type FlightsDialogStaleSessionInlineFragment = {
    __typename?: 'FlightsDialogStaleSession';

    actions: Actions[];

    animation: FlightsDialogAnimation;

    displayedAnalytics: DisplayedAnalytics;

    header: string;

    message?: string | null;

    timeoutInSeconds: number;
  };

  export type Actions = FlightAction.Fragment;

  export type DisplayedAnalytics = FlightsAnalytics.Fragment;

  export type FlightsDialogForcedChoiceLodgingCrossSellInlineFragment = {
    __typename?: 'FlightsDialogForcedChoiceLodgingCrossSell';

    actions: _Actions[];

    animation: FlightsDialogAnimation;

    annotation: Annotation;

    header: string;

    subHeader: SubHeader;

    message?: string | null;

    displayCounter?: number | null;

    hotelDatesTitle?: string | null;

    displayedAnalytics: _DisplayedAnalytics;

    displayBlockedAnalytics: DisplayBlockedAnalytics;

    checkInDate?: CheckInDate | null;

    checkOutDate?: CheckOutDate | null;
  };

  export type _Actions = FlightAction.Fragment;

  export type Annotation = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: __________Items[];
  };

  export type __________Items = {
    __typename?: FlightsPhraseLinkNodeInlineFragment['__typename'];

    styles: FlightsPhrasePartStyle[];

    text: string;
  } & FlightsPhraseLinkNodeInlineFragment;

  export type FlightsPhraseLinkNodeInlineFragment = {
    __typename?: 'FlightsPhraseLinkNode';

    analytics: ________________________________Analytics;

    link: Url;
  };

  export type ________________________________Analytics = FlightsAnalytics.Fragment;

  export type SubHeader = {
    __typename?: 'FlightsIconAndPhrase';

    icon: __________________Icon;

    label: ____Label;
  };

  export type __________________Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type ____Label = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: ___________Items[];
  };

  export type ___________Items = {
    __typename?: 'FlightsPhrasePart';

    styles: FlightsPhrasePartStyle[];

    text: string;
  };

  export type _DisplayedAnalytics = FlightsAnalytics.Fragment;

  export type DisplayBlockedAnalytics = FlightsAnalytics.Fragment;

  export type CheckInDate = {
    __typename?: 'FlightsSearchFormDateField';

    analytics: _________________________________Analytics;

    currentError?: string | null;

    date?: _____Date | null;

    dateFormat: string;

    daysBookableInAdvance: number;

    label: string;

    placeholder: string;

    possibleErrors: _________PossibleErrors[];

    maxStayDurationAllowed?: number | null;

    possibleErrorsHeader?: PossibleErrorsHeader | null;

    doneAction: string;
  };

  export type _________________________________Analytics = FlightsAnalytics.Fragment;

  export type _____Date = {
    __typename?: 'Date';

    day: number;

    month: number;

    year: number;

    formatted: string;

    isoFormat: string;
  };

  export type _________PossibleErrors = {
    __typename?: 'FlightsSearchFormError';

    analytics: __________________________________Analytics;

    message: string;

    type: FlightsSearchFormErrorType;
  };

  export type __________________________________Analytics = FlightsAnalytics.Fragment;

  export type PossibleErrorsHeader = {
    __typename?: 'FlightsIconAndPhrase';

    icon: ___________________Icon;

    label: _____Label;
  };

  export type ___________________Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type _____Label = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: ____________Items[];
  };

  export type ____________Items = {
    __typename?: 'FlightsPhrasePart';

    styles: FlightsPhrasePartStyle[];

    text: string;
  };

  export type CheckOutDate = {
    __typename?: 'FlightsSearchFormDateField';

    analytics: ___________________________________Analytics;

    currentError?: string | null;

    date?: ______Date | null;

    dateFormat: string;

    daysBookableInAdvance: number;

    label: string;

    placeholder: string;

    possibleErrors: __________PossibleErrors[];

    maxStayDurationAllowed?: number | null;

    possibleErrorsHeader?: _PossibleErrorsHeader | null;

    doneAction: string;
  };

  export type ___________________________________Analytics = FlightsAnalytics.Fragment;

  export type ______Date = {
    __typename?: 'Date';

    day: number;

    month: number;

    year: number;

    formatted: string;

    isoFormat: string;
  };

  export type __________PossibleErrors = {
    __typename?: 'FlightsSearchFormError';

    analytics: ____________________________________Analytics;

    message: string;

    type: FlightsSearchFormErrorType;
  };

  export type ____________________________________Analytics = FlightsAnalytics.Fragment;

  export type _PossibleErrorsHeader = {
    __typename?: 'FlightsIconAndPhrase';

    icon: ____________________Icon;

    label: ______Label;
  };

  export type ____________________Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type ______Label = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: _____________Items[];
  };

  export type _____________Items = {
    __typename?: 'FlightsPhrasePart';

    styles: FlightsPhrasePartStyle[];

    text: string;
  };

  export type Banners = FlightsIconPlacard.Fragment;

  export type CheapestListingInfo = {
    __typename?: 'FlightsCheapestListingInfo';

    price: string;

    analytics: _____________________________________Analytics;

    nffAnalytics: NffAnalytics;

    deviationAnalytics?: DeviationAnalytics | null;
  };

  export type _____________________________________Analytics = FlightsAnalytics.Fragment;

  export type NffAnalytics = FlightsAnalytics.Fragment;

  export type DeviationAnalytics = FlightsAnalytics.Fragment;

  export type StepIndicator = FlightsStepIndicator.Fragment;
}

export namespace FlightsShoppingPwaFlightSearchResultsLoadingFlightsSearch {
  export type Variables = {
    context: ContextInput;
    flightsSearchContext?: FlightsSearchContextInput | null;
    journeyCriteria: FlightsJourneyCriteriaInput[];
    queryState?: FlightsQueryState | null;
    searchFilterValuesList?: FlightsSearchFilterValuesInput[] | null;
    searchPreferences?: FlightsSearchPreferencesInput | null;
    sortOption?: FlightsSortOptionTypeInput | null;
    travelerDetails?: FlightsTravelerDetailsInput[] | null;
  };

  export type Query = {
    __typename?: 'Query';

    flightsSearch: FlightsSearch;
  };

  export type FlightsSearch = {
    __typename?: 'FlightsSearchResponse';

    clientMetadata?: ClientMetadata | null;

    pageTitle?: PageTitle | null;

    listingResult?: ListingResult | null;

    sortAndFilterResult?: SortAndFilterResult | null;

    searchForm?: SearchForm | null;

    failedRequestMessaging?: FailedRequestMessaging | null;

    stepIndicator?: StepIndicator | null;
  };

  export type ClientMetadata = FlightsPwaMetadataInlineFragment;

  export type FlightsPwaMetadataInlineFragment = {
    __typename?: 'FlightsPWAMetadata';

    pageName: string;

    pageNameAnalytics: PageNameAnalytics;
  };

  export type PageNameAnalytics = FlightsAnalyticsLoading.Fragment;

  export type PageTitle = {
    __typename?: 'FlightsPageTitle';

    date?: Date | null;

    subTitle?: SubTitle | null;

    title: Title;
  };

  export type Date = {
    __typename?: 'FlightsResponsiveMessage';

    longMessage: string;

    shortMessage?: string | null;
  };

  export type SubTitle = {
    __typename?: 'FlightsResponsiveMessage';

    longMessage: string;

    shortMessage?: string | null;
  };

  export type Title = {
    __typename?: 'FlightsResponsiveMessage';

    longMessage: string;

    shortMessage?: string | null;
  };

  export type ListingResult = FlightsLoadingListingResultInlineFragment;

  export type FlightsLoadingListingResultInlineFragment = {
    __typename?: 'FlightsLoadingListingResult';

    listingsSkeletonCount: number;

    message: string;

    originDestination: string;

    progressBarDetails?: ProgressBarDetails | null;

    progressBar: FlightsProgressBarDisplay;
  };

  export type ProgressBarDetails = {
    __typename?: 'FlightsProgressBarDetails';

    accessibility: Accessibility;

    listingsLatency: number;

    sortAndFilterLatency: number;
  };

  export type Accessibility = {
    __typename?: 'FlightsSimpleLocalizationTemplate';

    initialValue?: string | null;

    template: string;

    tokens: string[];
  };

  export type SortAndFilterResult = FlightsLoadingSortAndFilterResultInlineFragment;

  export type FlightsLoadingSortAndFilterResultInlineFragment = {
    __typename?: 'FlightsLoadingSortAndFilterResult';

    filterPresentation: FilterPresentation;

    revealAction: RevealAction;
  };

  export type FilterPresentation = {
    __typename?: 'FlightsFilterLoadingPresentation';

    options: Options[];

    title?: string | null;
  };

  export type Options = {
    __typename?: 'FlightsFilterSkeletonOption';

    itemCount: number;

    label: string;

    priceFromLabel?: string | null;
  };

  export type RevealAction = {
    __typename?: 'FlightsSortAndFilterRevealAction';

    iconAndLabel: IconAndLabel;

    enabled: boolean;
  };

  export type IconAndLabel = {
    __typename?: 'FlightsIconAndLabel';

    icon: Icon;

    label: string;
  };

  export type Icon = {
    __typename?: 'Icon';

    id: string;
  };

  export type SearchForm = FlightsLoadingSearchFormInlineFragment;

  export type FlightsLoadingSearchFormInlineFragment = {
    __typename?: 'FlightsLoadingSearchForm';

    addJourneyAction?: AddJourneyAction | null;

    departureAndReturnDates?: DepartureAndReturnDates | null;

    journeys: Journeys[];

    originAndDestinationLocations?: string | null;

    searchAction?: string | null;

    searchOptions: SearchOptions[];
  };

  export type AddJourneyAction = {
    __typename?: 'FlightsAction';

    displayAction: string;

    displayType: FlightsActionDisplayType;
  };

  export type DepartureAndReturnDates = {
    __typename?: 'FlightsResponsiveMessage';

    longMessage: string;

    shortMessage?: string | null;
  };

  export type Journeys = {
    __typename?: 'FlightsSearchFormJourneyCriteria';

    departureDate: DepartureDate;

    label: Label;

    destinationLocation: DestinationLocation;

    originLocation: OriginLocation;

    returnDate?: ReturnDate | null;

    removeJourneyAction?: RemoveJourneyAction | null;

    swapLocationsAction: SwapLocationsAction;
  };

  export type DepartureDate = {
    __typename?: 'FlightsSearchFormDateField';

    date?: _Date | null;

    label: string;

    placeholder: string;
  };

  export type _Date = {
    __typename?: 'Date';

    isoFormat: string;
  };

  export type Label = {
    __typename?: 'FlightsSimpleLocalizationTemplate';

    initialValue?: string | null;

    template: string;

    tokens: string[];
  };

  export type DestinationLocation = {
    __typename?: 'FlightsSearchFormLocationField';

    icon: _Icon;

    label: string;

    placeholder: string;

    value?: string | null;
  };

  export type _Icon = {
    __typename?: 'Icon';

    id: string;
  };

  export type OriginLocation = {
    __typename?: 'FlightsSearchFormLocationField';

    icon: __Icon;

    label: string;

    placeholder: string;

    value?: string | null;
  };

  export type __Icon = {
    __typename?: 'Icon';

    id: string;
  };

  export type ReturnDate = {
    __typename?: 'FlightsSearchFormDateField';

    date?: __Date | null;

    label: string;

    placeholder: string;
  };

  export type __Date = {
    __typename?: 'Date';

    isoFormat: string;
  };

  export type RemoveJourneyAction = {
    __typename?: 'FlightsAction';

    displayAction: string;
  };

  export type SwapLocationsAction = {
    __typename?: 'FlightsSwapLocationAction';

    icon: ___Icon;
  };

  export type ___Icon = {
    __typename?: 'FlightsResponsiveIcon';

    smallView: SmallView;

    largeView: LargeView;
  };

  export type SmallView = {
    __typename?: 'Icon';

    id: string;

    size?: IconSize | null;
  };

  export type LargeView = {
    __typename?: 'Icon';

    id: string;

    size?: IconSize | null;
  };

  export type SearchOptions =
    | FlightsSearchFormAirlineOptionInlineFragment
    | FlightsSearchFormCabinClassOptionInlineFragment
    | FlightsSearchFormMoreFiltersOptionInlineFragment
    | FlightsSearchFormTravelersOptionInlineFragment
    | FlightsSearchFormTripTypeOptionInlineFragment;

  export type FlightsSearchFormAirlineOptionInlineFragment = {
    __typename?: 'FlightsSearchFormAirlineOption';

    label: string;

    icon: ____Icon;

    selectedItem: SelectedItem;
  };

  export type ____Icon = {
    __typename?: 'Icon';

    id: string;
  };

  export type SelectedItem = {
    __typename?: 'FlightsSearchFormAirlineOptionItem';

    airline: string;

    label: string;
  };

  export type FlightsSearchFormCabinClassOptionInlineFragment = {
    __typename?: 'FlightsSearchFormCabinClassOption';

    label: string;

    icon: _____Icon;

    selectedItem: _SelectedItem;
  };

  export type _____Icon = {
    __typename?: 'Icon';

    id: string;
  };

  export type _SelectedItem = {
    __typename?: 'FlightsSearchFormCabinClassOptionItem';

    cabinClass: FlightsCabinClass;

    label: string;
  };

  export type FlightsSearchFormMoreFiltersOptionInlineFragment = {
    __typename?: 'FlightsSearchFormMoreFiltersOption';

    label: string;

    icon: ______Icon;
  };

  export type ______Icon = {
    __typename?: 'Icon';

    id: string;
  };

  export type FlightsSearchFormTravelersOptionInlineFragment = {
    __typename?: 'FlightsSearchFormTravelersOption';

    label: string;

    icon: _______Icon;

    valueTemplate: ValueTemplate;

    items: Items[];
  };

  export type _______Icon = {
    __typename?: 'Icon';

    id: string;
  };

  export type ValueTemplate = {
    __typename?: 'FlightsMultiPluralLocalizationTemplate';

    oneTemplate: string;

    manyTemplate: string;

    tokens: string[];

    fewTemplate: string;

    otherTemplate: string;

    twoTemplate: string;

    zeroTemplate: string;
  };

  export type Items = {
    __typename?: 'FlightsSearchFormTravelerItem';

    label: string;

    travelerCount: number;

    type: FlightsTravelerType;
  };

  export type FlightsSearchFormTripTypeOptionInlineFragment = {
    __typename?: 'FlightsSearchFormTripTypeOption';

    icon: ________Icon;

    items: _Items[];
  };

  export type ________Icon = {
    __typename?: 'Icon';

    id: string;
  };

  export type _Items = {
    __typename?: 'FlightsSearchFormTripTypeOptionItem';

    label: string;

    selected: boolean;

    tripType: FlightsTripType;
  };

  export type FailedRequestMessaging = {
    __typename?: 'FlightsActionableErrorMessaging';

    icon: _________Icon;

    message: string;

    action: Action;
  };

  export type _________Icon = {
    __typename?: 'Icon';

    id: string;
  };

  export type Action = {
    __typename?: 'FlightsAction';

    analytics: Analytics;

    displayAction: string;
  };

  export type Analytics = FlightsAnalyticsLoading.Fragment;

  export type StepIndicator = FlightsStepIndicatorLoading.Fragment;
}

export namespace FlightsFlexSearchResults {
  export type Fragment = {
    __typename?: 'FlightsFlexibleSearchResultCell';

    valueText?: string | null;

    labelText?: string | null;

    theme: FlightsFlexibleSearchResultCellTheme;

    summary?: string | null;

    journeyDate?: string | null;

    accessibility: Accessibility;

    nextSearchCriteria?: NextSearchCriteria | null;

    selectAnalytics: SelectAnalytics;
  };

  export type Accessibility = {
    __typename?: 'FlightsFlexibleSearchCellAccessibility';

    highlightDescription?: string | null;

    selectionDescription?: string | null;
  };

  export type NextSearchCriteria = FlightsNextJourneyCriteriaValues.Fragment;

  export type SelectAnalytics = FlightsAnalyticsFlexSearch.Fragment;
}

export namespace FlightsNextJourneyCriteriaValues {
  export type Fragment = {
    __typename?: 'FlightsNextJourneyCriteriaValues';

    journeyCriteria: (JourneyCriteria | null)[];

    searchPreferences: SearchPreferences;
  };

  export type JourneyCriteria = {
    __typename?: 'FlightsJourneyCriteria';

    destination: string;

    departureDate: DepartureDate;

    origin: string;
  };

  export type DepartureDate = {
    __typename?: 'Date';

    day: number;

    month: number;

    year: number;
  };

  export type SearchPreferences = {
    __typename?: 'FlightSearchPreferences';

    cabinClass: FlightCabinClassInfo;
  };
}

export namespace FlightsFlexSearchLegendCell {
  export type Fragment = {
    __typename?: 'FlightsFlexibleSearchLegendCell';

    accessibilityMessage?: AccessibilityMessage | null;

    icon?: Icon | null;

    valueText?: string | null;

    legendTheme: FlightsFlexibleSearchLegendCellTheme;
  };

  export type AccessibilityMessage = {
    __typename?: 'FlightsAccessibilityMessage';

    usage?: string | null;
  };

  export type Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;
  };
}

export namespace FlightsFlexSearchHeaderCell {
  export type Fragment = {
    __typename?: 'FlightsFlexibleSearchHeaderCell';

    labelText?: string | null;

    valueText?: string | null;

    headerTheme: FlightsFlexibleSearchHeaderCellTheme;
  };
}

export namespace FlightsAnalyticsFlexSearch {
  export type Fragment = {
    __typename?: 'FlightsAnalytics';

    linkName: string;

    rfrr: string;
  };
}

export namespace FlightsLoadedPriceSummary {
  export type Fragment = {
    __typename?: 'FlightsLoadedPriceSummary';

    breakdown: Breakdown[];

    buttonAction: ButtonAction;

    dismiss: Dismiss;

    policies: Policies;

    title: string;

    tripTotalLabel: string;

    totals?: Totals[] | null;

    tripTotalDetails: TripTotalDetails;

    viewPriceSummary: ViewPriceSummary;
  };

  export type Breakdown = FlightsPriceSummaryGroupLoaded.Fragment;

  export type ButtonAction = FlightsActionInformationLoaded.Fragment;

  export type Dismiss = FlightsActionableInformationIconLoaded.Fragment;

  export type Policies = FlightsInformationTextSectionLoaded.Fragment;

  export type Totals = FlightsPriceSummaryGroupLoaded.Fragment;

  export type TripTotalDetails = FlightsLoadedPriceSummaryTripTotalItem.Fragment;

  export type ViewPriceSummary = FlightsActionInformationLoaded.Fragment;
}

export namespace FlightsInformationServerErrorMessaging {
  export type Fragment = {
    __typename?: 'FlightsActionableErrorMessaging';

    action: Action;

    icon: Icon;

    message: string;

    title: string;
  };

  export type Action = FlightsActionInformationLoaded.Fragment;

  export type Icon = IconInformationLoaded.Fragment;
}

export namespace FlightsMessageAndAccessibilityInformationLoaded {
  export type Fragment = {
    __typename?: 'FlightsMessageAndAccessibility';

    text: string;

    accessibilityMessage: string;
  };
}

export namespace FlightsToggleInformationLoaded {
  export type Fragment = {
    __typename?: 'FlightsToggle';

    collapseActionable: CollapseActionable;

    expandActionable: ExpandActionable;

    expanded: boolean;
  };

  export type CollapseActionable = TogglePhaseInformationLoaded.Fragment;

  export type ExpandActionable = TogglePhaseInformationLoaded.Fragment;
}

export namespace IconInformationLoaded {
  export type Fragment = {
    __typename?: 'Icon';

    description: string;

    id: string;

    size?: IconSize | null;

    withBackground?: boolean | null;
  };
}

export namespace TogglePhaseInformationLoaded {
  export type Fragment = {
    __typename?: 'TogglePhase';

    accessibilityMessage?: string | null;

    action: string;

    analytics: Analytics;

    icon?: Icon | null;
  };

  export type Analytics = FlightsAnalyticsInformationLoaded.Fragment;

  export type Icon = IconInformationLoaded.Fragment;
}

export namespace CoordinateInformationInformationLoaded {
  export type Fragment = {
    __typename?: 'CoordinateInformation';

    icon: Icon;

    overnightMessage?: string | null;

    subtitle: string;

    title: string;
  };

  export type Icon = IconInformationLoaded.Fragment;
}

export namespace FlightsImagePlacardInformationLoaded {
  export type Fragment = {
    __typename?: 'FlightsImagePlacard';

    image: Image;

    heading?: string | null;

    message: string;

    actions?: Actions[] | null;

    onViewedAnalytics?: OnViewedAnalytics | null;
  };

  export type Image = {
    __typename?: 'Image';

    url: Url;

    description: string;
  };

  export type Actions = FlightsActionInformationLoaded.Fragment;

  export type OnViewedAnalytics = FlightsAnalyticsInformationLoaded.Fragment;
}

export namespace FlightsIconPlacardInformationLoaded {
  export type Fragment = {
    __typename?: 'FlightsIconPlacard';

    heading?: string | null;

    message: string;

    icon?: Icon | null;

    actions?: Actions[] | null;

    onViewedAnalytics?: OnViewedAnalytics | null;
  };

  export type Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;

    withBackground?: boolean | null;

    size?: IconSize | null;
  };

  export type Actions = FlightsActionInformationLoaded.Fragment;

  export type OnViewedAnalytics = FlightsAnalyticsInformationLoaded.Fragment;
}

export namespace FlightsActionInformationLoaded {
  export type Fragment = {
    __typename?: 'FlightsAction';

    accessibilityMessage?: string | null;

    accessibilityCheckoutMessage?: string | null;

    analytics: Analytics;

    analyticsList: AnalyticsList[];

    displayAction: string;

    displayType: FlightsActionDisplayType;

    enable?: boolean | null;

    relativePackageableURI?: RelativePackageableUri | null;

    relativeURI?: RelativeUri | null;

    type: FlightsActionType;

    displayAnalytics?: DisplayAnalytics | null;
  };

  export type Analytics = FlightsAnalyticsInformationLoaded.Fragment;

  export type AnalyticsList = FlightsAnalyticsInformationLoaded.Fragment;

  export type RelativePackageableUri = {
    __typename?: 'HttpURI';

    relativePath: string;

    value: string;
  };

  export type RelativeUri = {
    __typename?: 'HttpURI';

    relativePath: string;

    value: string;
  };

  export type DisplayAnalytics = FlightsAnalyticsInformationLoaded.Fragment;
}

export namespace FlightsAnalyticsInformationLoaded {
  export type Fragment = {
    __typename?: 'FlightsAnalytics';

    linkName: string;

    rfrr: string;
  };
}

export namespace FlightsPriceSummaryGroupLoaded {
  export type Fragment = {
    __typename?: 'FlightsPriceSummaryGroup';

    accessibilityMessage?: string | null;

    entries: Entries[];

    title?: Title | null;
  };

  export type Entries = FlightsPriceSummaryLoadedItem.Fragment;

  export type Title = FlightsPriceSummaryLoadedItem.Fragment;
}

export namespace FlightsPriceSummaryLoadedItem {
  export type Fragment = {
    __typename?: 'FlightsPriceSummaryItem';

    label: string;

    price: string;

    roundedPrice?: string | null;
  };
}

export namespace FlightsActionableInformationIconLoaded {
  export type Fragment = {
    __typename?: 'FlightsActionableIcon';

    analytics: Analytics;

    icon: Icon;

    type: FlightsActionType;
  };

  export type Analytics = FlightsAnalyticsInformationLoaded.Fragment;

  export type Icon = IconInformationLoaded.Fragment;
}

export namespace FlightsInformationTextSectionLoaded {
  export type Fragment = {
    __typename?: 'FlightsTextSection';

    displayAction?: DisplayAction | null;

    heading?: string | null;

    messages: Messages[];

    onViewedAnalytics?: OnViewedAnalytics | null;

    displayAnalytics?: DisplayAnalytics | null;
  };

  export type DisplayAction = FlightsToggleInformationLoaded.Fragment;

  export type Messages = FlightsInformationLoadedPhrase.Fragment;

  export type OnViewedAnalytics = FlightsAnalyticsInformationLoaded.Fragment;

  export type DisplayAnalytics = FlightsAnalyticsInformationLoaded.Fragment;
}

export namespace FlightsInformationLoadedPhrase {
  export type Fragment = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    delimeter?: string | null;

    items: Items[];
  };

  export type Items = {
    __typename?: FlightsPhraseLinkNodeInlineFragment['__typename'];

    text: string;

    styles: FlightsPhrasePartStyle[];
  } & FlightsPhraseLinkNodeInlineFragment;

  export type FlightsPhraseLinkNodeInlineFragment = {
    __typename?: 'FlightsPhraseLinkNode';

    accessibility?: string | null;

    analytics: Analytics;

    displayAnalytics?: DisplayAnalytics | null;

    link: Url;

    icon?: string | null;
  };

  export type Analytics = FlightsAnalyticsInformationLoaded.Fragment;

  export type DisplayAnalytics = FlightsAnalyticsInformationLoaded.Fragment;
}

export namespace FlightsLoadedPriceSummaryTripTotalItem {
  export type Fragment = {
    __typename?: 'FlightsPriceSummaryTripTotalItem';

    ratesCurrencyMessage: string;

    tripTotal: TripTotal;
  };

  export type TripTotal = FlightsPriceSummaryLoadedItem.Fragment;
}

export namespace FlightsBaggageInformation {
  export type Fragment = {
    __typename?: 'FlightsBaggageInformation';

    label: string;

    defaultBagSelectionMessage?: string | null;

    bagFeesMoreInfo: BagFeesMoreInfo[];

    displayAnalytics?: DisplayAnalytics | null;

    displayDetailsAction?: string | null;

    dismissAction?: string | null;

    details?: Details[] | null;
  };

  export type BagFeesMoreInfo = FlightsInformationLoadedPhrase.Fragment;

  export type DisplayAnalytics = FlightsAnalyticsInformationLoaded.Fragment;

  export type Details = FlightsBaggageInformationDetail.Fragment;
}

export namespace FlightsBaggageInformationDetail {
  export type Fragment = {
    __typename?: 'FlightBaggageInformationDetail';

    topic: string;

    detail: string;
  };
}

export namespace JourneyInformation {
  export type Fragment = {
    __typename?: 'JourneyInformation';

    destinationAirportCode: string;

    originAirportCode: string;

    tripType: string;
  };
}

export namespace FlightsInformationStepIndicator {
  export type Fragment = {
    __typename?: 'FlightsStepIndicator';

    errorAnalytics: ErrorAnalytics;

    journeyContinuationId: string;
  };

  export type ErrorAnalytics = FlightsAnalyticsInformationLoading.Fragment;
}

export namespace FlightsInformationLoadingServerErrorMessaging {
  export type Fragment = {
    __typename?: 'FlightsActionableErrorMessaging';

    action: Action;

    icon: Icon;

    message: string;

    title: string;
  };

  export type Action = FlightsActionInformationLoading.Fragment;

  export type Icon = IconInformationLoading.Fragment;
}

export namespace IconInformationLoading {
  export type Fragment = {
    __typename?: 'Icon';

    id: string;
  };
}

export namespace FlightsMessageAndAccessibilityInformationLoading {
  export type Fragment = {
    __typename?: 'FlightsMessageAndAccessibility';

    text: string;

    accessibilityMessage: string;
  };
}

export namespace FlightsImagePlacardInformationLoading {
  export type Fragment = {
    __typename?: 'FlightsImagePlacard';

    image: Image;

    heading?: string | null;

    message: string;
  };

  export type Image = {
    __typename?: 'Image';

    url: Url;

    description: string;
  };
}

export namespace FlightsActionInformationLoading {
  export type Fragment = {
    __typename?: 'FlightsAction';

    accessibilityMessage?: string | null;

    analytics: Analytics;

    displayAction: string;

    displayType: FlightsActionDisplayType;

    enable?: boolean | null;

    relativePackageableURI?: RelativePackageableUri | null;

    relativeURI?: RelativeUri | null;

    type: FlightsActionType;
  };

  export type Analytics = FlightsAnalyticsInformationLoading.Fragment;

  export type RelativePackageableUri = {
    __typename?: 'HttpURI';

    relativePath: string;

    value: string;
  };

  export type RelativeUri = {
    __typename?: 'HttpURI';

    relativePath: string;

    value: string;
  };
}

export namespace FlightsAnalyticsInformationLoading {
  export type Fragment = {
    __typename?: 'FlightsAnalytics';

    linkName: string;

    rfrr: string;
  };
}

export namespace FlightsBargainFareOffer {
  export type Fragment = {
    __typename?: 'FlightsBargainFareOffer';

    bargainOfferAccessibilityMessage: string;

    accessibilityHeading?: string | null;

    bargainPricingInformation?: BargainPricingInformation | null;

    description: Description;

    header: Header;

    image: _Image;

    selectOfferAction: SelectOfferAction;

    journeys: Journeys[];
  };

  export type BargainPricingInformation = {
    __typename?: 'FlightsPricingInformation';

    cancellationMessage?: string | null;

    loyaltyMessage?: LoyaltyMessage | null;

    price: Price;

    mainPrice: MainPrice;

    pricePerTraveler: PricePerTraveler;

    taxesLabel?: string | null;

    totalLabel: string;

    totalPriceForAllTravelers?: TotalPriceForAllTravelers | null;

    tripType?: string | null;
  };

  export type LoyaltyMessage = {
    __typename?: 'FlightsImageAndLabel';

    image: Image;

    label: Label;
  };

  export type Image = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type Label = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: Items[];
  };

  export type Items = {
    __typename?: FlightsPhraseLinkNodeInlineFragment['__typename'];

    styles: FlightsPhrasePartStyle[];

    text: string;
  } & FlightsPhraseLinkNodeInlineFragment;

  export type FlightsPhraseLinkNodeInlineFragment = {
    __typename?: 'FlightsPhraseLinkNode';

    analytics: Analytics;
  };

  export type Analytics = FlightsAnalytics.Fragment;

  export type Price = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: _Items[];
  };

  export type _Items = {
    __typename?: _FlightsPhraseLinkNodeInlineFragment['__typename'];

    styles: FlightsPhrasePartStyle[];

    text: string;
  } & _FlightsPhraseLinkNodeInlineFragment;

  export type _FlightsPhraseLinkNodeInlineFragment = {
    __typename?: 'FlightsPhraseLinkNode';

    analytics: _Analytics;
  };

  export type _Analytics = {
    __typename?: 'FlightsAnalytics';

    linkName: string;

    rfrr: string;
  };

  export type MainPrice = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: __Items[];
  };

  export type __Items = {
    __typename?: __FlightsPhraseLinkNodeInlineFragment['__typename'];

    styles: FlightsPhrasePartStyle[];

    text: string;
  } & __FlightsPhraseLinkNodeInlineFragment;

  export type __FlightsPhraseLinkNodeInlineFragment = {
    __typename?: 'FlightsPhraseLinkNode';

    analytics: __Analytics;
  };

  export type __Analytics = {
    __typename?: 'FlightsAnalytics';

    linkName: string;

    rfrr: string;
  };

  export type PricePerTraveler = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: ___Items[];
  };

  export type ___Items = {
    __typename?: ___FlightsPhraseLinkNodeInlineFragment['__typename'];

    styles: FlightsPhrasePartStyle[];

    text: string;
  } & ___FlightsPhraseLinkNodeInlineFragment;

  export type ___FlightsPhraseLinkNodeInlineFragment = {
    __typename?: 'FlightsPhraseLinkNode';

    analytics: ___Analytics;
  };

  export type ___Analytics = FlightsAnalytics.Fragment;

  export type TotalPriceForAllTravelers = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: ____Items[];
  };

  export type ____Items = {
    __typename?: ____FlightsPhraseLinkNodeInlineFragment['__typename'];

    styles: FlightsPhrasePartStyle[];

    text: string;
  } & ____FlightsPhraseLinkNodeInlineFragment;

  export type ____FlightsPhraseLinkNodeInlineFragment = {
    __typename?: 'FlightsPhraseLinkNode';

    analytics: ____Analytics;
  };

  export type ____Analytics = FlightsAnalytics.Fragment;

  export type Description = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: _____Items[];
  };

  export type _____Items = {
    __typename?: _____FlightsPhraseLinkNodeInlineFragment['__typename'];

    styles: FlightsPhrasePartStyle[];

    text: string;
  } & _____FlightsPhraseLinkNodeInlineFragment;

  export type _____FlightsPhraseLinkNodeInlineFragment = {
    __typename?: 'FlightsPhraseLinkNode';

    analytics: _____Analytics;

    link: Url;
  };

  export type _____Analytics = FlightsAnalytics.Fragment;

  export type Header = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: ______Items[];
  };

  export type ______Items = {
    __typename?: ______FlightsPhraseLinkNodeInlineFragment['__typename'];

    text: string;

    styles: FlightsPhrasePartStyle[];
  } & ______FlightsPhraseLinkNodeInlineFragment;

  export type ______FlightsPhraseLinkNodeInlineFragment = {
    __typename?: 'FlightsPhraseLinkNode';

    link: Url;

    analytics: ______Analytics;
  };

  export type ______Analytics = FlightsAnalytics.Fragment;

  export type _Image = {
    __typename?: 'Image';

    url: Url;
  };

  export type SelectOfferAction = FlightAction.Fragment;

  export type Journeys = {
    __typename?: 'FlightsOfferJourney';

    flightsJourneyAvailableFaresInformation?: FlightsJourneyAvailableFaresInformation | null;
  };

  export type FlightsJourneyAvailableFaresInformation = FlightsJourneyAvailableFares.Fragment;
}

export namespace FlightsSuggestedFilterMessageListing {
  export type Fragment = {
    __typename?: 'FlightsSuggestedFilterMessageListing';

    suggestedFilterDetails: SuggestedFilterDetails;

    suggestedFilter: SuggestedFilter;
  };

  export type SuggestedFilterDetails = FlightsImagePlacardInlineFragment;

  export type FlightsImagePlacardInlineFragment = {
    __typename?: 'FlightsImagePlacard';

    image: Image;

    heading?: string | null;

    message: string;

    actions?: Actions[] | null;
  };

  export type Image = {
    __typename?: 'Image';

    url: Url;
  };

  export type Actions = FlightsActionInlineFragment;

  export type FlightsActionInlineFragment = {
    __typename?: 'FlightsAction';

    displayAction: string;

    displayType: FlightsActionDisplayType;

    type: FlightsActionType;

    analytics: Analytics;
  };

  export type Analytics = FlightsAnalytics.Fragment;

  export type SuggestedFilter = FlightsSuggestedFilterItemInlineFragment;

  export type FlightsSuggestedFilterItemInlineFragment = {
    __typename?: 'FlightsSuggestedFilterItem';

    selected: boolean;

    accessibility?: Accessibility | null;

    label: string;

    value: Value;

    type: FlightsFilterType;
  };

  export type Accessibility = {
    __typename?: 'FlightsAccessibilityMessage';

    usage?: string | null;

    onCompletion?: string | null;
  };

  export type Value = FlightsFlexibleChangePolicyBasedFilterValueInlineFragment;

  export type FlightsFlexibleChangePolicyBasedFilterValueInlineFragment = {
    __typename?: 'FlightsFlexibleChangePolicyBasedFilterValue';

    policyName: FilterPolicyType;
  };
}

export namespace FlightsFeedback {
  export type Fragment = {
    __typename?: 'FlightsFeedback';

    feedbackLinkAction: FeedbackLinkAction;

    iconAndLabel: IconAndLabel;
  };

  export type FeedbackLinkAction = FlightAction.Fragment;

  export type IconAndLabel = {
    __typename?: 'FlightsIconAndLabel';

    icon: Icon;

    label: string;

    accessibility?: string | null;
  };

  export type Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;
  };
}

export namespace MultiItemSearchContext {
  export type Fragment = {
    __typename?: 'MultiItemSearchContext';

    flights?: Flights[] | null;
  };

  export type Flights = {
    __typename?: 'FlightSearchCriteria';

    primary: Primary;
  };

  export type Primary = {
    __typename?: 'PrimaryFlightCriteria';

    journeyCriterias: JourneyCriterias[];

    searchPreferences?: SearchPreferences | null;

    tripType: FlightsTripType;

    travelers: Travelers[];
  };

  export type JourneyCriterias = {
    __typename?: 'FlightsJourneyCriteria';

    departureDate: DepartureDate;

    origin: string;

    destination: string;
  };

  export type DepartureDate = {
    __typename?: 'Date';

    day: number;

    month: number;

    year: number;
  };

  export type SearchPreferences = {
    __typename?: 'FlightsSearchPreferences';

    cabinClass: FlightsCabinClass;

    advancedFilters?: FlightsAdvancedFilterType[] | null;
  };

  export type Travelers = {
    __typename?: 'TravelerDetails';

    age?: number | null;

    type: TravelerDetailsType;
  };
}

export namespace FlightsCrossSellMessage {
  export type Fragment = {
    __typename?: 'FlightsCrossSellMessage';

    multiItemFlightCrossSellPrimer?: MultiItemFlightCrossSellPrimer | null;
  };

  export type MultiItemFlightCrossSellPrimer = {
    __typename?: 'MultiItemFlightCrossSellPrimer';

    flightCrossSellProductType?: FlightCrossSellProductType | null;

    multiItemSearchContext: MultiItemSearchContext;
  };

  export type MultiItemSearchContext = MultiItemSearchContext.Fragment;
}

export namespace FlightsStandardOffer {
  export type Fragment = {
    __typename?: 'FlightsStandardOffer';

    accessibilityHeading?: string | null;

    accessibilityMessage?: string | null;

    pinnedOfferMessage?: string | null;

    baggageFeesInformation?: BaggageFeesInformation | null;

    badges?: Badges[] | null;

    journeys: Journeys[];

    pricingInformation: PricingInformation;

    restrictiveFareRules?: RestrictiveFareRules | null;

    selectOfferAction: SelectOfferAction;

    specialFareType?: string | null;

    sponsoredAirline?: SponsoredAirline | null;

    tag?: Tag | null;

    flightsOfferAnalytics: FlightsOfferAnalytics;
  };

  export type BaggageFeesInformation = {
    __typename?: 'FlightsOfferBaggageFeesInformation';

    analytics: Analytics;

    icon: Icon;

    label: string;

    link?: Url | null;
  };

  export type Analytics = FlightsAnalytics.Fragment;

  export type Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type Badges = {
    __typename?: 'FlightsBadge';

    accessibilityMessage?: string | null;

    icon?: _Icon | null;

    text?: string | null;

    type: FlightsBadgeTheme;
  };

  export type _Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;
  };

  export type Journeys = {
    __typename?: 'FlightsOfferJourney';

    airlines: Airlines[];

    cabinClass: string;

    departureAndArrivalTime: DepartureAndArrivalTime;

    departureAndArrivalLocations: string;

    layoverInformation?: string | null;

    differentDayArrival?: string | null;

    differentDayArrivalAccessibilityMessage?: string | null;

    displayAction: DisplayAction;

    durationAndStops: string;

    flightOperatedBy?: string | null;

    label: string;

    urgencyMessage?: string | null;

    urgencyAccessibilityMessage?: string | null;

    stringifiedFlightsJourneyAvailableFaresInformation?: string | null;

    flightsJourneyAvailableFaresInformation?: FlightsJourneyAvailableFaresInformation | null;

    hygieneAmenitiesMessage?: string | null;

    hygieneAmenitiesPresentation?: HygieneAmenitiesPresentation | null;
  };

  export type Airlines = {
    __typename?: 'FlightsImageAndLabel';

    image: Image;

    text: string;
  };

  export type Image = {
    __typename?: 'Image';

    url: Url;

    description: string;
  };

  export type DepartureAndArrivalTime = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: Items[];
  };

  export type Items = {
    __typename?: 'FlightsPhrasePart';

    styles: FlightsPhrasePartStyle[];

    text: string;
  };

  export type DisplayAction = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type FlightsJourneyAvailableFaresInformation = {
    __typename?: 'FlightsJourneyAvailableFares';

    flightsJourneyHeaders: FlightsJourneyHeaders;

    flightsJourneyInformation?: FlightsJourneyInformation | null;

    flightsJourneySummary: FlightsJourneySummary;

    fareChoiceInformation?: FareChoiceInformation | null;

    dismissDetailedJourneyInformation: DismissDetailedJourneyInformation;

    openAccessibility: string;
  };

  export type FlightsJourneyHeaders = {
    __typename?: 'FlightsJourneyHeaders';

    heading: string;

    flightsJourneySubheadingImage?: FlightsJourneySubheadingImage | null;

    flightsJourneySubheading: string;
  };

  export type FlightsJourneySubheadingImage = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type FlightsJourneyInformation = FlightsJourneyInformation.Fragment;

  export type FlightsJourneySummary = {
    __typename?: 'FlightsJourneySummary';

    heading: Heading;

    differentDayArrival?: DifferentDayArrival | null;

    basicFlightDetails: BasicFlightDetails[];
  };

  export type Heading = {
    __typename?: 'FlightsMessageAndAccessibility';

    text: string;

    accessibilityMessage: string;
  };

  export type DifferentDayArrival = {
    __typename?: 'FlightsMessageAndAccessibility';

    text: string;

    accessibilityMessage: string;
  };

  export type BasicFlightDetails = {
    __typename?: 'FlightsMessageAndAccessibility';

    text: string;

    accessibilityMessage: string;
  };

  export type FareChoiceInformation = {
    __typename?: 'FlightsFareChoiceInformation';

    heading: _Heading;

    accessibleHeading: string;

    message: string;

    tripTypePerTraveler: string;

    displayAnalytics: DisplayAnalytics;

    scrollAnalytics: ScrollAnalytics;

    fareTypes: FareTypes[];

    defaultBaggageInformation: DefaultBaggageInformation;

    hideFareChoiceDetails?: boolean | null;
  };

  export type _Heading = {
    __typename?: 'FlightsResponsiveMessage';

    longMessage: string;

    shortMessage?: string | null;
  };

  export type DisplayAnalytics = FlightsAnalytics.Fragment;

  export type ScrollAnalytics = FlightsAnalytics.Fragment;

  export type FareTypes = {
    __typename?: 'FlightsJourneyFare';

    name: string;

    cabinClass: string;

    accessibilityMessage: string;

    formattedPrice: FormattedPrice;

    formattedMainPrice: FormattedMainPrice;

    totalPrice: string;

    identifier: string;

    selected: boolean;

    clickEventAnalytics: ClickEventAnalytics;

    fareScrollAnalytics: FareScrollAnalytics;

    collapsedRules: CollapsedRules;

    expandedRules: ExpandedRules[];

    baggageFeesInformation: _BaggageFeesInformation;

    showMoreToggle: ShowMoreToggle;

    showMoreAmenitiesToggle?: ShowMoreAmenitiesToggle | null;

    chooseFareAction: ChooseFareAction;

    recommendation?: Recommendation | null;
  };

  export type FormattedPrice = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: _Items[];
  };

  export type _Items = {
    __typename?: 'FlightsPhrasePart';

    text: string;

    styles: FlightsPhrasePartStyle[];
  };

  export type FormattedMainPrice = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: __Items[];
  };

  export type __Items = {
    __typename?: 'FlightsPhrasePart';

    text: string;

    styles: FlightsPhrasePartStyle[];
  };

  export type ClickEventAnalytics = FlightsAnalytics.Fragment;

  export type FareScrollAnalytics = FlightsAnalytics.Fragment;

  export type CollapsedRules = FlightsJourneyAmenities.Fragment;

  export type ExpandedRules = FlightsJourneyAmenitiesWithLabel.Fragment;

  export type _BaggageFeesInformation = {
    __typename?: 'FlightsBaggageInformation';

    label: string;

    defaultBagSelectionMessage?: string | null;

    bagFeesMoreInfo: BagFeesMoreInfo[];

    displayDetailsAction?: string | null;

    dismissAction?: string | null;

    details?: Details[] | null;
  };

  export type BagFeesMoreInfo = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    delimeter?: string | null;

    items: ___Items[];
  };

  export type ___Items = {
    __typename?: FlightsPhraseLinkNodeInlineFragment['__typename'];

    text: string;

    styles: FlightsPhrasePartStyle[];
  } & FlightsPhraseLinkNodeInlineFragment;

  export type FlightsPhraseLinkNodeInlineFragment = {
    __typename?: 'FlightsPhraseLinkNode';

    accessibility?: string | null;

    analytics: _Analytics;

    link: Url;

    icon?: string | null;
  };

  export type _Analytics = FlightsAnalytics.Fragment;

  export type Details = {
    __typename?: 'FlightBaggageInformationDetail';

    topic: string;

    detail: string;
  };

  export type ShowMoreToggle = FlightsToggleSearch.Fragment;

  export type ShowMoreAmenitiesToggle = FlightsToggleSearch.Fragment;

  export type ChooseFareAction = {
    __typename?: 'FlightsAction';

    analyticsList: AnalyticsList[];

    displayAction: string;

    displayType: FlightsActionDisplayType;

    type: FlightsActionType;

    accessibilityMessage?: string | null;

    relativeURI?: RelativeUri | null;

    relativePackageableURI?: RelativePackageableUri | null;

    journeySearchCriteria?: JourneySearchCriteria | null;

    stepIndicator?: StepIndicator | null;
  };

  export type AnalyticsList = {
    __typename?: 'FlightsAnalytics';

    linkName: string;

    rfrr: string;
  };

  export type RelativeUri = {
    __typename?: 'HttpURI';

    relativePath: string;

    value: string;
  };

  export type RelativePackageableUri = {
    __typename?: 'HttpURI';

    relativePath: string;

    value: string;
  };

  export type JourneySearchCriteria = {
    __typename?: 'FlightsJourneySearchCriteria';

    previousFlightSelections?: PreviousFlightSelections[] | null;
  };

  export type PreviousFlightSelections = {
    __typename?: 'JourneyFlightSelection';

    journeyIndex: number;

    offerIdentifier: string;
  };

  export type StepIndicator = FlightsStepIndicator.Fragment;

  export type Recommendation = {
    __typename?: 'FlightsBadge';

    text?: string | null;

    type: FlightsBadgeTheme;
  };

  export type DefaultBaggageInformation = {
    __typename?: 'FlightsBaggageInformation';

    label: string;

    defaultBagSelectionMessage?: string | null;

    bagFeesMoreInfo: _BagFeesMoreInfo[];

    displayDetailsAction?: string | null;

    dismissAction?: string | null;

    details?: _Details[] | null;
  };

  export type _BagFeesMoreInfo = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    delimeter?: string | null;

    items: ____Items[];
  };

  export type ____Items = {
    __typename?: 'FlightsPhrasePart';

    text: string;
  };

  export type _Details = {
    __typename?: 'FlightBaggageInformationDetail';

    topic: string;

    detail: string;
  };

  export type DismissDetailedJourneyInformation = {
    __typename?: 'FlightsActionableIcon';

    icon: __Icon;

    analytics: __Analytics;
  };

  export type __Icon = IconSearch.Fragment;

  export type __Analytics = FlightsAnalytics.Fragment;

  export type HygieneAmenitiesPresentation = {
    __typename?: 'FlightsHygieneAmenitiesPresentation';

    displayAction?: _DisplayAction | null;

    airlineAmenityGroups: AirlineAmenityGroups[];

    disclaimerMessage: string;
  };

  export type _DisplayAction = {
    __typename?: 'FlightsTextSection';

    heading?: string | null;

    onViewedAnalytics?: OnViewedAnalytics | null;
  };

  export type OnViewedAnalytics = FlightsAnalytics.Fragment;

  export type AirlineAmenityGroups = {
    __typename?: 'FlightsAirlineAmenityGroup';

    headerText?: string | null;

    amenities?: Amenities[] | null;
  };

  export type Amenities = {
    __typename?: 'FlightsIconAndLabel';

    icon: ___Icon;

    label: string;
  };

  export type ___Icon = {
    __typename?: 'Icon';

    id: string;
  };

  export type PricingInformation = {
    __typename?: 'FlightsPricingInformation';

    loyaltyMessage?: LoyaltyMessage | null;

    price: Price;

    mainPrice: MainPrice;

    subPrice?: SubPrice | null;

    pricePerTraveler: PricePerTraveler;

    taxesLabel?: string | null;

    totalLabel: string;

    totalPriceForAllTravelers?: TotalPriceForAllTravelers | null;

    tripType?: string | null;
  };

  export type LoyaltyMessage = {
    __typename?: 'FlightsImageAndLabel';

    image: _Image;

    label: Label;
  };

  export type _Image = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type Label = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: _____Items[];
  };

  export type _____Items = {
    __typename?: 'FlightsPhrasePart';

    text: string;

    styles: FlightsPhrasePartStyle[];
  };

  export type Price = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: ______Items[];
  };

  export type ______Items = {
    __typename?: 'FlightsPhrasePart';

    text: string;

    styles: FlightsPhrasePartStyle[];
  };

  export type MainPrice = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: _______Items[];
  };

  export type _______Items = {
    __typename?: 'FlightsPhrasePart';

    text: string;

    styles: FlightsPhrasePartStyle[];
  };

  export type SubPrice = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: ________Items[];
  };

  export type ________Items = {
    __typename?: 'FlightsPhrasePart';

    text: string;

    styles: FlightsPhrasePartStyle[];
  };

  export type PricePerTraveler = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: _________Items[];
  };

  export type _________Items = {
    __typename?: 'FlightsPhrasePart';

    text: string;

    styles: FlightsPhrasePartStyle[];
  };

  export type TotalPriceForAllTravelers = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: __________Items[];
  };

  export type __________Items = {
    __typename?: 'FlightsPhrasePart';

    text: string;

    styles: FlightsPhrasePartStyle[];
  };

  export type RestrictiveFareRules = {
    __typename?: 'FlightsRestrictiveFareRules';

    dismissLabel: string;

    displayAction: __DisplayAction;

    rules: string[];

    title: string;
  };

  export type __DisplayAction = {
    __typename?: 'FlightsIconAndPhrase';

    icon: ____Icon;

    label: _Label;
  };

  export type ____Icon = {
    __typename?: 'Icon';

    id: string;

    description: string;
  };

  export type _Label = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: ___________Items[];
  };

  export type ___________Items = {
    __typename?: 'FlightsPhrasePart';

    styles: FlightsPhrasePartStyle[];

    text: string;
  };

  export type SelectOfferAction = FlightAction.Fragment;

  export type SponsoredAirline = {
    __typename?: 'FlightsOfferSponsoredAirline';

    airlineCode?: string | null;

    adUnitID?: string | null;

    advertiserID?: string | null;

    creativeID?: string | null;

    clickTrackingURL?: string | null;

    delayedImpressionURL?: string | null;

    orderID?: string | null;

    sponsoredHeader?: string | null;

    sponsoredText?: string | null;
  };

  export type Tag = {
    __typename?: 'FlightsOfferTag';

    image: __Image;

    message: string;
  };

  export type __Image = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type FlightsOfferAnalytics = {
    __typename?: 'FlightsOfferAnalytics';

    onViewedAnalytics: _OnViewedAnalytics;
  };

  export type _OnViewedAnalytics = FlightsAnalytics.Fragment;
}

export namespace FlightsToggleSearch {
  export type Fragment = {
    __typename?: 'FlightsToggle';

    collapseActionable: CollapseActionable;

    expandActionable: ExpandActionable;

    expanded: boolean;
  };

  export type CollapseActionable = TogglePhaseSearch.Fragment;

  export type ExpandActionable = TogglePhaseSearch.Fragment;
}

export namespace IconSearch {
  export type Fragment = {
    __typename?: 'Icon';

    description: string;

    id: string;

    size?: IconSize | null;

    withBackground?: boolean | null;
  };
}

export namespace TogglePhaseSearch {
  export type Fragment = {
    __typename?: 'TogglePhase';

    accessibilityMessage?: string | null;

    action: string;

    analytics: Analytics;

    icon?: Icon | null;
  };

  export type Analytics = FlightsAnalytics.Fragment;

  export type Icon = IconSearch.Fragment;
}

export namespace FlightsAnalytics {
  export type Fragment = {
    __typename?: 'FlightsAnalytics';

    linkName: string;

    rfrr: string;
  };
}

export namespace FlightsIconPlacard {
  export type Fragment = {
    __typename?: 'FlightsIconPlacard';

    heading?: string | null;

    message: string;

    icon?: Icon | null;

    actions?: Actions[] | null;
  };

  export type Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;
  };

  export type Actions = FlightAction.Fragment;
}

export namespace FlightAction {
  export type Fragment = {
    __typename?: 'FlightsAction';

    analytics: Analytics;

    analyticsList: AnalyticsList[];

    displayAnalytics?: DisplayAnalytics | null;

    displayAction: string;

    displayType: FlightsActionDisplayType;

    type: FlightsActionType;

    accessibilityMessage?: string | null;

    relativeURI?: RelativeUri | null;

    relativePackageableURI?: RelativePackageableUri | null;

    stepIndicator?: StepIndicator | null;

    searchPagination?: SearchPagination | null;
  };

  export type Analytics = FlightsAnalytics.Fragment;

  export type AnalyticsList = FlightsAnalytics.Fragment;

  export type DisplayAnalytics = FlightsAnalytics.Fragment;

  export type RelativeUri = {
    __typename?: 'HttpURI';

    relativePath: string;

    value: string;
  };

  export type RelativePackageableUri = {
    __typename?: 'HttpURI';

    relativePath: string;

    value: string;
  };

  export type StepIndicator = FlightsStepIndicator.Fragment;

  export type SearchPagination = Pagination.Fragment;
}

export namespace FlightsStepIndicator {
  export type Fragment = {
    __typename?: 'FlightsStepIndicator';

    errorAnalytics: ErrorAnalytics;

    journeyContinuationId: string;
  };

  export type ErrorAnalytics = FlightsAnalytics.Fragment;
}

export namespace CoordinateInformationSearch {
  export type Fragment = {
    __typename?: 'CoordinateInformation';

    icon: Icon;

    overnightMessage?: string | null;

    subtitle: string;

    title: string;
  };

  export type Icon = IconSearch.Fragment;
}

export namespace FlightsJourneyAvailableFares {
  export type Fragment = {
    __typename?: 'FlightsJourneyAvailableFares';

    flightsJourneyHeaders: FlightsJourneyHeaders;

    flightsJourneyInformation?: FlightsJourneyInformation | null;

    flightsJourneySummary: FlightsJourneySummary;

    fareChoiceInformation?: FareChoiceInformation | null;

    dismissDetailedJourneyInformation: DismissDetailedJourneyInformation;

    applySelection: ApplySelection;

    flightsJourneyPolicies?: FlightsJourneyPolicies | null;
  };

  export type FlightsJourneyHeaders = {
    __typename?: 'FlightsJourneyHeaders';

    heading: string;

    flightsJourneySubheadingImage?: FlightsJourneySubheadingImage | null;

    flightsJourneySubheading: string;
  };

  export type FlightsJourneySubheadingImage = {
    __typename?: 'Image';

    description: string;

    url: Url;
  };

  export type FlightsJourneyInformation = FlightsJourneyInformation.Fragment;

  export type FlightsJourneySummary = {
    __typename?: FlightsBargainJourneySummaryInlineFragment['__typename'];

    heading: Heading;

    differentDayArrival?: DifferentDayArrival | null;

    basicFlightDetails: BasicFlightDetails[];
  } & FlightsBargainJourneySummaryInlineFragment;

  export type Heading = {
    __typename?: 'FlightsMessageAndAccessibility';

    text: string;

    accessibilityMessage: string;
  };

  export type DifferentDayArrival = {
    __typename?: 'FlightsMessageAndAccessibility';

    text: string;

    accessibilityMessage: string;
  };

  export type BasicFlightDetails = {
    __typename?: 'FlightsMessageAndAccessibility';

    text: string;

    accessibilityMessage: string;
  };

  export type FlightsBargainJourneySummaryInlineFragment = {
    __typename?: 'FlightsBargainJourneySummary';

    formattedPrice?: FormattedPrice | null;

    tripTypePerTraveler?: string | null;

    totalPrice?: string | null;
  };

  export type FormattedPrice = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: Items[];
  };

  export type Items = {
    __typename?: 'FlightsPhrasePart';

    text: string;

    styles: FlightsPhrasePartStyle[];
  };

  export type FareChoiceInformation = {
    __typename?: 'FlightsFareChoiceInformation';

    heading: _Heading;

    accessibleHeading: string;

    message: string;

    fareTypes: FareTypes[];

    defaultBaggageInformation: DefaultBaggageInformation;
  };

  export type _Heading = {
    __typename?: 'FlightsResponsiveMessage';

    longMessage: string;

    shortMessage?: string | null;
  };

  export type FareTypes = {
    __typename?: 'FlightsJourneyFare';

    name: string;

    cabinClass: string;

    formattedPrice: _FormattedPrice;

    identifier: string;

    selected: boolean;

    collapsedRules: CollapsedRules;

    expandedRules: ExpandedRules[];

    baggageFeesInformation: BaggageFeesInformation;

    showMoreToggle: ShowMoreToggle;

    showMoreAmenitiesToggle?: ShowMoreAmenitiesToggle | null;

    chooseFareAction: ChooseFareAction;
  };

  export type _FormattedPrice = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: _Items[];
  };

  export type _Items = {
    __typename?: 'FlightsPhrasePart';

    text: string;

    styles: FlightsPhrasePartStyle[];
  };

  export type CollapsedRules = FlightsJourneyAmenities.Fragment;

  export type ExpandedRules = FlightsJourneyAmenitiesWithLabel.Fragment;

  export type BaggageFeesInformation = {
    __typename?: 'FlightsBaggageInformation';

    label: string;

    defaultBagSelectionMessage?: string | null;

    bagFeesMoreInfo: BagFeesMoreInfo[];

    displayDetailsAction?: string | null;

    dismissAction?: string | null;

    details?: Details[] | null;
  };

  export type BagFeesMoreInfo = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    delimeter?: string | null;

    items: __Items[];
  };

  export type __Items = {
    __typename?: FlightsPhraseLinkNodeInlineFragment['__typename'];

    text: string;

    styles: FlightsPhrasePartStyle[];
  } & FlightsPhraseLinkNodeInlineFragment;

  export type FlightsPhraseLinkNodeInlineFragment = {
    __typename?: 'FlightsPhraseLinkNode';

    accessibility?: string | null;

    analytics: Analytics;

    link: Url;
  };

  export type Analytics = FlightsAnalytics.Fragment;

  export type Details = {
    __typename?: 'FlightBaggageInformationDetail';

    topic: string;

    detail: string;
  };

  export type ShowMoreToggle = FlightsToggleSearch.Fragment;

  export type ShowMoreAmenitiesToggle = FlightsToggleSearch.Fragment;

  export type ChooseFareAction = FlightAction.Fragment;

  export type DefaultBaggageInformation = {
    __typename?: 'FlightsBaggageInformation';

    label: string;

    defaultBagSelectionMessage?: string | null;

    bagFeesMoreInfo: _BagFeesMoreInfo[];

    displayDetailsAction?: string | null;

    dismissAction?: string | null;

    details?: _Details[] | null;
  };

  export type _BagFeesMoreInfo = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    delimeter?: string | null;

    items: ___Items[];
  };

  export type ___Items = {
    __typename?: _FlightsPhraseLinkNodeInlineFragment['__typename'];

    text: string;

    styles: FlightsPhrasePartStyle[];
  } & _FlightsPhraseLinkNodeInlineFragment;

  export type _FlightsPhraseLinkNodeInlineFragment = {
    __typename?: 'FlightsPhraseLinkNode';

    accessibility?: string | null;

    analytics: _Analytics;

    link: Url;
  };

  export type _Analytics = FlightsAnalytics.Fragment;

  export type _Details = {
    __typename?: 'FlightBaggageInformationDetail';

    topic: string;

    detail: string;
  };

  export type DismissDetailedJourneyInformation = {
    __typename?: 'FlightsActionableIcon';

    icon: Icon;
  };

  export type Icon = IconSearch.Fragment;

  export type ApplySelection = FlightAction.Fragment;

  export type FlightsJourneyPolicies = {
    __typename?: 'FlightsTextSection';

    messages: Messages[];
  };

  export type Messages = {
    __typename?: 'FlightsPhrase';

    completeText: string;

    items: ____Items[];
  };

  export type ____Items = {
    __typename?: 'FlightsPhrasePart';

    text: string;

    styles: FlightsPhrasePartStyle[];
  };
}

export namespace FlightsJourneyAmenities {
  export type Fragment = {
    __typename?: 'FlightsJourneyAmenities';

    accessibilityMessage: string;

    amenities: Amenities[];

    analytics?: Analytics | null;
  };

  export type Amenities = {
    __typename?: 'FlightsIconAndLabel';

    icon: Icon;

    label: string;

    accessibility?: string | null;
  };

  export type Icon = {
    __typename?: 'Icon';

    description: string;

    id: string;

    withBackground?: boolean | null;
  };

  export type Analytics = FlightsAnalytics.Fragment;
}

export namespace FlightsJourneyAmenitiesWithLabel {
  export type Fragment = {
    __typename?: 'FlightsJourneyAmenitiesWithLabel';

    label: string;

    rules: Rules;
  };

  export type Rules = FlightsJourneyAmenities.Fragment;
}

export namespace Pagination {
  export type Fragment = {
    __typename?: 'Pagination';

    size?: number | null;

    startingIndex?: number | null;
  };
}

export namespace FlightsJourneyInformation {
  export type Fragment = {
    __typename?: 'FlightsDetailedJourneyInformation';

    details: Details;

    flightJourneyDetails: FlightJourneyDetails;
  };

  export type Details = FlightsToggleSearch.Fragment;

  export type FlightJourneyDetails = {
    __typename?: 'FlightsJourneyDetails';

    journeyParts: JourneyParts[];
  };

  export type JourneyParts = {
    __typename?: 'JourneyPart';

    connectionAdditionalInformation?: ConnectionAdditionalInformation | null;

    flightsConnectionInformation: FlightsConnectionInformation;
  };

  export type ConnectionAdditionalInformation = {
    __typename?: 'AdditionalInformation';

    durationAndStop: string;

    nextFlightOriginAirport?: string | null;
  };

  export type FlightsConnectionInformation = {
    __typename?: 'FlightsConnectionInformation';

    flightsConnection: FlightsConnection;

    governmentApprovalMessage?: string | null;
  };

  export type FlightsConnection = {
    __typename?: 'FlightsConnection';

    aircraftModel?: string | null;

    airlineInfo: string;

    cabinClassAndBookingCode: string;

    connectionArrival: ConnectionArrival;

    connectionDeparture: ConnectionDeparture;

    duration: string;

    journeyAmenities?: JourneyAmenities | null;
  };

  export type ConnectionArrival = CoordinateInformationSearch.Fragment;

  export type ConnectionDeparture = CoordinateInformationSearch.Fragment;

  export type JourneyAmenities = {
    __typename?: 'FlightsJourneyAmenities';

    accessibilityMessage: string;

    amenities: Amenities[];

    analytics?: Analytics | null;
  };

  export type Amenities = {
    __typename?: 'FlightsIconAndLabel';

    accessibility?: string | null;

    icon: Icon;

    label: string;
  };

  export type Icon = IconSearch.Fragment;

  export type Analytics = FlightsAnalytics.Fragment;
}

export namespace FlightsAnalyticsLoading {
  export type Fragment = {
    __typename?: 'FlightsAnalytics';

    linkName: string;

    rfrr: string;
  };
}

export namespace FlightsStepIndicatorLoading {
  export type Fragment = {
    __typename?: 'FlightsStepIndicator';

    errorAnalytics: ErrorAnalytics;

    journeyContinuationId: string;
  };

  export type ErrorAnalytics = FlightsAnalyticsLoading.Fragment;
}
